
// // // // // // // // // // // // // changes after header get from local


// // // // // // // // // // import React, { useState, useEffect, useRef } from "react";
// // // // // // // // // // import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle } from "lucide-react";
// // // // // // // // // // import LeadDetails from "./Leaddetails";
// // // // // // // // // // import TimelineComponent from "./Header";
// // // // // // // // // // import Reports from "./Reports";

// // // // // // // // // // const allColumns = [
// // // // // // // // // //   { key: "Sales_Agent", label: "Sales Agent" },
// // // // // // // // // //   { key: "Customer_Name", label: "Lead Name" },
// // // // // // // // // //   { key: "Move_Date", label: "Move Date" },
// // // // // // // // // //   { key: "Status", label: "Estimate Status" },
// // // // // // // // // //   { key: "OriginCity", label: "From Province" },
// // // // // // // // // //   { key: "DestinationCity", label: "To Province" },
// // // // // // // // // //   { key: "FollowUpDate", label: "Follow Up Date" },
// // // // // // // // // //   { key: "Move_Size", label: "Move Size" },
// // // // // // // // // //   { key: "Lead_Status", label: "Lead Status" },
// // // // // // // // // //   { key: "Move_Type", label: "Move Type" },
// // // // // // // // // //   { key: "Estimate_Amount", label: "Estimate Amount" },
// // // // // // // // // //   { key: "From_Postcode", label: "From Postcode" },
// // // // // // // // // //   { key: "To_Postcode", label: "To Postcode" },
// // // // // // // // // //   { key: "Received_Date_EST", label: "Received Date EST" },
// // // // // // // // // //   { key: "Banner", label: "Banner" },
// // // // // // // // // //   { key: "Lead_Priority", label: "Lead Priority" },
// // // // // // // // // //   { key: "Received_Time_IST", label: "Received Time IST" },
// // // // // // // // // // ];

// // // // // // // // // // const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
// // // // // // // // // //   const [showReports, setShowReports] = useState(false);
// // // // // // // // // //   const [data, setData] = useState([]);
// // // // // // // // // //   const [filteredData, setFilteredData] = useState([]);
// // // // // // // // // //   const [searchQuery, setSearchQuery] = useState("");
// // // // // // // // // //   const [loading, setLoading] = useState(true);
// // // // // // // // // //   const [error, setError] = useState(null);
// // // // // // // // // //   const [selectedBooking, setSelectedBooking] = useState(null);
// // // // // // // // // //   const [width, setWidth] = useState(350);
// // // // // // // // // //   const [showFilter, setShowFilter] = useState(false);
// // // // // // // // // //   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
// // // // // // // // // //   const [columnFilters, setColumnFilters] = useState({});
// // // // // // // // // //   const [selectedColumns, setSelectedColumns] = useState(
// // // // // // // // // //     allColumns.slice(0, 7).map((col) => col.key)
// // // // // // // // // //   );
// // // // // // // // // //   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
// // // // // // // // // //   const [isDefaultSort, setIsDefaultSort] = useState(false);
// // // // // // // // // //   const filterRef = useRef(null);
// // // // // // // // // //   const isResizing = useRef(false);
// // // // // // // // // //   const [userMap, setUserMap] = useState({});
// // // // // // // // // //   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
// // // // // // // // // //   const prevSelectedLeadId = useRef(null);
// // // // // // // // // //   const [allNotes, setAllNotes] = useState([]);

// // // // // // // // // //   const updateLeadData = (updatedBooking) => {
// // // // // // // // // //     setData((prevData) =>
// // // // // // // // // //       prevData.map((lead) =>
// // // // // // // // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // // // // // //           ? { ...lead, ...updatedBooking }
// // // // // // // // // //           : lead
// // // // // // // // // //       )
// // // // // // // // // //     );
// // // // // // // // // //     setFilteredData((prevFilteredData) =>
// // // // // // // // // //       prevFilteredData.map((lead) =>
// // // // // // // // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // // // // // //           ? { ...lead, ...updatedBooking }
// // // // // // // // // //           : lead
// // // // // // // // // //       )
// // // // // // // // // //     );
// // // // // // // // // //     if (
// // // // // // // // // //       selectedBooking &&
// // // // // // // // // //       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // // // // // //     ) {
// // // // // // // // // //       setSelectedBooking(updatedBooking);
// // // // // // // // // //     }
// // // // // // // // // //   };

// // // // // // // // // //   const refetchNotes = () => {
// // // // // // // // // //     fetchAllNotes();
// // // // // // // // // //   };

// // // // // // // // // //   const formatFollowUpDate = (date) => {
// // // // // // // // // //     if (!date) return "N/A";
// // // // // // // // // //     return date.replace("T", " ");
// // // // // // // // // //   };

// // // // // // // // // //   const handleDefaultSort = () => {
// // // // // // // // // //     setSearchQuery("");
// // // // // // // // // //     setColumnFilters({});
// // // // // // // // // //     setIsGlobalSearch(false);
// // // // // // // // // //     setIsDefaultSort(true);
// // // // // // // // // //     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
// // // // // // // // // //     fetchLeads();
// // // // // // // // // //   };

// // // // // // // // // //   const updateUserpreference = async (headers) => {
// // // // // // // // // //       try {
// // // // // // // // // //         const payload = { Userpreference: { Header: headers } };
// // // // // // // // // //         await fetch("https://salesjet-10097049716.development.catalystappsail.com/userdata", {
// // // // // // // // // //           method: "PUT",
// // // // // // // // // //           headers: {
// // // // // // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // // // // // //             "Content-Type": "application/json",
// // // // // // // // // //           },
// // // // // // // // // //           body: JSON.stringify(payload),
// // // // // // // // // //         });
// // // // // // // // // //       } catch (err) {
// // // // // // // // // //         console.error("Error updating preferences:", err);
// // // // // // // // // //       }
// // // // // // // // // //   };
  
// // // // // // // // // //   const loadPreferences = () => {
// // // // // // // // // //     try {
// // // // // // // // // //       const stored = localStorage.getItem("Userpreference");
// // // // // // // // // //       let headers;
// // // // // // // // // //       if (stored) {
// // // // // // // // // //         const parsed = JSON.parse(stored);
// // // // // // // // // //         headers = parsed.Headers || null;
// // // // // // // // // //       }
// // // // // // // // // //       if (!headers || !Array.isArray(headers) || headers.length === 0) {
// // // // // // // // // //         headers = allColumns.slice(0, 7).map((col) => col.label);
// // // // // // // // // //         const prefs = { Headers: headers };
// // // // // // // // // //         localStorage.setItem("Userpreference", JSON.stringify(prefs));
// // // // // // // // // //         updateUserpreference(headers);
// // // // // // // // // //       }
// // // // // // // // // //       // Map labels to keys
// // // // // // // // // //       const keys = headers
// // // // // // // // // //         .map((label) => {
// // // // // // // // // //           const col = allColumns.find((c) => c.label === label);
// // // // // // // // // //           return col ? col.key : null;
// // // // // // // // // //         })
// // // // // // // // // //         .filter(Boolean);
// // // // // // // // // //       setSelectedColumns(keys);
// // // // // // // // // //     } catch (err) {
// // // // // // // // // //       console.error(err);
// // // // // // // // // //       // Fallback to default
// // // // // // // // // //       const headers = allColumns.slice(0, 7).map((col) => col.label);
// // // // // // // // // //       const prefs = { Headers: headers };
// // // // // // // // // //       localStorage.setItem("Userpreference", JSON.stringify(prefs));
// // // // // // // // // //       updateUserpreference(headers);
// // // // // // // // // //       setSelectedColumns(allColumns.slice(0, 7).map((col) => col.key));
// // // // // // // // // //     }
// // // // // // // // // //   };

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     if (accessToken) {
// // // // // // // // // //       loadPreferences();
// // // // // // // // // //     }
// // // // // // // // // //   }, [accessToken]);

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     const fetchUserData = async () => {
// // // // // // // // // //       try {
// // // // // // // // // //         const response = await fetch(
// // // // // // // // // //           "https://salesjet-10097049716.development.catalystappsail.com/userdata",
// // // // // // // // // //           {
// // // // // // // // // //             method: "GET",
// // // // // // // // // //             headers: {
// // // // // // // // // //               Authorization: `Bearer ${accessToken}`,
// // // // // // // // // //               "Content-Type": "application/json",
// // // // // // // // // //             },
// // // // // // // // // //           }
// // // // // // // // // //         );
// // // // // // // // // //         if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // // // // // //         const result = await response.json();
// // // // // // // // // //         const userMapping = result.data.reduce((acc, user) => {
// // // // // // // // // //           acc[user.userId] = user.pseudoname;
// // // // // // // // // //           return acc;
// // // // // // // // // //         }, {});
// // // // // // // // // //         setUserMap(userMapping);
// // // // // // // // // //       } catch (err) {
// // // // // // // // // //         console.error("Error fetching user data:", err.message);
// // // // // // // // // //       }
// // // // // // // // // //     };
// // // // // // // // // //     fetchUserData();
// // // // // // // // // //   }, [accessToken]);

// // // // // // // // // //   const fetchLeads = async () => {
// // // // // // // // // //     try {
// // // // // // // // // //       setLoading(true);
// // // // // // // // // //       const response = await fetch(
// // // // // // // // // //         "https://salesjet-10097049716.development.catalystappsail.com/leadsdata",
// // // // // // // // // //         {
// // // // // // // // // //           method: "GET",
// // // // // // // // // //           headers: {
// // // // // // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // // // // // //             "Content-Type": "application/json",
// // // // // // // // // //           },
// // // // // // // // // //         }
// // // // // // // // // //       );
// // // // // // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // // // // // //       const result = await response.json();
// // // // // // // // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // // // // // // // //       setData(leads);
// // // // // // // // // //       setFilteredData(leads);
// // // // // // // // // //     } catch (err) {
// // // // // // // // // //       setError(err.message);
// // // // // // // // // //       console.error("Error fetching leads:", err.message);
// // // // // // // // // //     } finally {
// // // // // // // // // //       setLoading(false);
// // // // // // // // // //     }
// // // // // // // // // //   };

// // // // // // // // // //   const fetchAllNotes = async () => {
// // // // // // // // // //     try {
// // // // // // // // // //       const response = await fetch(
// // // // // // // // // //         "https://salesjet-10097049716.development.catalystappsail.com/allleadnotes",
// // // // // // // // // //         {
// // // // // // // // // //           method: "GET",
// // // // // // // // // //           headers: {
// // // // // // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // // // // // //             "Content-Type": "application/json",
// // // // // // // // // //           },
// // // // // // // // // //         }
// // // // // // // // // //       );
// // // // // // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // // // // // //       const result = await response.json();
// // // // // // // // // //       setAllNotes(Array.isArray(result.data) ? result.data : []);
// // // // // // // // // //     } catch (err) {
// // // // // // // // // //       console.error("Error fetching all lead notes:", err.message);
// // // // // // // // // //     }
// // // // // // // // // //   };

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     if (!isGlobalSearch) {
// // // // // // // // // //       fetchLeads();
// // // // // // // // // //       fetchAllNotes();
// // // // // // // // // //     }
// // // // // // // // // //   }, [accessToken, isGlobalSearch]);

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     handleDefaultSort();
// // // // // // // // // //   }, []);

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
// // // // // // // // // //       prevSelectedLeadId.current = selectedLeadId;
// // // // // // // // // //       setIsGlobalSearch(true);
// // // // // // // // // //       setColumnFilters({});
// // // // // // // // // //       handleGlobalSearch(selectedLeadId.toString());
// // // // // // // // // //     }
// // // // // // // // // //   }, [selectedLeadId]);

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     if (selectedLeadId && filteredData.length > 0) {
// // // // // // // // // //       const matchingLead = filteredData.find(
// // // // // // // // // //         (lead) =>
// // // // // // // // // //           lead.LeadACVLRecordID &&
// // // // // // // // // //           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
// // // // // // // // // //       );
// // // // // // // // // //       if (matchingLead) {
// // // // // // // // // //         setSelectedBooking(matchingLead);
// // // // // // // // // //         setWidth(700);
// // // // // // // // // //       } else {
// // // // // // // // // //         setSelectedBooking(null);
// // // // // // // // // //       }
// // // // // // // // // //     } else if (selectedLeadId && filteredData.length === 0) {
// // // // // // // // // //       setSelectedBooking(null);
// // // // // // // // // //     }
// // // // // // // // // //   }, [filteredData, selectedLeadId]);

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     if (isGlobalSearch) {
// // // // // // // // // //       return;
// // // // // // // // // //     }
// // // // // // // // // //     let filtered = [...data];
// // // // // // // // // //     if (searchQuery.trim()) {
// // // // // // // // // //       const normalizedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // // // // // //       filtered = filtered.filter((lead) =>
// // // // // // // // // //         Object.entries(lead).some(([key, value]) => {
// // // // // // // // // //           if (!value) return false;
// // // // // // // // // //           const normalizedValue = value
// // // // // // // // // //             .toString()
// // // // // // // // // //             .replace(/[^a-zA-Z0-9]/g, "")
// // // // // // // // // //             .toLowerCase();
// // // // // // // // // //           return normalizedValue.includes(normalizedQuery);
// // // // // // // // // //         })
// // // // // // // // // //       );
// // // // // // // // // //     }
// // // // // // // // // //     Object.keys(columnFilters).forEach((key) => {
// // // // // // // // // //       const rawFilter = columnFilters[key];
// // // // // // // // // //       if (rawFilter) {
// // // // // // // // // //         const trimmedRawFilter = rawFilter.trim();
// // // // // // // // // //         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // // // // // //         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
// // // // // // // // // //         if (isNAFilter) {
// // // // // // // // // //           filtered = filtered.filter((lead) => {
// // // // // // // // // //             const value = lead[key];
// // // // // // // // // //             return value === null || value === undefined || value === "" || value === "N/A";
// // // // // // // // // //           });
// // // // // // // // // //         } else if (normalizedFilter) {
// // // // // // // // // //           filtered = filtered.filter((lead) => {
// // // // // // // // // //             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // // // // // //             return value?.includes(normalizedFilter);
// // // // // // // // // //           });
// // // // // // // // // //         }
// // // // // // // // // //       }
// // // // // // // // // //     });
// // // // // // // // // //     setFilteredData(filtered);
// // // // // // // // // //   }, [data, searchQuery, columnFilters, isGlobalSearch]);

// // // // // // // // // //   const handleSearchChange = (query) => {
// // // // // // // // // //     setSearchQuery(query);
// // // // // // // // // //     setIsGlobalSearch(false);
// // // // // // // // // //     setColumnFilters({});
// // // // // // // // // //   };

// // // // // // // // // //   const handleGlobalSearch = async (query) => {
// // // // // // // // // //     setLoading(true);
// // // // // // // // // //     setIsDefaultSort(false);
// // // // // // // // // //     setIsGlobalSearch(true);
// // // // // // // // // //     try {
// // // // // // // // // //       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // // // // // //       const response = await fetch(
// // // // // // // // // //         "https://salesjet-10097049716.development.catalystappsail.com/globalsearch",
// // // // // // // // // //         {
// // // // // // // // // //           method: "POST",
// // // // // // // // // //           headers: {
// // // // // // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // // // // // //             "Content-Type": "application/json",
// // // // // // // // // //           },
// // // // // // // // // //           body: JSON.stringify({ query: normalizedQuery }),
// // // // // // // // // //         }
// // // // // // // // // //       );
// // // // // // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // // // // // //       const result = await response.json();
// // // // // // // // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // // // // // // // //       setFilteredData(leads);
// // // // // // // // // //       setSearchQuery(query);
// // // // // // // // // //       fetchAllNotes();
// // // // // // // // // //     } catch (err) {
// // // // // // // // // //       console.error("Global search error:", err.message);
// // // // // // // // // //       setError(err.message);
// // // // // // // // // //     } finally {
// // // // // // // // // //       setLoading(false);
// // // // // // // // // //     }
// // // // // // // // // //   };

// // // // // // // // // //   const handleSort = (key) => {
// // // // // // // // // //     setIsDefaultSort(false);
// // // // // // // // // //     setSortConfig((prev) =>
// // // // // // // // // //       prev.key === key
// // // // // // // // // //         ? {
// // // // // // // // // //             key,
// // // // // // // // // //             direction: prev.direction === "ascending" ? "descending" : "ascending",
// // // // // // // // // //           }
// // // // // // // // // //         : { key, direction: "ascending" }
// // // // // // // // // //     );
// // // // // // // // // //   };

// // // // // // // // // //   const handleColumnChange = (event) => {
// // // // // // // // // //     const value = event.target.value;
// // // // // // // // // //     setSelectedColumns((prev) => {
// // // // // // // // // //       let newSelected;
// // // // // // // // // //       if (prev.includes(value)) {
// // // // // // // // // //         newSelected = prev.filter((col) => col !== value);
// // // // // // // // // //       } else {
// // // // // // // // // //         newSelected = prev.length < 7 ? [...prev, value] : prev;
// // // // // // // // // //       }
// // // // // // // // // //       // Update localStorage and backend
// // // // // // // // // //       const labels = newSelected.map((key) => {
// // // // // // // // // //         const col = allColumns.find((c) => c.key === key);
// // // // // // // // // //         return col ? col.label : "";
// // // // // // // // // //       });
// // // // // // // // // //       const prefs = { Headers: labels };
// // // // // // // // // //       localStorage.setItem("Userpreference", JSON.stringify(prefs));
// // // // // // // // // //       updateUserpreference(labels);
// // // // // // // // // //       return newSelected;
// // // // // // // // // //     });
// // // // // // // // // //   };

// // // // // // // // // //   const sortedData = React.useMemo(() => {
// // // // // // // // // //     let sortableData = [...filteredData];
// // // // // // // // // //     if (isDefaultSort) {
// // // // // // // // // //       // Get current date in EST (America/Toronto)
// // // // // // // // // //       const now = new Date();
// // // // // // // // // //       const todayStr = now.toLocaleString('en-CA', { 
// // // // // // // // // //         timeZone: 'America/Toronto', 
// // // // // // // // // //         year: 'numeric', 
// // // // // // // // // //         month: '2-digit', 
// // // // // // // // // //         day: '2-digit' 
// // // // // // // // // //       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

// // // // // // // // // //       // Custom sorting logic
// // // // // // // // // //       sortableData.sort((a, b) => {
// // // // // // // // // //         const isUnassignedA = a.Status === null || a.Status === undefined;
// // // // // // // // // //         const isUnassignedB = b.Status === null || b.Status === undefined;
// // // // // // // // // //         const timeA = a.Received_Date_EST;
// // // // // // // // // //         const timeB = b.Received_Date_EST;
// // // // // // // // // //         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
// // // // // // // // // //         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

// // // // // // // // // //         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
// // // // // // // // // //         if (isUnassignedA && timeA === todayStr && (!isUnassignedB || timeB !== todayStr)) {
// // // // // // // // // //           return -1;
// // // // // // // // // //         }
// // // // // // // // // //         if (isUnassignedB && timeB === todayStr && (!isUnassignedA || timeA !== todayStr)) {
// // // // // // // // // //           return 1;
// // // // // // // // // //         }

// // // // // // // // // //         // Step 2: Leads with FollowUpDate date as today (EST)
// // // // // // // // // //         if (followUpA === todayStr && followUpB !== todayStr) return -1;
// // // // // // // // // //         if (followUpB === todayStr && followUpA !== todayStr) return 1;

// // // // // // // // // //         // Step 3: Sort by LeadACVLRecordID descending as fallback
// // // // // // // // // //         const idA = Number(a.LeadACVLRecordID || 0);
// // // // // // // // // //         const idB = Number(b.LeadACVLRecordID || 0);
// // // // // // // // // //         return idB - idA;
// // // // // // // // // //       });
// // // // // // // // // //     } else if (sortConfig.key) {
// // // // // // // // // //       sortableData.sort((a, b) => {
// // // // // // // // // //         let aVal = a[sortConfig.key];
// // // // // // // // // //         let bVal = b[sortConfig.key];
// // // // // // // // // //         // Handle null or undefined values
// // // // // // // // // //         if (aVal === undefined || aVal === null) return 1;
// // // // // // // // // //         if (bVal === undefined || bVal === null) return -1;
// // // // // // // // // //         // Handle LeadACVLRecordID specifically as a number
// // // // // // // // // //         if (sortConfig.key === "LeadACVLRecordID") {
// // // // // // // // // //           aVal = Number(aVal);
// // // // // // // // // //           bVal = Number(bVal);
// // // // // // // // // //           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // // // // // // // //         }
// // // // // // // // // //         // Handle date fields
// // // // // // // // // //         const isDateField = [
// // // // // // // // // //           "Move_Date",
// // // // // // // // // //           "Received_Date_EST",
// // // // // // // // // //           "Received_Time_IST",
// // // // // // // // // //           "FollowUpDate",
// // // // // // // // // //         ].includes(sortConfig.key);
// // // // // // // // // //         if (isDateField) {
// // // // // // // // // //           const dateA = new Date(aVal);
// // // // // // // // // //           const dateB = new Date(bVal);
// // // // // // // // // //           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
// // // // // // // // // //         }
// // // // // // // // // //         // Handle string fields
// // // // // // // // // //         if (typeof aVal === "string" && typeof bVal === "string") {
// // // // // // // // // //           return sortConfig.direction === "ascending"
// // // // // // // // // //             ? aVal.localeCompare(bVal)
// // // // // // // // // //             : bVal.localeCompare(bVal);
// // // // // // // // // //         }
// // // // // // // // // //         // Handle numeric fields
// // // // // // // // // //         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // // // // // // // //       });
// // // // // // // // // //     }
// // // // // // // // // //     return sortableData;
// // // // // // // // // //   }, [filteredData, sortConfig, isDefaultSort]);

// // // // // // // // // //   const notesByLead = React.useMemo(() => {
// // // // // // // // // //     const map = {};
// // // // // // // // // //     allNotes.forEach((note) => {
// // // // // // // // // //       const id = note.LeadACVLRecordID;
// // // // // // // // // //       if (id) {
// // // // // // // // // //         if (!map[id]) {
// // // // // // // // // //           map[id] = { notes: [], latestByCategory: {} };
// // // // // // // // // //         }
// // // // // // // // // //         map[id].notes.push(note);
// // // // // // // // // //       }
// // // // // // // // // //     });
// // // // // // // // // //     Object.keys(map).forEach((leadId) => {
// // // // // // // // // //       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
// // // // // // // // // //       const categoryMap = {};
// // // // // // // // // //       map[leadId].notes.forEach((note) => {
// // // // // // // // // //         const category = note.Category?.toLowerCase() || "";
// // // // // // // // // //         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
// // // // // // // // // //           categoryMap[category] = note;
// // // // // // // // // //         }
// // // // // // // // // //       });
// // // // // // // // // //       map[leadId].latestByCategory = categoryMap;
// // // // // // // // // //     });
// // // // // // // // // //     return map;
// // // // // // // // // //   }, [allNotes]);

// // // // // // // // // //   const startResizing = (e) => {
// // // // // // // // // //     isResizing.current = true;
// // // // // // // // // //     document.addEventListener("mousemove", resize);
// // // // // // // // // //     document.addEventListener("mouseup", stopResizing);
// // // // // // // // // //   };

// // // // // // // // // //   const resize = (e) => {
// // // // // // // // // //     if (!isResizing.current) return;
// // // // // // // // // //     const minWidth = 500;
// // // // // // // // // //     const maxWidth = window.innerWidth * 0.7;
// // // // // // // // // //     let newWidth = window.innerWidth - e.clientX;
// // // // // // // // // //     if (newWidth >= minWidth && newWidth <= maxWidth) {
// // // // // // // // // //       setWidth(newWidth);
// // // // // // // // // //     }
// // // // // // // // // //   };

// // // // // // // // // //   const stopResizing = () => {
// // // // // // // // // //     isResizing.current = false;
// // // // // // // // // //     document.removeEventListener("mousemove", resize);
// // // // // // // // // //     document.removeEventListener("mouseup", stopResizing);
// // // // // // // // // //   };

// // // // // // // // // //   useEffect(() => {
// // // // // // // // // //     const handleClickOutside = (event) => {
// // // // // // // // // //       if (filterRef.current && !filterRef.current.contains(event.target)) {
// // // // // // // // // //         setShowFilter(false);
// // // // // // // // // //       }
// // // // // // // // // //     };
// // // // // // // // // //     document.addEventListener("mousedown", handleClickOutside);
// // // // // // // // // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // // // // // // // // //   }, []);

// // // // // // // // // //   const today = new Date().toISOString().split('T')[0];

// // // // // // // // // //   return (
// // // // // // // // // //     <div>
// // // // // // // // // //       <>
// // // // // // // // // //         <TimelineComponent
// // // // // // // // // //           userDetails={userDetails}
// // // // // // // // // //           accessToken={accessToken}
// // // // // // // // // //           onSearchChange={handleSearchChange}
// // // // // // // // // //           onGlobalSearch={handleGlobalSearch}
// // // // // // // // // //           connectionStatus={connectionStatus}
// // // // // // // // // //           onShowReports={() => setShowReports(true)}
// // // // // // // // // //           onListView={() => setShowReports(false)}
// // // // // // // // // //         />
// // // // // // // // // //       </>
// // // // // // // // // //       {showReports && (
// // // // // // // // // //         <>
// // // // // // // // // //           {/* <button onClick={() => setShowReports(false)}>✖ Close Report</button> */}
// // // // // // // // // //           <Reports />
// // // // // // // // // //         </>
// // // // // // // // // //       )}
// // // // // // // // // //       {!showReports && (
// // // // // // // // // //         <div className="table-container">
// // // // // // // // // //           <div
// // // // // // // // // //             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
// // // // // // // // // //             style={{ flex: selectedBooking ? "1" : "2" }}
// // // // // // // // // //           >
// // // // // // // // // //             <div>
// // // // // // // // // //               <div className="bookings-header-my">
// // // // // // // // // //                 <span
// // // // // // // // // //                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
// // // // // // // // // //                   onClick={() => handleSort("LeadACVLRecordID")}
// // // // // // // // // //                   style={{ cursor: "pointer" }}
// // // // // // // // // //                 >
// // // // // // // // // //                   ACVL LeadID
// // // // // // // // // //                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
// // // // // // // // // //                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // // // // // // // //                 </span>
// // // // // // // // // //                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // // // // // //                   (colKey) => {
// // // // // // // // // //                     const column = allColumns.find((c) => c.key === colKey);
// // // // // // // // // //                     const isSorted = sortConfig.key === colKey;
// // // // // // // // // //                     return column ? (
// // // // // // // // // //                       <span
// // // // // // // // // //                         key={colKey}
// // // // // // // // // //                         className="sortable-header"
// // // // // // // // // //                         onClick={() => handleSort(colKey)}
// // // // // // // // // //                         style={{ cursor: "pointer" }}
// // // // // // // // // //                       >
// // // // // // // // // //                         {column.label}
// // // // // // // // // //                         {!isDefaultSort && isSorted &&
// // // // // // // // // //                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // // // // // // // //                       </span>
// // // // // // // // // //                     ) : null;
// // // // // // // // // //                   }
// // // // // // // // // //                 )}
// // // // // // // // // //                 <span2>
// // // // // // // // // //                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
// // // // // // // // // //                     <div>
// // // // // // // // // //                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
// // // // // // // // // //                     </div>
// // // // // // // // // //                     <div>
// // // // // // // // // //                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
// // // // // // // // // //                     </div>
// // // // // // // // // //                     <div>
// // // // // // // // // //                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
// // // // // // // // // //                     </div>
// // // // // // // // // //                     <div>
// // // // // // // // // //                       <Search
// // // // // // // // // //                         className="filter-icon"
// // // // // // // // // //                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
// // // // // // // // // //                         title="Advanced column search"
// // // // // // // // // //                       />
// // // // // // // // // //                     </div>
// // // // // // // // // //                   </div>
// // // // // // // // // //                 </span2>
// // // // // // // // // //                 {showFilter && (
// // // // // // // // // //                   <div className="filter-dropdown" ref={filterRef}>
// // // // // // // // // //                     {allColumns.map((col) => (
// // // // // // // // // //                       <label key={col.key}>
// // // // // // // // // //                         <input
// // // // // // // // // //                           type="checkbox"
// // // // // // // // // //                           value={col.key}
// // // // // // // // // //                           checked={selectedColumns.includes(col.key)}
// // // // // // // // // //                           onChange={handleColumnChange}
// // // // // // // // // //                           disabled={
// // // // // // // // // //                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
// // // // // // // // // //                           }
// // // // // // // // // //                         />
// // // // // // // // // //                         {col.label}
// // // // // // // // // //                       </label>
// // // // // // // // // //                     ))}
// // // // // // // // // //                   </div>
// // // // // // // // // //                 )}
// // // // // // // // // //               </div>
// // // // // // // // // //               {showAdvancedFilter && (
// // // // // // // // // //                 <div className="column-filter-row">
// // // // // // // // // //                   <span className="filter-input">
// // // // // // // // // //                     <input
// // // // // // // // // //                       placeholder="Lead ID"
// // // // // // // // // //                       value={columnFilters["LeadACVLRecordID"] || ""}
// // // // // // // // // //                       onChange={(e) =>
// // // // // // // // // //                         setColumnFilters({
// // // // // // // // // //                           ...columnFilters,
// // // // // // // // // //                           LeadACVLRecordID: e.target.value,
// // // // // // // // // //                         })
// // // // // // // // // //                       }
// // // // // // // // // //                     />
// // // // // // // // // //                   </span>
// // // // // // // // // //                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // // // // // //                     (colKey) => (
// // // // // // // // // //                       <span key={colKey} className="filter-input">
// // // // // // // // // //                         <input
// // // // // // // // // //                           placeholder={
// // // // // // // // // //                             allColumns.find((col) => col.key === colKey)?.label || colKey
// // // // // // // // // //                           }
// // // // // // // // // //                           value={columnFilters[colKey] || ""}
// // // // // // // // // //                           onChange={(e) =>
// // // // // // // // // //                             setColumnFilters({
// // // // // // // // // //                               ...columnFilters,
// // // // // // // // // //                               [colKey]: e.target.value,
// // // // // // // // // //                             })
// // // // // // // // // //                           }
// // // // // // // // // //                         />
// // // // // // // // // //                       </span>
// // // // // // // // // //                     )
// // // // // // // // // //                   )}
// // // // // // // // // //                   <span className="filter-icons-space" />
// // // // // // // // // //                 </div>
// // // // // // // // // //               )}
// // // // // // // // // //               {loading && <p>Loading...</p>}
// // // // // // // // // //               {error && <p className="error">{error}</p>}
// // // // // // // // // //               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
// // // // // // // // // //               {!loading &&
// // // // // // // // // //                 !error &&
// // // // // // // // // //                 sortedData.map((item, index) => {
// // // // // // // // // //                   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// // // // // // // // // //                   const categories = leadNotesData.latestByCategory;
// // // // // // // // // //                   let flags = [];
// // // // // // // // // //                   const now = new Date();
// // // // // // // // // //                   const todayStr = now.toLocaleString('en-CA', { 
// // // // // // // // // //                     timeZone: 'America/Toronto', 
// // // // // // // // // //                     year: 'numeric', 
// // // // // // // // // //                     month: '2-digit', 
// // // // // // // // // //                     day: '2-digit' 
// // // // // // // // // //                   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
// // // // // // // // // //                   const isUnassignedToday =
// // // // // // // // // //                     (item.Status === null || item.Status === undefined) &&
// // // // // // // // // //                     item.Received_Date_EST &&
// // // // // // // // // //                     item.Received_Date_EST.split(' ')[0] === todayStr;
// // // // // // // // // //                   const isUnassignedall =
// // // // // // // // // //                     (item.Status === null || item.Status === undefined) &&
// // // // // // // // // //                     item.Received_Date_EST &&
// // // // // // // // // //                     item.Received_Date_EST.split(' ')[0] !== todayStr;
// // // // // // // // // //                   let isTodayFollowUp = false;

// // // // // // // // // //                   // Collect and process follow-up dates
// // // // // // // // // //                   const followUpDates = [];
                  
// // // // // // // // // //                   // Add follow-up date from notes (next follow-up category)
// // // // // // // // // //                   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
// // // // // // // // // //                     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
// // // // // // // // // //                     if (noteDate) {
// // // // // // // // // //                       followUpDates.push(noteDate);
// // // // // // // // // //                     }
// // // // // // // // // //                   }

// // // // // // // // // //                   // Add follow-up date from item.FollowUpDate
// // // // // // // // // //                   if (item.FollowUpDate) {
// // // // // // // // // //                     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
// // // // // // // // // //                     if (itemDate && !followUpDates.includes(itemDate)) {
// // // // // // // // // //                       followUpDates.push(itemDate);
// // // // // // // // // //                     }
// // // // // // // // // //                   }

// // // // // // // // // //                   // Select the most relevant follow-up date
// // // // // // // // // //                   let selectedFollowUpDate = null;
// // // // // // // // // //                   if (followUpDates.length > 0) {
// // // // // // // // // //                     // Prioritize: today's date, then past date, then future date
// // // // // // // // // //                     const today = new Date(todayStr);
// // // // // // // // // //                     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
// // // // // // // // // //                       const followUpDate = new Date(dateStr);
// // // // // // // // // //                       if (!selected) return dateStr;
// // // // // // // // // //                       const selectedDate = new Date(selected);
// // // // // // // // // //                       if (dateStr === todayStr) return dateStr; // Prioritize today's date
// // // // // // // // // //                       if (selected === todayStr) return selected;
// // // // // // // // // //                       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
// // // // // // // // // //                       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
// // // // // // // // // //                       return selected; // Keep first date if no priority
// // // // // // // // // //                     }, null);

// // // // // // // // // //                     if (selectedFollowUpDate) {
// // // // // // // // // //                       const followUpDate = new Date(selectedFollowUpDate);
// // // // // // // // // //                       isTodayFollowUp = selectedFollowUpDate === todayStr;
// // // // // // // // // //                       let color;
// // // // // // // // // //                       if (followUpDate < today && !isTodayFollowUp) {
// // // // // // // // // //                         color = "red"; // Past date
// // // // // // // // // //                       } else if (isTodayFollowUp) {
// // // // // // // // // //                         color = "green"; // Today
// // // // // // // // // //                       } else {
// // // // // // // // // //                         color = "gray"; // Future date
// // // // // // // // // //                       }
// // // // // // // // // //                       flags.push({ 
// // // // // // // // // //                         icon: Clock, 
// // // // // // // // // //                         color, 
// // // // // // // // // //                         title: `Follow-Up: ${selectedFollowUpDate}` 
// // // // // // // // // //                       });
// // // // // // // // // //                     }
// // // // // // // // // //                   }

// // // // // // // // // //                   // Process other categories
// // // // // // // // // //                   Object.values(categories).forEach((note) => {
// // // // // // // // // //                     if (note && note.Category?.toLowerCase() !== "next follow-up") {
// // // // // // // // // //                       const category = note.Category?.toLowerCase() || "";
// // // // // // // // // //                       const categoryDetails = note.Category_Details?.toLowerCase() || "";
// // // // // // // // // //                       if (category === "connection status") {
// // // // // // // // // //                         if (categoryDetails === "connected") {
// // // // // // // // // //                           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
// // // // // // // // // //                         } else if (categoryDetails === "not connected") {
// // // // // // // // // //                           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
// // // // // // // // // //                         }
// // // // // // // // // //                       } else if (category === "prospective") {
// // // // // // // // // //                         if (categoryDetails === "hot") {
// // // // // // // // // //                           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
// // // // // // // // // //                         } else if (categoryDetails === "warm") {
// // // // // // // // // //                           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
// // // // // // // // // //                         } else if (categoryDetails === "cold") {
// // // // // // // // // //                           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
// // // // // // // // // //                         }
// // // // // // // // // //                       }
// // // // // // // // // //                     }
// // // // // // // // // //                   });

// // // // // // // // // //                   // Process Lead_Priority for left side icon
// // // // // // // // // //                   let priorityFlag = null;
// // // // // // // // // //                   if (item.Lead_Priority) {
// // // // // // // // // //                     const priority = item.Lead_Priority.toString().toLowerCase().trim();
// // // // // // // // // //                     let color, title;
// // // // // // // // // //                     if (priority === "high") {
// // // // // // // // // //                       color = "red";
// // // // // // // // // //                       title = "High";
// // // // // // // // // //                     } else if (priority === "medium") {
// // // // // // // // // //                       color = "purple";
// // // // // // // // // //                       title = "Medium";
// // // // // // // // // //                     } else if (priority === "low") {
// // // // // // // // // //                       color = "green";
// // // // // // // // // //                       title = "Low";
// // // // // // // // // //                     }
// // // // // // // // // //                     if (color && title) {
// // // // // // // // // //                       priorityFlag = { icon: Circle, color, title };
// // // // // // // // // //                     }
// // // // // // // // // //                   }

// // // // // // // // // //                   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
// // // // // // // // // //                   const orderedFlags = new Array(5).fill(null);
// // // // // // // // // //                   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
// // // // // // // // // //                     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
// // // // // // // // // //                   }
// // // // // // // // // //                   if (item.Lead_Source_Status?.toLowerCase() === "return") {
// // // // // // // // // //                     if (item.Return_Outcome?.toLowerCase() === "approved") {
// // // // // // // // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
// // // // // // // // // //                     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
// // // // // // // // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
// // // // // // // // // //                     } else {
// // // // // // // // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
// // // // // // // // // //                     }
// // // // // // // // // //                   }
// // // // // // // // // //                   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
// // // // // // // // // //                   if (prospectiveFlag) {
// // // // // // // // // //                     orderedFlags[2] = prospectiveFlag;
// // // // // // // // // //                   }
// // // // // // // // // //                   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
// // // // // // // // // //                   if (connectionFlag) {
// // // // // // // // // //                     orderedFlags[3] = connectionFlag;
// // // // // // // // // //                   }
// // // // // // // // // //                   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
// // // // // // // // // //                   if (followUpFlag) {
// // // // // // // // // //                     orderedFlags[4] = followUpFlag;
// // // // // // // // // //                   }

// // // // // // // // // //                   return (
// // // // // // // // // //                     <div
// // // // // // // // // //                       key={index}
// // // // // // // // // //                       className={`booking-item-my ${
// // // // // // // // // //                         selectedBooking === item ? "active-booking" : ""
// // // // // // // // // //                       } ${
// // // // // // // // // //                         item.Duplicate_Lead_Details &&
// // // // // // // // // //                         Object.keys(item.Duplicate_Lead_Details).length > 0
// // // // // // // // // //                           ? "duplicate-item"
// // // // // // // // // //                           : ""
// // // // // // // // // //                       } ${
// // // // // // // // // //                         item.Lead_Source_Status?.toLowerCase() === "return"
// // // // // // // // // //                           ? "returned-item"
// // // // // // // // // //                           : ""
// // // // // // // // // //                       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
// // // // // // // // // //                       onClick={() => {
// // // // // // // // // //                         if (!selectedBooking) setWidth(700);
// // // // // // // // // //                         setSelectedBooking(item);
// // // // // // // // // //                       }}
// // // // // // // // // //                       style={{
// // // // // // // // // //                         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
// // // // // // // // // //                         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
// // // // // // // // // //                         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
// // // // // // // // // //                         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
// // // // // // // // // //                       }}
// // // // // // // // // //                     >
// // // // // // // // // //                       <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
// // // // // // // // // //                         {priorityFlag && (
// // // // // // // // // //                           <>
// // // // // // // // // //                             <priorityFlag.icon
// // // // // // // // // //                               className="icon"
// // // // // // // // // //                               style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
// // // // // // // // // //                               fill={priorityFlag.color}
// // // // // // // // // //                               title={priorityFlag.title}
// // // // // // // // // //                             />
// // // // // // // // // //                             <div className="custom-tooltip1">
// // // // // // // // // //                               {priorityFlag.title}
// // // // // // // // // //                             </div>
// // // // // // // // // //                           </>
// // // // // // // // // //                         )}
// // // // // // // // // //                       </div>
// // // // // // // // // //                       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
// // // // // // // // // //                       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // // // // // //                         (colKey) => (
// // // // // // // // // //                           <span1 key={colKey}>
// // // // // // // // // //                             {colKey === "AssignedUserID"
// // // // // // // // // //                               ? userMap[item.AssignedUserID] || "N/A"
// // // // // // // // // //                               : colKey === "FollowUpDate"
// // // // // // // // // //                               ? formatFollowUpDate(item[colKey])
// // // // // // // // // //                               : item[colKey] || "N/A"}
// // // // // // // // // //                           </span1>
// // // // // // // // // //                         )
// // // // // // // // // //                       )}
// // // // // // // // // //                       <span2 style={{
// // // // // // // // // //                         display: "flex",
// // // // // // // // // //                         gap: "8px",
// // // // // // // // // //                         alignItems: "center",
// // // // // // // // // //                         justifyContent: "flex-end",
// // // // // // // // // //                         width: "120px",
// // // // // // // // // //                       }}>
// // // // // // // // // //                         {orderedFlags.map((flag, idx) => (
// // // // // // // // // //                           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
// // // // // // // // // //                             {flag && (
// // // // // // // // // //                               <>
// // // // // // // // // //                                 <flag.icon
// // // // // // // // // //                                   className="icon"
// // // // // // // // // //                                   style={{ color: flag.color, width: "16px", height: "16px" }}
// // // // // // // // // //                                   title={flag.title}
// // // // // // // // // //                                 />
// // // // // // // // // //                                 <div className="custom-tooltip">
// // // // // // // // // //                                   {flag.title}
// // // // // // // // // //                                 </div>
// // // // // // // // // //                               </>
// // // // // // // // // //                             )}
// // // // // // // // // //                           </div>
// // // // // // // // // //                         ))}
// // // // // // // // // //                       </span2>
// // // // // // // // // //                     </div>
// // // // // // // // // //                   );
// // // // // // // // // //                 })}
// // // // // // // // // //             </div>
// // // // // // // // // //           </div>
// // // // // // // // // //           {selectedBooking && (
// // // // // // // // // //             <div className="lead-details-container" style={{ width: `${width}px` }}>
// // // // // // // // // //               <div className="resize-handle" onMouseDown={startResizing}></div>
// // // // // // // // // //               <LeadDetails
// // // // // // // // // //                 key={selectedBooking.LeadACVLRecordID}
// // // // // // // // // //                 booking={selectedBooking}
// // // // // // // // // //                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
// // // // // // // // // //                 onClose={() => setSelectedBooking(null)}
// // // // // // // // // //                 userDetails={userDetails}
// // // // // // // // // //                 accessToken={accessToken}
// // // // // // // // // //                 userMap={userMap}
// // // // // // // // // //                 updateLeadData={updateLeadData}
// // // // // // // // // //                 refetchNotes={refetchNotes}
// // // // // // // // // //               />
// // // // // // // // // //             </div>
// // // // // // // // // //           )}
// // // // // // // // // //         </div>
// // // // // // // // // //       )}
// // // // // // // // // //     </div>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // export default Homepage;

// // // // // // // // // // // // after the dailpad changes 


// // // // // // import React, { useState, useEffect, useRef } from "react";
// // // // // // import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle } from "lucide-react";
// // // // // // import LeadDetails from "./Leaddetails";
// // // // // // import TimelineComponent from "./Header";
// // // // // // import Reports from "./Reports";
// // // // // // import Dialpad from "./SmsEmail/Dialpad";

// // // // // // const allColumns = [
// // // // // //   { key: "Sales_Agent", label: "Sales Agent" },
// // // // // //   { key: "Customer_Name", label: "Lead Name" },
// // // // // //   { key: "Move_Date", label: "Move Date" },
// // // // // //   { key: "Status", label: "Estimate Status" },
// // // // // //   { key: "OriginCity", label: "From Province" },
// // // // // //   { key: "DestinationCity", label: "To Province" },
// // // // // //   { key: "FollowUpDate", label: "Follow Up Date" },
// // // // // //   { key: "Move_Size", label: "Move Size" },
// // // // // //   { key: "Lead_Status", label: "Lead Status" },
// // // // // //   { key: "Move_Type", label: "Move Type" },
// // // // // //   { key: "Estimate_Amount", label: "Estimate Amount" },
// // // // // //   { key: "From_Postcode", label: "From Postcode" },
// // // // // //   { key: "To_Postcode", label: "To Postcode" },
// // // // // //   { key: "Received_Date_EST", label: "Received Date EST" },
// // // // // //   { key: "Banner", label: "Banner" },
// // // // // //   { key: "Lead_Priority", label: "Lead Priority" },
// // // // // //   { key: "Received_Time_IST", label: "Received Time IST" },
// // // // // // ];

// // // // // // const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
// // // // // //   const [showReports, setShowReports] = useState(false);
// // // // // //   const [data, setData] = useState([]);
// // // // // //   const [filteredData, setFilteredData] = useState([]);
// // // // // //   const [searchQuery, setSearchQuery] = useState("");
// // // // // //   const [loading, setLoading] = useState(true);
// // // // // //   const [error, setError] = useState(null);
// // // // // //   const [selectedBooking, setSelectedBooking] = useState(null);
// // // // // //   const [width, setWidth] = useState(350);
// // // // // //   const [showFilter, setShowFilter] = useState(false);
// // // // // //   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
// // // // // //   const [columnFilters, setColumnFilters] = useState({});
// // // // // //   const [selectedColumns, setSelectedColumns] = useState(
// // // // // //     allColumns.slice(0, 7).map((col) => col.key)
// // // // // //   );
// // // // // //   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
// // // // // //   const [isDefaultSort, setIsDefaultSort] = useState(false);
// // // // // //   const filterRef = useRef(null);
// // // // // //   const isResizing = useRef(false);
// // // // // //   const [userMap, setUserMap] = useState({});
// // // // // //   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
// // // // // //   const prevSelectedLeadId = useRef(null);
// // // // // //   const [allNotes, setAllNotes] = useState([]);

// // // // // //   const [telnyxClient, setTelnyxClient] = useState(null);
// // // // // //   const [telnyxConnected, setTelnyxConnected] = useState(false);
// // // // // //   const [currentCall, setCurrentCall] = useState(null);
// // // // // //   const telnyxLogRef = useRef(null);

// // // // // //   const [showDialpad, setShowDialpad] = useState(false);
// // // // // //   const [currentPhoneNumber, setCurrentPhoneNumber] = useState('');
// // // // // //   const [dialpadPosition, setDialpadPosition] = useState({ x: window.innerWidth / 2 - 150, y: window.innerHeight / 2 - 200 });
// // // // // //   const [isDragging, setIsDragging] = useState(false);
// // // // // //   const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
// // // // // //   const dialpadRef = useRef(null);

// // // // // //   const updateLeadData = (updatedBooking) => {
// // // // // //     setData((prevData) =>
// // // // // //       prevData.map((lead) =>
// // // // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // //           ? { ...lead, ...updatedBooking }
// // // // // //           : lead
// // // // // //       )
// // // // // //     );
// // // // // //     setFilteredData((prevFilteredData) =>
// // // // // //       prevFilteredData.map((lead) =>
// // // // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // //           ? { ...lead, ...updatedBooking }
// // // // // //           : lead
// // // // // //       )
// // // // // //     );
// // // // // //     if (
// // // // // //       selectedBooking &&
// // // // // //       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // //     ) {
// // // // // //       setSelectedBooking(updatedBooking);
// // // // // //     }
// // // // // //   };

// // // // // //   const refetchNotes = () => {
// // // // // //     fetchAllNotes();
// // // // // //   };

// // // // // //   const formatFollowUpDate = (date) => {
// // // // // //     if (!date) return "N/A";
// // // // // //     return date.replace("T", " ");
// // // // // //   };

// // // // // //   const handleDefaultSort = () => {
// // // // // //     setSearchQuery("");
// // // // // //     setColumnFilters({});
// // // // // //     setIsGlobalSearch(false);
// // // // // //     setIsDefaultSort(true);
// // // // // //     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
// // // // // //     fetchLeads();
// // // // // //   };

// // // // // //   const updateUserpreference = async (headers) => {
// // // // // //       try {
// // // // // //         const payload = { Userpreference: { Header: headers } };
// // // // // //         await fetch("https://salesjet-10097049716.development.catalystappsail.com/userdata", {
// // // // // //           method: "PUT",
// // // // // //           headers: {
// // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // //             "Content-Type": "application/json",
// // // // // //           },
// // // // // //           body: JSON.stringify(payload),
// // // // // //         });
// // // // // //       } catch (err) {
// // // // // //         console.error("Error updating preferences:", err);
// // // // // //       }
// // // // // //   };
  
// // // // // //   const loadPreferences = () => {
// // // // // //     try {
// // // // // //       const stored = localStorage.getItem("Userpreference");
// // // // // //       let headers;
// // // // // //       if (stored) {
// // // // // //         const parsed = JSON.parse(stored);
// // // // // //         headers = parsed.Headers || null;
// // // // // //       }
// // // // // //       if (!headers || !Array.isArray(headers) || headers.length === 0) {
// // // // // //         headers = allColumns.slice(0, 7).map((col) => col.label);
// // // // // //         const prefs = { Headers: headers };
// // // // // //         localStorage.setItem("Userpreference", JSON.stringify(prefs));
// // // // // //         updateUserpreference(headers);
// // // // // //       }
// // // // // //       const keys = headers
// // // // // //         .map((label) => {
// // // // // //           const col = allColumns.find((c) => c.label === label);
// // // // // //           return col ? col.key : null;
// // // // // //         })
// // // // // //         .filter(Boolean);
// // // // // //       setSelectedColumns(keys);
// // // // // //     } catch (err) {
// // // // // //       console.error(err);
// // // // // //       const headers = allColumns.slice(0, 7).map((col) => col.label);
// // // // // //       const prefs = { Headers: headers };
// // // // // //       localStorage.setItem("Userpreference", JSON.stringify(prefs));
// // // // // //       updateUserpreference(headers);
// // // // // //       setSelectedColumns(allColumns.slice(0, 7).map((col) => col.key));
// // // // // //     }
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     if (accessToken) {
// // // // // //       loadPreferences();
// // // // // //     }
// // // // // //   }, [accessToken]);

// // // // // //   useEffect(() => {
// // // // // //     const fetchUserData = async () => {
// // // // // //       try {
// // // // // //         const response = await fetch(
// // // // // //           "https://salesjet-10097049716.development.catalystappsail.com/userdata",
// // // // // //           {
// // // // // //             method: "GET",
// // // // // //             headers: {
// // // // // //               Authorization: `Bearer ${accessToken}`,
// // // // // //               "Content-Type": "application/json",
// // // // // //             },
// // // // // //           }
// // // // // //         );
// // // // // //         if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // //         const result = await response.json();
// // // // // //         const userMapping = result.data.reduce((acc, user) => {
// // // // // //           acc[user.userId] = user.pseudoname;
// // // // // //           return acc;
// // // // // //         }, {});
// // // // // //         setUserMap(userMapping);
// // // // // //       } catch (err) {
// // // // // //         console.error("Error fetching user data:", err.message);
// // // // // //       }
// // // // // //     };
// // // // // //     fetchUserData();
// // // // // //   }, [accessToken]);

// // // // // //   const loadTelnyxScripts = () => {
// // // // // //     return new Promise((resolve, reject) => {
// // // // // //       const scripts = [
// // // // // //         { id: 'webrtc-adapter', src: 'https://webrtc.github.io/adapter/adapter-latest.js' },
// // // // // //         { id: 'telnyx-webrtc', src: 'https://unpkg.com/@telnyx/webrtc@2.9.0/lib/bundle.js' }
// // // // // //       ];

// // // // // //       let loadedCount = 0;
// // // // // //       const totalScripts = scripts.length;

// // // // // //       const loadScript = (script) => {
// // // // // //         return new Promise((scriptResolve, scriptReject) => {
// // // // // //           if (document.getElementById(script.id)) {
// // // // // //             scriptResolve(); // Already loaded
// // // // // //             return;
// // // // // //           }

// // // // // //           const scriptElement = document.createElement('script');
// // // // // //           scriptElement.id = script.id;
// // // // // //           scriptElement.src = script.src;
// // // // // //           scriptElement.async = true;
// // // // // //           scriptElement.onload = () => {
// // // // // //             scriptResolve();
// // // // // //           };
// // // // // //           scriptElement.onerror = () => {
// // // // // //             scriptReject(new Error(`Failed to load ${script.src}`));
// // // // // //           };
// // // // // //           document.head.appendChild(scriptElement);
// // // // // //         });
// // // // // //       };

// // // // // //       const loadAll = async () => {
// // // // // //         for (const script of scripts) {
// // // // // //           try {
// // // // // //             await loadScript(script);
// // // // // //             loadedCount++;
// // // // // //           } catch (err) {
// // // // // //             reject(err);
// // // // // //             return;
// // // // // //           }
// // // // // //         }
// // // // // //         if (loadedCount === totalScripts) {
// // // // // //           resolve();
// // // // // //         }
// // // // // //       };

// // // // // //       loadAll();
// // // // // //     });
// // // // // //   };

// // // // // //   const logTelnyx = (msg) => {
// // // // // //     console.log(msg);
// // // // // //   };

// // // // // //   const connectTelnyx = async () => {
// // // // // //     const token = localStorage.getItem('telnyxToken');
// // // // // //     const userStr = localStorage.getItem('user');
// // // // // //     if (!token || !userStr) {
// // // // // //       logTelnyx("Telnyx Token or User data missing in localStorage");
// // // // // //       return;
// // // // // //     }

// // // // // //     const user = JSON.parse(userStr);
// // // // // //     const name = user.firstName;
// // // // // //     if (!name) {
// // // // // //       logTelnyx("Agent firstName missing in user data");
// // // // // //       return;
// // // // // //     }

// // // // // //     try {
// // // // // //       // Load scripts if not already loaded
// // // // // //       await loadTelnyxScripts();

// // // // // //       // Check if library is available after loading
// // // // // //       if (window.TelnyxWebRTC && window.TelnyxWebRTC.TelnyxRTC) {
// // // // // //         const client = new window.TelnyxWebRTC.TelnyxRTC({ login_token: token });

// // // // // //         client.on('telnyx.ready', () => {
// // // // // //           setTelnyxConnected(true);
// // // // // //           logTelnyx(`Connected as ${name}`);
// // // // // //         });

// // // // // //         client.on('telnyx.error', (e) => {
// // // // // //           logTelnyx(`Error: ${e.message}`);
// // // // // //           setTelnyxConnected(false);
// // // // // //         });

// // // // // //         client.on('telnyx.notification', (n) => {
// // // // // //           if (n.call) {
// // // // // //             setCurrentCall(n.call);

// // // // // //             if (n.call.state === 'ringing') {
// // // // // //               logTelnyx("📞 Incoming Call...");
// // // // // //               const incomingNum = n.call.options?.remoteCallerNumber || '';
// // // // // //               setCurrentPhoneNumber(incomingNum);
// // // // // //               setShowDialpad(true);
// // // // // //             }

// // // // // //             if (n.call.state === 'active') {
// // // // // //               logTelnyx("Call Active");
// // // // // //             }

// // // // // //             if (n.call.state === 'destroy') {
// // // // // //               logTelnyx("📴 Call Ended");
// // // // // //               setCurrentCall(null);
// // // // // //               setShowDialpad(false);
// // // // // //               setTelnyxConnected(true); // Re-enable connection
// // // // // //             }
// // // // // //           }
// // // // // //         });

// // // // // //         client.connect();
// // // // // //         setTelnyxClient(client);
// // // // // //       } else {
// // // // // //         throw new Error("TelnyxWebRTC library still not loaded after script injection");
// // // // // //       }
// // // // // //     } catch (e) {
// // // // // //       logTelnyx(`Connection Error: ${e.message}`);
// // // // // //       setTelnyxConnected(false);
// // // // // //     }
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     connectTelnyx();
// // // // // //   }, []);

// // // // // //   const makeTelnyxCall = (destinationNumber, fromNumber) => {
// // // // // //     if (telnyxClient && destinationNumber) {
// // // // // //       const call = telnyxClient.call({
// // // // // //         destinationNumber: destinationNumber,
// // // // // //         callerName: fromNumber || 'Sales Agent', // Use selected fromNumber
// // // // // //       });
// // // // // //       setCurrentCall(call);
// // // // // //       logTelnyx(`Calling ${destinationNumber}`);
// // // // // //       return call;
// // // // // //     }
// // // // // //     return null;
// // // // // //   };

// // // // // //   const endTelnyxCall = () => {
// // // // // //     if (currentCall) {
// // // // // //       currentCall.hangup();
// // // // // //       setCurrentCall(null);
// // // // // //     }
// // // // // //   };

// // // // // //   const fetchLeads = async () => {
// // // // // //     try {
// // // // // //       setLoading(true);
// // // // // //       const response = await fetch(
// // // // // //         "https://salesjet-10097049716.development.catalystappsail.com/leadsdata",
// // // // // //         {
// // // // // //           method: "GET",
// // // // // //           headers: {
// // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // //             "Content-Type": "application/json",
// // // // // //           },
// // // // // //         }
// // // // // //       );
// // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // //       const result = await response.json();
// // // // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // // // //       setData(leads);
// // // // // //       setFilteredData(leads);
// // // // // //     } catch (err) {
// // // // // //       setError(err.message);
// // // // // //       console.error("Error fetching leads:", err.message);
// // // // // //     } finally {
// // // // // //       setLoading(false);
// // // // // //     }
// // // // // //   };

// // // // // //   const fetchAllNotes = async () => {
// // // // // //     try {
// // // // // //       const response = await fetch(
// // // // // //         "https://salesjet-10097049716.development.catalystappsail.com/allleadnotes",
// // // // // //         {
// // // // // //           method: "GET",
// // // // // //           headers: {
// // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // //             "Content-Type": "application/json",
// // // // // //           },
// // // // // //         }
// // // // // //       );
// // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // //       const result = await response.json();
// // // // // //       setAllNotes(Array.isArray(result.data) ? result.data : []);
// // // // // //     } catch (err) {
// // // // // //       console.error("Error fetching all lead notes:", err.message);
// // // // // //     }
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     if (!isGlobalSearch) {
// // // // // //       fetchLeads();
// // // // // //       fetchAllNotes();
// // // // // //     }
// // // // // //   }, [accessToken, isGlobalSearch]);

// // // // // //   useEffect(() => {
// // // // // //     handleDefaultSort();
// // // // // //   }, []);

// // // // // //   useEffect(() => {
// // // // // //     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
// // // // // //       prevSelectedLeadId.current = selectedLeadId;
// // // // // //       setIsGlobalSearch(true);
// // // // // //       setColumnFilters({});
// // // // // //       handleGlobalSearch(selectedLeadId.toString());
// // // // // //     }
// // // // // //   }, [selectedLeadId]);

// // // // // //   useEffect(() => {
// // // // // //     if (selectedLeadId && filteredData.length > 0) {
// // // // // //       const matchingLead = filteredData.find(
// // // // // //         (lead) =>
// // // // // //           lead.LeadACVLRecordID &&
// // // // // //           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
// // // // // //       );
// // // // // //       if (matchingLead) {
// // // // // //         setSelectedBooking(matchingLead);
// // // // // //         setWidth(700);
// // // // // //       } else {
// // // // // //         setSelectedBooking(null);
// // // // // //       }
// // // // // //     } else if (selectedLeadId && filteredData.length === 0) {
// // // // // //       setSelectedBooking(null);
// // // // // //     }
// // // // // //   }, [filteredData, selectedLeadId]);

// // // // // //   useEffect(() => {
// // // // // //     if (isGlobalSearch) {
// // // // // //       return;
// // // // // //     }
// // // // // //     let filtered = [...data];
// // // // // //     if (searchQuery.trim()) {
// // // // // //       const normalizedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // //       filtered = filtered.filter((lead) =>
// // // // // //         Object.entries(lead).some(([key, value]) => {
// // // // // //           if (!value) return false;
// // // // // //           const normalizedValue = value
// // // // // //             .toString()
// // // // // //             .replace(/[^a-zA-Z0-9]/g, "")
// // // // // //             .toLowerCase();
// // // // // //           return normalizedValue.includes(normalizedQuery);
// // // // // //         })
// // // // // //       );
// // // // // //     }
// // // // // //     Object.keys(columnFilters).forEach((key) => {
// // // // // //       const rawFilter = columnFilters[key];
// // // // // //       if (rawFilter) {
// // // // // //         const trimmedRawFilter = rawFilter.trim();
// // // // // //         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // //         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
// // // // // //         if (isNAFilter) {
// // // // // //           filtered = filtered.filter((lead) => {
// // // // // //             const value = lead[key];
// // // // // //             return value === null || value === undefined || value === "" || value === "N/A";
// // // // // //           });
// // // // // //         } else if (normalizedFilter) {
// // // // // //           filtered = filtered.filter((lead) => {
// // // // // //             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // //             return value?.includes(normalizedFilter);
// // // // // //           });
// // // // // //         }
// // // // // //       }
// // // // // //     });
// // // // // //     setFilteredData(filtered);
// // // // // //   }, [data, searchQuery, columnFilters, isGlobalSearch]);

// // // // // //   const handleSearchChange = (query) => {
// // // // // //     setSearchQuery(query);
// // // // // //     setIsGlobalSearch(false);
// // // // // //     setColumnFilters({});
// // // // // //   };

// // // // // //   const handleGlobalSearch = async (query) => {
// // // // // //     setLoading(true);
// // // // // //     setIsDefaultSort(false);
// // // // // //     setIsGlobalSearch(true);
// // // // // //     try {
// // // // // //       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // //       const response = await fetch(
// // // // // //         "https://salesjet-10097049716.development.catalystappsail.com/globalsearch",
// // // // // //         {
// // // // // //           method: "POST",
// // // // // //           headers: {
// // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // //             "Content-Type": "application/json",
// // // // // //           },
// // // // // //           body: JSON.stringify({ query: normalizedQuery }),
// // // // // //         }
// // // // // //       );
// // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // //       const result = await response.json();
// // // // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // // // //       setFilteredData(leads);
// // // // // //       setSearchQuery(query);
// // // // // //       fetchAllNotes();
// // // // // //     } catch (err) {
// // // // // //       console.error("Global search error:", err.message);
// // // // // //       setError(err.message);
// // // // // //     } finally {
// // // // // //       setLoading(false);
// // // // // //     }
// // // // // //   };

// // // // // //   const handleSort = (key) => {
// // // // // //     setIsDefaultSort(false);
// // // // // //     setSortConfig((prev) =>
// // // // // //       prev.key === key
// // // // // //         ? {
// // // // // //             key,
// // // // // //             direction: prev.direction === "ascending" ? "descending" : "ascending",
// // // // // //           }
// // // // // //         : { key, direction: "ascending" }
// // // // // //     );
// // // // // //   };

// // // // // //   const handleColumnChange = (event) => {
// // // // // //     const value = event.target.value;
// // // // // //     setSelectedColumns((prev) => {
// // // // // //       let newSelected;
// // // // // //       if (prev.includes(value)) {
// // // // // //         newSelected = prev.filter((col) => col !== value);
// // // // // //       } else {
// // // // // //         newSelected = prev.length < 7 ? [...prev, value] : prev;
// // // // // //       }
// // // // // //       // Update localStorage and backend
// // // // // //       const labels = newSelected.map((key) => {
// // // // // //         const col = allColumns.find((c) => c.key === key);
// // // // // //         return col ? col.label : "";
// // // // // //       });
// // // // // //       const prefs = { Headers: labels };
// // // // // //       localStorage.setItem("Userpreference", JSON.stringify(prefs));
// // // // // //       updateUserpreference(labels);
// // // // // //       return newSelected;
// // // // // //     });
// // // // // //   };

// // // // // //   const sortedData = React.useMemo(() => {
// // // // // //     let sortableData = [...filteredData];
// // // // // //     if (isDefaultSort) {
// // // // // //       // Get current date in EST (America/Toronto)
// // // // // //       const now = new Date();
// // // // // //       const todayStr = now.toLocaleString('en-CA', { 
// // // // // //         timeZone: 'America/Toronto', 
// // // // // //         year: 'numeric', 
// // // // // //         month: '2-digit', 
// // // // // //         day: '2-digit' 
// // // // // //       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

// // // // // //       // Custom sorting logic
// // // // // //       sortableData.sort((a, b) => {
// // // // // //         const isUnassignedA = a.Status === null || a.Status === undefined;
// // // // // //         const isUnassignedB = b.Status === null || b.Status === undefined;
// // // // // //         const timeA = a.Received_Date_EST;
// // // // // //         const timeB = b.Received_Date_EST;
// // // // // //         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
// // // // // //         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

// // // // // //         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
// // // // // //         if (isUnassignedA && timeA === todayStr && (!isUnassignedB || timeB !== todayStr)) {
// // // // // //           return -1;
// // // // // //         }
// // // // // //         if (isUnassignedB && timeB === todayStr && (!isUnassignedA || timeA !== todayStr)) {
// // // // // //           return 1;
// // // // // //         }

// // // // // //         // Step 2: Leads with FollowUpDate date as today (EST)
// // // // // //         if (followUpA === todayStr && followUpB !== todayStr) return -1;
// // // // // //         if (followUpB === todayStr && followUpA !== todayStr) return 1;

// // // // // //         // Step 3: Sort by LeadACVLRecordID descending as fallback
// // // // // //         const idA = Number(a.LeadACVLRecordID || 0);
// // // // // //         const idB = Number(b.LeadACVLRecordID || 0);
// // // // // //         return idB - idA;
// // // // // //       });
// // // // // //     } else if (sortConfig.key) {
// // // // // //       sortableData.sort((a, b) => {
// // // // // //         let aVal = a[sortConfig.key];
// // // // // //         let bVal = b[sortConfig.key];
// // // // // //         // Handle null or undefined values
// // // // // //         if (aVal === undefined || aVal === null) return 1;
// // // // // //         if (bVal === undefined || bVal === null) return -1;
// // // // // //         // Handle LeadACVLRecordID specifically as a number
// // // // // //         if (sortConfig.key === "LeadACVLRecordID") {
// // // // // //           aVal = Number(aVal);
// // // // // //           bVal = Number(bVal);
// // // // // //           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // // // //         }
// // // // // //         // Handle date fields
// // // // // //         const isDateField = [
// // // // // //           "Move_Date",
// // // // // //           "Received_Date_EST",
// // // // // //           "Received_Time_IST",
// // // // // //           "FollowUpDate",
// // // // // //         ].includes(sortConfig.key);
// // // // // //         if (isDateField) {
// // // // // //           const dateA = new Date(aVal);
// // // // // //           const dateB = new Date(bVal);
// // // // // //           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
// // // // // //         }
// // // // // //         // Handle string fields
// // // // // //         if (typeof aVal === "string" && typeof bVal === "string") {
// // // // // //           return sortConfig.direction === "ascending"
// // // // // //             ? aVal.localeCompare(bVal)
// // // // // //             : bVal.localeCompare(bVal);
// // // // // //         }
// // // // // //         // Handle numeric fields
// // // // // //         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // // // //       });
// // // // // //     }
// // // // // //     return sortableData;
// // // // // //   }, [filteredData, sortConfig, isDefaultSort]);

// // // // // //   const notesByLead = React.useMemo(() => {
// // // // // //     const map = {};
// // // // // //     allNotes.forEach((note) => {
// // // // // //       const id = note.LeadACVLRecordID;
// // // // // //       if (id) {
// // // // // //         if (!map[id]) {
// // // // // //           map[id] = { notes: [], latestByCategory: {} };
// // // // // //         }
// // // // // //         map[id].notes.push(note);
// // // // // //       }
// // // // // //     });
// // // // // //     Object.keys(map).forEach((leadId) => {
// // // // // //       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
// // // // // //       const categoryMap = {};
// // // // // //       map[leadId].notes.forEach((note) => {
// // // // // //         const category = note.Category?.toLowerCase() || "";
// // // // // //         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
// // // // // //           categoryMap[category] = note;
// // // // // //         }
// // // // // //       });
// // // // // //       map[leadId].latestByCategory = categoryMap;
// // // // // //     });
// // // // // //     return map;
// // // // // //   }, [allNotes]);

// // // // // //   const startResizing = (e) => {
// // // // // //     isResizing.current = true;
// // // // // //     document.addEventListener("mousemove", resize);
// // // // // //     document.addEventListener("mouseup", stopResizing);
// // // // // //   };

// // // // // //   const resize = (e) => {
// // // // // //     if (!isResizing.current) return;
// // // // // //     const minWidth = 500;
// // // // // //     const maxWidth = window.innerWidth * 0.7;
// // // // // //     let newWidth = window.innerWidth - e.clientX;
// // // // // //     if (newWidth >= minWidth && newWidth <= maxWidth) {
// // // // // //       setWidth(newWidth);
// // // // // //     }
// // // // // //   };

// // // // // //   const stopResizing = () => {
// // // // // //     isResizing.current = false;
// // // // // //     document.removeEventListener("mousemove", resize);
// // // // // //     document.removeEventListener("mouseup", stopResizing);
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     const handleClickOutside = (event) => {
// // // // // //       if (filterRef.current && !filterRef.current.contains(event.target)) {
// // // // // //         setShowFilter(false);
// // // // // //       }
// // // // // //     };
// // // // // //     document.addEventListener("mousedown", handleClickOutside);
// // // // // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // // // // //   }, []);

// // // // // //   const handleMouseDown = (e) => {
// // // // // //     setIsDragging(true);
// // // // // //     const rect = dialpadRef.current.getBoundingClientRect();
// // // // // //     setDragOffset({
// // // // // //       x: e.clientX - rect.left,
// // // // // //       y: e.clientY - rect.top
// // // // // //     });
// // // // // //   };

// // // // // //   const handleMouseMove = (e) => {
// // // // // //     if (!isDragging) return;
// // // // // //     setDialpadPosition({
// // // // // //       x: e.clientX - dragOffset.x,
// // // // // //       y: e.clientY - dragOffset.y
// // // // // //     });
// // // // // //   };

// // // // // //   const handleMouseUp = () => {
// // // // // //     setIsDragging(false);
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     if (isDragging) {
// // // // // //       document.addEventListener('mousemove', handleMouseMove);
// // // // // //       document.addEventListener('mouseup', handleMouseUp);
// // // // // //     }
// // // // // //     return () => {
// // // // // //       document.removeEventListener('mousemove', handleMouseMove);
// // // // // //       document.removeEventListener('mouseup', handleMouseUp);
// // // // // //     };
// // // // // //   }, [isDragging, dragOffset]);

// // // // // //   const today = new Date().toISOString().split('T')[0];

// // // // // //   const openDialpad = (phone = '') => {
// // // // // //     setCurrentPhoneNumber(phone);
// // // // // //     setShowDialpad(true);
// // // // // //   };

// // // // // //   return (
// // // // // //     <div style={{ position: 'relative' }}>
// // // // // //       <>
// // // // // //         <TimelineComponent
// // // // // //           userDetails={userDetails}
// // // // // //           accessToken={accessToken}
// // // // // //           onSearchChange={handleSearchChange}
// // // // // //           onGlobalSearch={handleGlobalSearch}
// // // // // //           connectionStatus={connectionStatus}
// // // // // //           telnyxConnected={telnyxConnected}
// // // // // //           onShowReports={() => setShowReports(true)}
// // // // // //           onListView={() => setShowReports(false)}
// // // // // //         />
// // // // // //       </>
// // // // // //       {showReports && (
// // // // // //         <>
// // // // // //           <Reports />
// // // // // //         </>
// // // // // //       )}
// // // // // //       {!showReports && (
// // // // // //         <div className="table-container">
// // // // // //           <div
// // // // // //             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
// // // // // //             style={{ flex: selectedBooking ? "1" : "2" }}
// // // // // //           >
// // // // // //             <div>
// // // // // //               <div className="bookings-header-my">
// // // // // //                 <span
// // // // // //                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
// // // // // //                   onClick={() => handleSort("LeadACVLRecordID")}
// // // // // //                   style={{ cursor: "pointer" }}
// // // // // //                 >
// // // // // //                   ACVL LeadID
// // // // // //                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
// // // // // //                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // // // //                 </span>
// // // // // //                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // //                   (colKey) => {
// // // // // //                     const column = allColumns.find((c) => c.key === colKey);
// // // // // //                     const isSorted = sortConfig.key === colKey;
// // // // // //                     return column ? (
// // // // // //                       <span
// // // // // //                         key={colKey}
// // // // // //                         className="sortable-header"
// // // // // //                         onClick={() => handleSort(colKey)}
// // // // // //                         style={{ cursor: "pointer" }}
// // // // // //                       >
// // // // // //                         {column.label}
// // // // // //                         {!isDefaultSort && isSorted &&
// // // // // //                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // // // //                       </span>
// // // // // //                     ) : null;
// // // // // //                   }
// // // // // //                 )}
// // // // // //                 <span2>
// // // // // //                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
// // // // // //                     <div>
// // // // // //                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
// // // // // //                     </div>
// // // // // //                     <div>
// // // // // //                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
// // // // // //                     </div>
// // // // // //                     <div>
// // // // // //                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
// // // // // //                     </div>
// // // // // //                     <div>
// // // // // //                       <Search
// // // // // //                         className="filter-icon"
// // // // // //                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
// // // // // //                         title="Advanced column search"
// // // // // //                       />
// // // // // //                     </div>
// // // // // //                   </div>
// // // // // //                 </span2>
// // // // // //                 {showFilter && (
// // // // // //                   <div className="filter-dropdown" ref={filterRef}>
// // // // // //                     {allColumns.map((col) => (
// // // // // //                       <label key={col.key}>
// // // // // //                         <input
// // // // // //                           type="checkbox"
// // // // // //                           value={col.key}
// // // // // //                           checked={selectedColumns.includes(col.key)}
// // // // // //                           onChange={handleColumnChange}
// // // // // //                           disabled={
// // // // // //                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
// // // // // //                           }
// // // // // //                         />
// // // // // //                         {col.label}
// // // // // //                       </label>
// // // // // //                     ))}
// // // // // //                   </div>
// // // // // //                 )}
// // // // // //               </div>
// // // // // //               {showAdvancedFilter && (
// // // // // //                 <div className="column-filter-row">
// // // // // //                   <span className="filter-input">
// // // // // //                     <input
// // // // // //                       placeholder="Lead ID"
// // // // // //                       value={columnFilters["LeadACVLRecordID"] || ""}
// // // // // //                       onChange={(e) =>
// // // // // //                         setColumnFilters({
// // // // // //                           ...columnFilters,
// // // // // //                           LeadACVLRecordID: e.target.value,
// // // // // //                         })
// // // // // //                       }
// // // // // //                     />
// // // // // //                   </span>
// // // // // //                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // //                     (colKey) => (
// // // // // //                       <span key={colKey} className="filter-input">
// // // // // //                         <input
// // // // // //                           placeholder={
// // // // // //                             allColumns.find((col) => col.key === colKey)?.label || colKey
// // // // // //                           }
// // // // // //                           value={columnFilters[colKey] || ""}
// // // // // //                           onChange={(e) =>
// // // // // //                             setColumnFilters({
// // // // // //                               ...columnFilters,
// // // // // //                               [colKey]: e.target.value,
// // // // // //                             })
// // // // // //                           }
// // // // // //                         />
// // // // // //                       </span>
// // // // // //                     )
// // // // // //                   )}
// // // // // //                   <span className="filter-icons-space" />
// // // // // //                 </div>
// // // // // //               )}
// // // // // //               {loading && <p>Loading...</p>}
// // // // // //               {error && <p className="error">{error}</p>}
// // // // // //               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
// // // // // //               {!loading &&
// // // // // //                 !error &&
// // // // // //                 sortedData.map((item, index) => {
// // // // // //                   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// // // // // //                   const categories = leadNotesData.latestByCategory;
// // // // // //                   let flags = [];
// // // // // //                   const now = new Date();
// // // // // //                   const todayStr = now.toLocaleString('en-CA', { 
// // // // // //                     timeZone: 'America/Toronto', 
// // // // // //                     year: 'numeric', 
// // // // // //                     month: '2-digit', 
// // // // // //                     day: '2-digit' 
// // // // // //                   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
// // // // // //                   const isUnassignedToday =
// // // // // //                     (item.Status === null || item.Status === undefined) &&
// // // // // //                     item.Received_Date_EST &&
// // // // // //                     item.Received_Date_EST.split(' ')[0] === todayStr;
// // // // // //                   const isUnassignedall =
// // // // // //                     (item.Status === null || item.Status === undefined) &&
// // // // // //                     item.Received_Date_EST &&
// // // // // //                     item.Received_Date_EST.split(' ')[0] !== todayStr;
// // // // // //                   let isTodayFollowUp = false;

// // // // // //                   // Collect and process follow-up dates
// // // // // //                   const followUpDates = [];
                  
// // // // // //                   // Add follow-up date from notes (next follow-up category)
// // // // // //                   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
// // // // // //                     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
// // // // // //                     if (noteDate) {
// // // // // //                       followUpDates.push(noteDate);
// // // // // //                     }
// // // // // //                   }

// // // // // //                   // Add follow-up date from item.FollowUpDate
// // // // // //                   if (item.FollowUpDate) {
// // // // // //                     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
// // // // // //                     if (itemDate && !followUpDates.includes(itemDate)) {
// // // // // //                       followUpDates.push(itemDate);
// // // // // //                     }
// // // // // //                   }

// // // // // //                   // Select the most relevant follow-up date
// // // // // //                   let selectedFollowUpDate = null;
// // // // // //                   if (followUpDates.length > 0) {
// // // // // //                     // Prioritize: today's date, then past date, then future date
// // // // // //                     const today = new Date(todayStr);
// // // // // //                     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
// // // // // //                       const followUpDate = new Date(dateStr);
// // // // // //                       if (!selected) return dateStr;
// // // // // //                       const selectedDate = new Date(selected);
// // // // // //                       if (dateStr === todayStr) return dateStr; // Prioritize today's date
// // // // // //                       if (selected === todayStr) return selected;
// // // // // //                       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
// // // // // //                       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
// // // // // //                       return selected; // Keep first date if no priority
// // // // // //                     }, null);

// // // // // //                     if (selectedFollowUpDate) {
// // // // // //                       const followUpDate = new Date(selectedFollowUpDate);
// // // // // //                       isTodayFollowUp = selectedFollowUpDate === todayStr;
// // // // // //                       let color;
// // // // // //                       if (followUpDate < today && !isTodayFollowUp) {
// // // // // //                         color = "red"; // Past date
// // // // // //                       } else if (isTodayFollowUp) {
// // // // // //                         color = "green"; // Today
// // // // // //                       } else {
// // // // // //                         color = "gray"; // Future date
// // // // // //                       }
// // // // // //                       flags.push({ 
// // // // // //                         icon: Clock, 
// // // // // //                         color, 
// // // // // //                         title: `Follow-Up: ${selectedFollowUpDate}` 
// // // // // //                       });
// // // // // //                     }
// // // // // //                   }

// // // // // //                   // Process other categories
// // // // // //                   Object.values(categories).forEach((note) => {
// // // // // //                     if (note && note.Category?.toLowerCase() !== "next follow-up") {
// // // // // //                       const category = note.Category?.toLowerCase() || "";
// // // // // //                       const categoryDetails = note.Category_Details?.toLowerCase() || "";
// // // // // //                       if (category === "connection status") {
// // // // // //                         if (categoryDetails === "connected") {
// // // // // //                           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
// // // // // //                         } else if (categoryDetails === "not connected") {
// // // // // //                           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
// // // // // //                         }
// // // // // //                       } else if (category === "prospective") {
// // // // // //                         if (categoryDetails === "hot") {
// // // // // //                           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
// // // // // //                         } else if (categoryDetails === "warm") {
// // // // // //                           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
// // // // // //                         } else if (categoryDetails === "cold") {
// // // // // //                           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
// // // // // //                         }
// // // // // //                       }
// // // // // //                     }
// // // // // //                   });

// // // // // //                   // Process Lead_Priority for left side icon
// // // // // //                   let priorityFlag = null;
// // // // // //                   if (item.Lead_Priority) {
// // // // // //                     const priority = item.Lead_Priority.toString().toLowerCase().trim();
// // // // // //                     let color, title;
// // // // // //                     if (priority === "high") {
// // // // // //                       color = "red";
// // // // // //                       title = "High";
// // // // // //                     } else if (priority === "medium") {
// // // // // //                       color = "purple";
// // // // // //                       title = "Medium";
// // // // // //                     } else if (priority === "low") {
// // // // // //                       color = "green";
// // // // // //                       title = "Low";
// // // // // //                     }
// // // // // //                     if (color && title) {
// // // // // //                       priorityFlag = { icon: Circle, color, title };
// // // // // //                     }
// // // // // //                   }

// // // // // //                   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
// // // // // //                   const orderedFlags = new Array(5).fill(null);
// // // // // //                   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
// // // // // //                     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
// // // // // //                   }
// // // // // //                   if (item.Lead_Source_Status?.toLowerCase() === "return") {
// // // // // //                     if (item.Return_Outcome?.toLowerCase() === "approved") {
// // // // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
// // // // // //                     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
// // // // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
// // // // // //                     } else {
// // // // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
// // // // // //                     }
// // // // // //                   }
// // // // // //                   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
// // // // // //                   if (prospectiveFlag) {
// // // // // //                     orderedFlags[2] = prospectiveFlag;
// // // // // //                   }
// // // // // //                   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
// // // // // //                   if (connectionFlag) {
// // // // // //                     orderedFlags[3] = connectionFlag;
// // // // // //                   }
// // // // // //                   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
// // // // // //                   if (followUpFlag) {
// // // // // //                     orderedFlags[4] = followUpFlag;
// // // // // //                   }

// // // // // //                   return (
// // // // // //                     <div
// // // // // //                       key={index}
// // // // // //                       className={`booking-item-my ${
// // // // // //                         selectedBooking === item ? "active-booking" : ""
// // // // // //                       } ${
// // // // // //                         item.Duplicate_Lead_Details &&
// // // // // //                         Object.keys(item.Duplicate_Lead_Details).length > 0
// // // // // //                           ? "duplicate-item"
// // // // // //                           : ""
// // // // // //                       } ${
// // // // // //                         item.Lead_Source_Status?.toLowerCase() === "return"
// // // // // //                           ? "returned-item"
// // // // // //                           : ""
// // // // // //                       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
// // // // // //                       onClick={() => {
// // // // // //                         if (!selectedBooking) setWidth(700);
// // // // // //                         setSelectedBooking(item);
// // // // // //                       }}
// // // // // //                       style={{
// // // // // //                         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
// // // // // //                         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
// // // // // //                         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
// // // // // //                         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
// // // // // //                       }}
// // // // // //                     >
// // // // // //                       <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
// // // // // //                         {priorityFlag && (
// // // // // //                           <>
// // // // // //                             <priorityFlag.icon
// // // // // //                               className="icon"
// // // // // //                               style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
// // // // // //                               fill={priorityFlag.color}
// // // // // //                               title={priorityFlag.title}
// // // // // //                             />
// // // // // //                             <div className="custom-tooltip1">
// // // // // //                               {priorityFlag.title}
// // // // // //                             </div>
// // // // // //                           </>
// // // // // //                         )}
// // // // // //                       </div>
// // // // // //                       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
// // // // // //                       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // //                         (colKey) => (
// // // // // //                           <span1 key={colKey}>
// // // // // //                             {colKey === "AssignedUserID"
// // // // // //                               ? userMap[item.AssignedUserID] || "N/A"
// // // // // //                               : colKey === "FollowUpDate"
// // // // // //                               ? formatFollowUpDate(item[colKey])
// // // // // //                               : item[colKey] || "N/A"}
// // // // // //                           </span1>
// // // // // //                         )
// // // // // //                       )}
// // // // // //                       <span2 style={{
// // // // // //                         display: "flex",
// // // // // //                         gap: "8px",
// // // // // //                         alignItems: "center",
// // // // // //                         justifyContent: "flex-end",
// // // // // //                         width: "120px",
// // // // // //                       }}>
// // // // // //                         {orderedFlags.map((flag, idx) => (
// // // // // //                           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
// // // // // //                             {flag && (
// // // // // //                               <>
// // // // // //                                 <flag.icon
// // // // // //                                   className="icon"
// // // // // //                                   style={{ color: flag.color, width: "16px", height: "16px" }}
// // // // // //                                   title={flag.title}
// // // // // //                                 />
// // // // // //                                 <div className="custom-tooltip">
// // // // // //                                   {flag.title}
// // // // // //                                 </div>
// // // // // //                               </>
// // // // // //                             )}
// // // // // //                           </div>
// // // // // //                         ))}
// // // // // //                       </span2>
// // // // // //                     </div>
// // // // // //                   );
// // // // // //                 })}
// // // // // //             </div>
// // // // // //           </div>
// // // // // //           {selectedBooking && (
// // // // // //             <div className="lead-details-container" style={{ width: `${width}px` }}>
// // // // // //               <div className="resize-handle" onMouseDown={startResizing}></div>
// // // // // //               <LeadDetails
// // // // // //                 key={selectedBooking.LeadACVLRecordID}
// // // // // //                 booking={selectedBooking}
// // // // // //                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
// // // // // //                 onClose={() => setSelectedBooking(null)}
// // // // // //                 userDetails={userDetails}
// // // // // //                 accessToken={accessToken}
// // // // // //                 userMap={userMap}
// // // // // //                 updateLeadData={updateLeadData}
// // // // // //                 refetchNotes={refetchNotes}
// // // // // //                 onOpenDialpad={openDialpad}
// // // // // //                 telnyxClient={telnyxClient}
// // // // // //                 currentCall={currentCall}
// // // // // //                 onMakeCall={makeTelnyxCall}
// // // // // //                 onEndCall={endTelnyxCall}
// // // // // //                 telnyxConnected={telnyxConnected}
// // // // // //               />
// // // // // //             </div>
// // // // // //           )}
// // // // // //         </div>
// // // // // //       )}

// // // // // //       <button 
// // // // // //         onClick={() => openDialpad('')} 
// // // // // //         style={{
// // // // // //           position: 'fixed',
// // // // // //           bottom: '20px',
// // // // // //           right: '80px',
// // // // // //           width: '56px',
// // // // // //           height: '56px',
// // // // // //           borderRadius: '50%',
// // // // // //           backgroundColor: '#10b981', 
// // // // // //           border: 'none',
// // // // // //           display: 'flex',
// // // // // //           alignItems: 'center',
// // // // // //           justifyContent: 'center',
// // // // // //           boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
// // // // // //           cursor: 'pointer',
// // // // // //           zIndex: 999,
// // // // // //           transition: 'all 0.2s ease'
// // // // // //         }}
// // // // // //         title="Open Dialpad"
// // // // // //       >
// // // // // //         <Phone size={24} color="white" />
// // // // // //       </button>
// // // // // //       {showDialpad && (
// // // // // //         <>
// // // // // //           <div 
// // // // // //             style={{ 
// // // // // //               position: 'fixed', 
// // // // // //               top: 0, 
// // // // // //               left: 0, 
// // // // // //               width: '100%', 
// // // // // //               height: '100%', 
// // // // // //               backgroundColor: 'rgba(0,0,0,0.5)', 
// // // // // //               zIndex: 1000 
// // // // // //             }} 
// // // // // //             onClick={() => setShowDialpad(false)}
// // // // // //           />
// // // // // //           <div 
// // // // // //             ref={dialpadRef}
// // // // // //             style={{ 
// // // // // //               position: 'fixed', 
// // // // // //               left: `${dialpadPosition.x}px`, 
// // // // // //               top: `${dialpadPosition.y}px`, 
// // // // // //               background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', // Match dialpad gradient
// // // // // //               padding: '2px',
// // // // // //               borderRadius: '10px', 
// // // // // //               zIndex: 1001,
// // // // // //               boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
// // // // // //             }} 
// // // // // //             onClick={(e) => e.stopPropagation()}
// // // // // //           >
// // // // // //             <div 
// // // // // //               style={{ 
// // // // // //                 display: 'flex', 
// // // // // //                 justifyContent: 'space-between', 
// // // // // //                 alignItems: 'center', 
// // // // // //                 marginBottom: '10px',
// // // // // //                 cursor: 'move',
// // // // // //                 padding: '5px 0'
// // // // // //               }} 
// // // // // //               onMouseDown={handleMouseDown}
// // // // // //             >
// // // // // //             </div>
// // // // // //             <Dialpad
// // // // // //               phoneNumber={currentPhoneNumber} 
// // // // // //               onClose={() => setShowDialpad(false)}
// // // // // //               telnyxClient={telnyxClient}
// // // // // //               currentCall={currentCall}
// // // // // //               onMakeCall={makeTelnyxCall}
// // // // // //               onEndCall={endTelnyxCall}
// // // // // //               telnyxConnected={telnyxConnected}
// // // // // //             />
// // // // // //           </div>
// // // // // //         </>
// // // // // //       )}
// // // // // //     </div>
// // // // // //   );
// // // // // // };

// // // // // // export default Homepage;

// // // // // // after changes in the task bar

// // // import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
// // // import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle, Trash2 } from "lucide-react";
// // // import LeadDetails from "./Leaddetails";
// // // import TimelineComponent from "./Header";
// // // import Reports from "./Reports";
// // // import Dialpad from "./SmsEmail/Dialpad";

// // // const allColumns = [
// // //   { key: "Sales_Agent", label: "Sales Agent" },
// // //   { key: "Customer_Name", label: "Lead Name" },
// // //   { key: "Move_Date", label: "Move Date" },
// // //   { key: "Status", label: "Estimate Status" },
// // //   { key: "OriginCity", label: "From Province" },
// // //   { key: "DestinationCity", label: "To Province" },
// // //   { key: "FollowUpDate", label: "Follow Up Date" },
// // //   { key: "Move_Size", label: "Move Size" },
// // //   { key: "Lead_Status", label: "Lead Status" },
// // //   { key: "Move_Type", label: "Move Type" },
// // //   { key: "Estimate_Amount", label: "Estimate Amount" },
// // //   { key: "From_Postcode", label: "From Postcode" },
// // //   { key: "To_Postcode", label: "To Postcode" },
// // //   { key: "Received_Date_EST", label: "Received Date EST" },
// // //   { key: "Banner", label: "Banner" },
// // //   { key: "Lead_Priority", label: "Lead Priority" },
// // //   { key: "Received_Time_IST", label: "Received Time IST" },
// // // ];

// // // const defaultFilters = [
// // //   { key: 'all', label: 'All', color: '#007bff' },
// // //   { key: 'today', label: 'Today\'s Follow-up', color: '#28a745' },
// // //   { key: 'noFollowUp', label: 'No Follow-up Date', color: '#dc3545' }
// // // ];

// // // const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
// // //   const [showReports, setShowReports] = useState(false);
// // //   const [data, setData] = useState([]);
// // //   const [filteredData, setFilteredData] = useState([]);
// // //   const [searchQuery, setSearchQuery] = useState("");
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [selectedBooking, setSelectedBooking] = useState(null);
// // //   const [width, setWidth] = useState(350);
// // //   const [showFilter, setShowFilter] = useState(false);
// // //   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
// // //   const [columnFilters, setColumnFilters] = useState({});
// // //   const [selectedColumns, setSelectedColumns] = useState(
// // //     allColumns.slice(0, 7).map((col) => col.key)
// // //   );
// // //   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
// // //   const [isDefaultSort, setIsDefaultSort] = useState(false);
// // //   const [currentFilter, setCurrentFilter] = useState('all');
// // //   const [savedFilters, setSavedFilters] = useState([]);
// // //   const [showSaveModal, setShowSaveModal] = useState(false);
// // //   const [filterName, setFilterName] = useState('');
// // //   const filterRef = useRef(null);
// // //   const isResizing = useRef(false);
// // //   const [userMap, setUserMap] = useState({});
// // //   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
// // //   const prevSelectedLeadId = useRef(null);
// // //   const [allNotes, setAllNotes] = useState([]);

// // //   const [telnyxClient, setTelnyxClient] = useState(null);
// // //   const [telnyxConnected, setTelnyxConnected] = useState(false);
// // //   const [currentCall, setCurrentCall] = useState(null);
// // //   const telnyxLogRef = useRef(null);

// // //   const [showDialpad, setShowDialpad] = useState(false);
// // //   const [currentPhoneNumber, setCurrentPhoneNumber] = useState('');
// // //   const [dialpadPosition, setDialpadPosition] = useState({ x: window.innerWidth / 2 - 150, y: window.innerHeight / 2 - 200 });
// // //   const [isDragging, setIsDragging] = useState(false);
// // //   const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
// // //   const dialpadRef = useRef(null);

// // //   const todayStr = useMemo(() => {
// // //     const now = new Date();
// // //     return now.toLocaleString('en-CA', { 
// // //       timeZone: 'America/Toronto', 
// // //       year: 'numeric', 
// // //       month: '2-digit', 
// // //       day: '2-digit' 
// // //     }).split(',')[0].split('/').reverse().join('-');
// // //   }, []);

// // //   const notesByLead = React.useMemo(() => {
// // //     const map = {};
// // //     allNotes.forEach((note) => {
// // //       const id = note.LeadACVLRecordID;
// // //       if (id) {
// // //         if (!map[id]) {
// // //           map[id] = { notes: [], latestByCategory: {} };
// // //         }
// // //         map[id].notes.push(note);
// // //       }
// // //     });
// // //     Object.keys(map).forEach((leadId) => {
// // //       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
// // //       const categoryMap = {};
// // //       map[leadId].notes.forEach((note) => {
// // //         const category = note.Category?.toLowerCase() || "";
// // //         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
// // //           categoryMap[category] = note;
// // //         }
// // //       });
// // //       map[leadId].latestByCategory = categoryMap;
// // //     });
// // //     return map;
// // //   }, [allNotes]);

// // //   const getFollowUpDates = useCallback((item) => {
// // //     const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// // //     const categories = leadNotesData.latestByCategory;
// // //     const followUpDates = [];
// // //     if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
// // //       const noteDate = categories["next follow-up"].Category_Details.split('T')[0];
// // //       if (noteDate) followUpDates.push(noteDate);
// // //     }
// // //     if (item.FollowUpDate) {
// // //       const itemDate = item.FollowUpDate.split('T')[0];
// // //       if (itemDate && !followUpDates.includes(itemDate)) {
// // //         followUpDates.push(itemDate);
// // //       }
// // //     }
// // //     return followUpDates;
// // //   }, [notesByLead]);

// // //   const counts = useMemo(() => {
// // //     const total = data.length;
// // //     let todayCount = 0;
// // //     let noFollowUpCount = 0;
// // //     data.forEach(item => {
// // //       const followUpDates = getFollowUpDates(item);
// // //       const hasToday = followUpDates.includes(todayStr);
// // //       const hasNo = followUpDates.length === 0;
// // //       if (hasToday) todayCount++;
// // //       if (hasNo) noFollowUpCount++;
// // //     });
// // //     return { total, today: todayCount, noFollowUp: noFollowUpCount };
// // //   }, [data, getFollowUpDates, todayStr]);

// // //   const updateLeadData = (updatedBooking) => {
// // //     setData((prevData) =>
// // //       prevData.map((lead) =>
// // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // //           ? { ...lead, ...updatedBooking }
// // //           : lead
// // //       )
// // //     );
// // //     setFilteredData((prevFilteredData) =>
// // //       prevFilteredData.map((lead) =>
// // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // //           ? { ...lead, ...updatedBooking }
// // //           : lead
// // //       )
// // //     );
// // //     if (
// // //       selectedBooking &&
// // //       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // //     ) {
// // //       setSelectedBooking(updatedBooking);
// // //     }
// // //   };

// // //   const refetchNotes = () => {
// // //     fetchAllNotes();
// // //   };

// // //   const formatFollowUpDate = (date) => {
// // //     if (!date) return "N/A";
// // //     return date.replace("T", " ");
// // //   };

// // //   const handleDefaultSort = () => {
// // //     setSearchQuery("");
// // //     setColumnFilters({});
// // //     setIsGlobalSearch(false);
// // //     setCurrentFilter('all');
// // //     setIsDefaultSort(true);
// // //     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
// // //     fetchLeads();
// // //   };
// // //   const updateUserpreference = async (headers, tabFilter, savedFilters) => {
// // //       try {
// // //         const payload = { 
// // //           Userpreference: { 
// // //             Headers: headers,
// // //             TabFilter: tabFilter,
// // //             SavedFilters: savedFilters
// // //           } 
// // //         };
// // //         await fetch("https://salesjet-10097049716.development.catalystappsail.com/userdata", {
// // //           method: "PUT",
// // //           headers: {
// // //             Authorization: `Bearer ${accessToken}`,
// // //             "Content-Type": "application/json",
// // //           },
// // //           body: JSON.stringify(payload),
// // //         });
// // //       } catch (err) {
// // //         console.error("Error updating preferences:", err);
// // //       }
// // //   };

// // //   const savePreferences = useCallback((headers, tabFilter, savedFilters) => {
// // //     const prefs = { Headers: headers, TabFilter: tabFilter, SavedFilters: savedFilters };
// // //     localStorage.setItem("Userpreference", JSON.stringify(prefs));
// // //     updateUserpreference(headers, tabFilter, savedFilters);
// // //   }, [accessToken]);
  
// // //   const loadPreferences = () => {
// // //     try {
// // //       const stored = localStorage.getItem("Userpreference");
// // //       console.log("Loaded preferences from localStorage:", stored);
// // //       let headers, tabFilter, savedFilters;
// // //       if (stored) {
// // //         const parsed = JSON.parse(stored);
// // //         headers = parsed.Headers || null;
// // //         tabFilter = parsed.TabFilter || 'all';
// // //         savedFilters = parsed.SavedFilters ;
// // //       }
// // //       if (!headers || !Array.isArray(headers) || headers.length === 0) {
// // //         headers = allColumns.slice(0, 7).map((col) => col.label);
// // //       }
// // //       const keys = headers
// // //         .map((label) => {
// // //           const col = allColumns.find((c) => c.label === label);
// // //           return col ? col.key : null;
// // //         })
// // //         .filter(Boolean);
// // //       setSelectedColumns(keys);
// // //       setCurrentFilter(tabFilter);
// // //       setSavedFilters(savedFilters);
// // //       savePreferences(headers, tabFilter, savedFilters);
// // //     } catch (err) {
// // //       console.error(err);
// // //       const headers = allColumns.slice(0, 7).map((col) => col.label);
// // //       const tabFilter = 'all';
// // //       const savedFilters = [];
// // //       const prefs = { Headers: headers, TabFilter: tabFilter, SavedFilters: savedFilters };
// // //       localStorage.setItem("Userpreference", JSON.stringify(prefs));
// // //       savePreferences(headers, tabFilter, savedFilters);
// // //       setSelectedColumns(allColumns.slice(0, 7).map((col) => col.key));
// // //       setCurrentFilter(tabFilter);
// // //       setSavedFilters(savedFilters);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     if (accessToken) {
// // //       loadPreferences();
// // //     }
// // //   }, [accessToken, savePreferences]);

// // //   // Auto-save when currentFilter or selectedColumns change
// // //   useEffect(() => {
// // //     const headers = selectedColumns.map((key) => {
// // //       const col = allColumns.find((c) => c.key === key);
// // //       return col ? col.label : "";
// // //     });
// // //     savePreferences(headers, currentFilter, savedFilters);
// // //   }, [currentFilter, selectedColumns, savedFilters, savePreferences]);

// // //   const handleSaveNewFilter = () => {
// // //     if (!filterName.trim()) return;
// // //     const newFilter = {
// // //       name: filterName.trim(),
// // //       searchQuery,
// // //       columnFilters
// // //     };
// // //     const updatedSavedFilters = [...savedFilters, newFilter];
// // //     setSavedFilters(updatedSavedFilters);
// // //     setFilterName('');
// // //     setShowSaveModal(false);
// // //     // Save will be triggered by useEffect
// // //   };

// // //   const handleApplySavedFilter = (savedFilter) => {
// // //     setSearchQuery(savedFilter.searchQuery || '');
// // //     setColumnFilters(savedFilter.columnFilters || {});
// // //     setCurrentFilter(savedFilter.name);
// // //     setIsGlobalSearch(false);
// // //   };

// // //   const handleDeleteFilter = (name) => {
// // //     const updatedSavedFilters = savedFilters.filter(f => f.name !== name);
// // //     setSavedFilters(updatedSavedFilters);
// // //     if (currentFilter === name) {
// // //       setCurrentFilter('all');
// // //       setSearchQuery('');
// // //       setColumnFilters({});
// // //     }
// // //     // Save will be triggered by useEffect
// // //   };

// // //   useEffect(() => {
// // //     const fetchUserData = async () => {
// // //       try {
// // //         const response = await fetch(
// // //           "https://salesjet-10097049716.development.catalystappsail.com/userdata",
// // //           {
// // //             method: "GET",
// // //             headers: {
// // //               Authorization: `Bearer ${accessToken}`,
// // //               "Content-Type": "application/json",
// // //             },
// // //           }
// // //         );
// // //         if (!response.ok) throw new Error(`Error: ${response.status}`);
// // //         const result = await response.json();
// // //         const userMapping = result.data.reduce((acc, user) => {
// // //           acc[user.userId] = user.pseudoname;
// // //           return acc;
// // //         }, {});
// // //         setUserMap(userMapping);
// // //       } catch (err) {
// // //         console.error("Error fetching user data:", err.message);
// // //       }
// // //     };
// // //     fetchUserData();
// // //   }, [accessToken]);

// // //   const loadTelnyxScripts = () => {
// // //     return new Promise((resolve, reject) => {
// // //       const scripts = [
// // //         { id: 'webrtc-adapter', src: 'https://webrtc.github.io/adapter/adapter-latest.js' },
// // //         { id: 'telnyx-webrtc', src: 'https://unpkg.com/@telnyx/webrtc@2.9.0/lib/bundle.js' }
// // //       ];

// // //       let loadedCount = 0;
// // //       const totalScripts = scripts.length;

// // //       const loadScript = (script) => {
// // //         return new Promise((scriptResolve, scriptReject) => {
// // //           if (document.getElementById(script.id)) {
// // //             scriptResolve(); // Already loaded
// // //             return;
// // //           }

// // //           const scriptElement = document.createElement('script');
// // //           scriptElement.id = script.id;
// // //           scriptElement.src = script.src;
// // //           scriptElement.async = true;
// // //           scriptElement.onload = () => {
// // //             scriptResolve();
// // //           };
// // //           scriptElement.onerror = () => {
// // //             scriptReject(new Error(`Failed to load ${script.src}`));
// // //           };
// // //           document.head.appendChild(scriptElement);
// // //         });
// // //       };

// // //       const loadAll = async () => {
// // //         for (const script of scripts) {
// // //           try {
// // //             await loadScript(script);
// // //             loadedCount++;
// // //           } catch (err) {
// // //             reject(err);
// // //             return;
// // //           }
// // //         }
// // //         if (loadedCount === totalScripts) {
// // //           resolve();
// // //         }
// // //       };

// // //       loadAll();
// // //     });
// // //   };

// // //   const logTelnyx = (msg) => {
// // //     console.log(msg);
// // //   };

// // //   const connectTelnyx = async () => {
// // //     const token = localStorage.getItem('telnyxToken');
// // //     const userStr = localStorage.getItem('user');
// // //     if (!token || !userStr) {
// // //       logTelnyx("Telnyx Token or User data missing in localStorage");
// // //       return;
// // //     }

// // //     const user = JSON.parse(userStr);
// // //     const name = user.firstName;
// // //     if (!name) {
// // //       logTelnyx("Agent firstName missing in user data");
// // //       return;
// // //     }

// // //     try {
// // //       // Load scripts if not already loaded
// // //       await loadTelnyxScripts();

// // //       // Check if library is available after loading
// // //       if (window.TelnyxWebRTC && window.TelnyxWebRTC.TelnyxRTC) {
// // //         const client = new window.TelnyxWebRTC.TelnyxRTC({ login_token: token });

// // //         client.on('telnyx.ready', () => {
// // //           setTelnyxConnected(true);
// // //           logTelnyx(`Connected as ${name}`);
// // //         });

// // //         client.on('telnyx.error', (e) => {
// // //           logTelnyx(`Error: ${e.message}`);
// // //           setTelnyxConnected(false);
// // //         });

// // //         client.on('telnyx.notification', (n) => {
// // //           if (n.call) {
// // //             setCurrentCall(n.call);

// // //             if (n.call.state === 'ringing') {
// // //               logTelnyx("📞 Incoming Call...");
// // //               const incomingNum = n.call.options?.remoteCallerNumber || '';
// // //               setCurrentPhoneNumber(incomingNum);
// // //               setShowDialpad(true);
// // //             }

// // //             if (n.call.state === 'active') {
// // //               logTelnyx("Call Active");
// // //             }

// // //             if (n.call.state === 'destroy') {
// // //               logTelnyx("📴 Call Ended");
// // //               setCurrentCall(null);
// // //               setShowDialpad(false);
// // //               setTelnyxConnected(true); // Re-enable connection
// // //             }
// // //           }
// // //         });

// // //         client.connect();
// // //         setTelnyxClient(client);
// // //       } else {
// // //         throw new Error("TelnyxWebRTC library still not loaded after script injection");
// // //       }
// // //     } catch (e) {
// // //       logTelnyx(`Connection Error: ${e.message}`);
// // //       setTelnyxConnected(false);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     connectTelnyx();
// // //   }, []);

// // //   const makeTelnyxCall = (destinationNumber, fromNumber) => {
// // //     if (telnyxClient && destinationNumber) {
// // //       const call = telnyxClient.call({
// // //         destinationNumber: destinationNumber,
// // //         callerName: fromNumber || 'Sales Agent', // Use selected fromNumber
// // //       });
// // //       setCurrentCall(call);
// // //       logTelnyx(`Calling ${destinationNumber}`);
// // //       return call;
// // //     }
// // //     return null;
// // //   };

// // //   const endTelnyxCall = () => {
// // //     if (currentCall) {
// // //       currentCall.hangup();
// // //       setCurrentCall(null);
// // //     }
// // //   };

// // //   const fetchLeads = async () => {
// // //     try {
// // //       setLoading(true);
// // //       const response = await fetch(
// // //         "https://salesjet-10097049716.development.catalystappsail.com/leadsdata",
// // //         {
// // //           method: "GET",
// // //           headers: {
// // //             Authorization: `Bearer ${accessToken}`,
// // //             "Content-Type": "application/json",
// // //           },
// // //         }
// // //       );
// // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // //       const result = await response.json();
// // //       const leads = Array.isArray(result.data) ? result.data : [];
// // //       setData(leads);
// // //       setFilteredData(leads);
// // //     } catch (err) {
// // //       setError(err.message);
// // //       console.error("Error fetching leads:", err.message);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const fetchAllNotes = async () => {
// // //     try {
// // //       const response = await fetch(
// // //         "https://salesjet-10097049716.development.catalystappsail.com/allleadnotes",
// // //         {
// // //           method: "GET",
// // //           headers: {
// // //             Authorization: `Bearer ${accessToken}`,
// // //             "Content-Type": "application/json",
// // //           },
// // //         }
// // //       );
// // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // //       const result = await response.json();
// // //       setAllNotes(Array.isArray(result.data) ? result.data : []);
// // //     } catch (err) {
// // //       console.error("Error fetching all lead notes:", err.message);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     if (!isGlobalSearch) {
// // //       fetchLeads();
// // //       fetchAllNotes();
// // //     }
// // //   }, [accessToken, isGlobalSearch]);

// // //   useEffect(() => {
// // //     handleDefaultSort();
// // //   }, []);

// // //   useEffect(() => {
// // //     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
// // //       prevSelectedLeadId.current = selectedLeadId;
// // //       setIsGlobalSearch(true);
// // //       setColumnFilters({});
// // //       handleGlobalSearch(selectedLeadId.toString());
// // //     }
// // //   }, [selectedLeadId]);

// // //   useEffect(() => {
// // //     if (selectedLeadId && filteredData.length > 0) {
// // //       const matchingLead = filteredData.find(
// // //         (lead) =>
// // //           lead.LeadACVLRecordID &&
// // //           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
// // //       );
// // //       if (matchingLead) {
// // //         setSelectedBooking(matchingLead);
// // //         setWidth(700);
// // //       } else {
// // //         setSelectedBooking(null);
// // //       }
// // //     } else if (selectedLeadId && filteredData.length === 0) {
// // //       setSelectedBooking(null);
// // //     }
// // //   }, [filteredData, selectedLeadId]);

// // //   useEffect(() => {
// // //     if (isGlobalSearch) {
// // //       return;
// // //     }
// // //     let filtered = [...data];
// // //     const normalizedQuery = searchQuery.toLowerCase().trim();
// // //     if (normalizedQuery === 'today') {
// // //       // Special filter for Move_Date today
// // //       filtered = filtered.filter((item) => 
// // //         item.Move_Date && item.Move_Date.split('T')[0] === todayStr
// // //       );
// // //     } else if (searchQuery.trim()) {
// // //       filtered = filtered.filter((lead) =>
// // //         Object.entries(lead).some(([key, value]) => {
// // //           if (!value) return false;
// // //           const normalizedValue = value
// // //             .toString()
// // //             .replace(/[^a-zA-Z0-9]/g, "")
// // //             .toLowerCase();
// // //           return normalizedValue.includes(normalizedQuery.replace(/[^a-zA-Z0-9]/g, ""));
// // //         })
// // //       );
// // //     }
// // //     Object.keys(columnFilters).forEach((key) => {
// // //       const rawFilter = columnFilters[key];
// // //       if (rawFilter) {
// // //         const trimmedRawFilter = rawFilter.trim();
// // //         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // //         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
// // //         if (isNAFilter) {
// // //           filtered = filtered.filter((lead) => {
// // //             const value = lead[key];
// // //             return value === null || value === undefined || value === "" || value === "N/A";
// // //           });
// // //         } else if (normalizedFilter) {
// // //           filtered = filtered.filter((lead) => {
// // //             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // //             return value?.includes(normalizedFilter);
// // //           });
// // //         }
// // //       }
// // //     });
// // //     // Apply current filter if it's a default one
// // //     if (defaultFilters.some(f => f.key === currentFilter)) {
// // //       if (currentFilter !== 'all') {
// // //         filtered = filtered.filter(item => {
// // //           const followUpDates = getFollowUpDates(item);
// // //           if (currentFilter === 'today') {
// // //             return followUpDates.includes(todayStr);
// // //           } else if (currentFilter === 'noFollowUp') {
// // //             return followUpDates.length === 0;
// // //           }
// // //           return true;
// // //         });
// // //       }
// // //     }
// // //     setFilteredData(filtered);
// // //   }, [data, searchQuery, columnFilters, isGlobalSearch, currentFilter, getFollowUpDates, todayStr]);

// // //   const handleSearchChange = (query) => {
// // //     setSearchQuery(query);
// // //     setIsGlobalSearch(false);
// // //     setCurrentFilter('all');
// // //   };

// // //   const handleGlobalSearch = async (query) => {
// // //     setLoading(true);
// // //     setIsDefaultSort(false);
// // //     setIsGlobalSearch(true);
// // //     setCurrentFilter('all');
// // //     try {
// // //       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // //       const response = await fetch(
// // //         "https://salesjet-10097049716.development.catalystappsail.com/globalsearch",
// // //         {
// // //           method: "POST",
// // //           headers: {
// // //             Authorization: `Bearer ${accessToken}`,
// // //             "Content-Type": "application/json",
// // //           },
// // //           body: JSON.stringify({ query: normalizedQuery }),
// // //         }
// // //       );
// // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // //       const result = await response.json();
// // //       const leads = Array.isArray(result.data) ? result.data : [];
// // //       setFilteredData(leads);
// // //       setSearchQuery(query);
// // //       fetchAllNotes();
// // //     } catch (err) {
// // //       console.error("Global search error:", err.message);
// // //       setError(err.message);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const handleSort = (key) => {
// // //     setIsDefaultSort(false);
// // //     setSortConfig((prev) =>
// // //       prev.key === key
// // //         ? {
// // //             key,
// // //             direction: prev.direction === "ascending" ? "descending" : "ascending",
// // //           }
// // //         : { key, direction: "ascending" }
// // //     );
// // //   };

// // //   const handleColumnChange = (event) => {
// // //     const value = event.target.value;
// // //     setSelectedColumns((prev) => {
// // //       let newSelected;
// // //       if (prev.includes(value)) {
// // //         newSelected = prev.filter((col) => col !== value);
// // //       } else {
// // //         newSelected = prev.length < 7 ? [...prev, value] : prev;
// // //       }
// // //       // The save will be handled by useEffect
// // //       return newSelected;
// // //     });
// // //   };

// // //   const handleSaveFilter = () => {
// // //     setShowSaveModal(true);
// // //   };

// // //   const sortedData = React.useMemo(() => {
// // //     let sortableData = [...filteredData];
// // //     if (isDefaultSort) {
// // //       // Get current date in EST (America/Toronto)
// // //       const now = new Date();
// // //       const todayStrLocal = now.toLocaleString('en-CA', { 
// // //         timeZone: 'America/Toronto', 
// // //         year: 'numeric', 
// // //         month: '2-digit', 
// // //         day: '2-digit' 
// // //       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

// // //       // Custom sorting logic
// // //       sortableData.sort((a, b) => {
// // //         const isUnassignedA = a.Status === null || a.Status === undefined;
// // //         const isUnassignedB = b.Status === null || b.Status === undefined;
// // //         const timeA = a.Received_Date_EST;
// // //         const timeB = b.Received_Date_EST;
// // //         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
// // //         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

// // //         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
// // //         if (isUnassignedA && timeA === todayStrLocal && (!isUnassignedB || timeB !== todayStrLocal)) {
// // //           return -1;
// // //         }
// // //         if (isUnassignedB && timeB === todayStrLocal && (!isUnassignedA || timeA !== todayStrLocal)) {
// // //           return 1;
// // //         }

// // //         // Step 2: Leads with FollowUpDate date as today (EST)
// // //         if (followUpA === todayStrLocal && followUpB !== todayStrLocal) return -1;
// // //         if (followUpB === todayStrLocal && followUpA !== todayStrLocal) return 1;

// // //         // Step 3: Sort by LeadACVLRecordID descending as fallback
// // //         const idA = Number(a.LeadACVLRecordID || 0);
// // //         const idB = Number(b.LeadACVLRecordID || 0);
// // //         return idB - idA;
// // //       });
// // //     } else if (sortConfig.key) {
// // //       sortableData.sort((a, b) => {
// // //         let aVal = a[sortConfig.key];
// // //         let bVal = b[sortConfig.key];
// // //         // Handle null or undefined values
// // //         if (aVal === undefined || aVal === null) return 1;
// // //         if (bVal === undefined || bVal === null) return -1;
// // //         // Handle LeadACVLRecordID specifically as a number
// // //         if (sortConfig.key === "LeadACVLRecordID") {
// // //           aVal = Number(aVal);
// // //           bVal = Number(bVal);
// // //           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // //         }
// // //         // Handle date fields
// // //         const isDateField = [
// // //           "Move_Date",
// // //           "Received_Date_EST",
// // //           "Received_Time_IST",
// // //           "FollowUpDate",
// // //         ].includes(sortConfig.key);
// // //         if (isDateField) {
// // //           const dateA = new Date(aVal);
// // //           const dateB = new Date(bVal);
// // //           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
// // //         }
// // //         // Handle string fields
// // //         if (typeof aVal === "string" && typeof bVal === "string") {
// // //           return sortConfig.direction === "ascending"
// // //             ? aVal.localeCompare(bVal)
// // //             : bVal.localeCompare(bVal);
// // //         }
// // //         // Handle numeric fields
// // //         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // //       });
// // //     }
// // //     return sortableData;
// // //   }, [filteredData, sortConfig, isDefaultSort]);

// // //   const startResizing = (e) => {
// // //     isResizing.current = true;
// // //     document.addEventListener("mousemove", resize);
// // //     document.addEventListener("mouseup", stopResizing);
// // //   };

// // //   const resize = (e) => {
// // //     if (!isResizing.current) return;
// // //     const minWidth = 500;
// // //     const maxWidth = window.innerWidth * 0.7;
// // //     let newWidth = window.innerWidth - e.clientX;
// // //     if (newWidth >= minWidth && newWidth <= maxWidth) {
// // //       setWidth(newWidth);
// // //     }
// // //   };

// // //   const stopResizing = () => {
// // //     isResizing.current = false;
// // //     document.removeEventListener("mousemove", resize);
// // //     document.removeEventListener("mouseup", stopResizing);
// // //   };

// // //   useEffect(() => {
// // //     const handleClickOutside = (event) => {
// // //       if (filterRef.current && !filterRef.current.contains(event.target)) {
// // //         setShowFilter(false);
// // //       }
// // //     };
// // //     document.addEventListener("mousedown", handleClickOutside);
// // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // //   }, []);

// // //   const handleMouseDown = (e) => {
// // //     setIsDragging(true);
// // //     const rect = dialpadRef.current.getBoundingClientRect();
// // //     setDragOffset({
// // //       x: e.clientX - rect.left,
// // //       y: e.clientY - rect.top
// // //     });
// // //   };

// // //   const handleMouseMove = (e) => {
// // //     if (!isDragging) return;
// // //     setDialpadPosition({
// // //       x: e.clientX - dragOffset.x,
// // //       y: e.clientY - dragOffset.y
// // //     });
// // //   };

// // //   const handleMouseUp = () => {
// // //     setIsDragging(false);
// // //   };

// // //   useEffect(() => {
// // //     if (isDragging) {
// // //       document.addEventListener('mousemove', handleMouseMove);
// // //       document.addEventListener('mouseup', handleMouseUp);
// // //     }
// // //     return () => {
// // //       document.removeEventListener('mousemove', handleMouseMove);
// // //       document.removeEventListener('mouseup', handleMouseUp);
// // //     };
// // //   }, [isDragging, dragOffset]);

// // //   const openDialpad = (phone = '') => {
// // //     setCurrentPhoneNumber(phone);
// // //     setShowDialpad(true);
// // //   };

// // //   const getFilterCount = (filterKey) => {
// // //     if (filterKey === 'all') return counts.total;
// // //     if (filterKey === 'today') return counts.today;
// // //     if (filterKey === 'noFollowUp') return counts.noFollowUp;
// // //     // For saved filters, compute on the fly if needed, but skip for now
// // //     return null;
// // //   };

// // //   const getFilterStyle = (filterKey) => {
// // //     const defFilter = defaultFilters.find(f => f.key === filterKey);
// // //     if (defFilter) {
// // //       return {
// // //         background: currentFilter === filterKey ? defFilter.color : 'transparent',
// // //         color: currentFilter === filterKey ? 'white' : defFilter.color,
// // //         border: `1px solid ${defFilter.color}`,
// // //       };
// // //     }
// // //     // For saved
// // //     return {
// // //       background: currentFilter === filterKey ? '#6c757d' : 'transparent',
// // //       color: currentFilter === filterKey ? 'white' : '#6c757d',
// // //       border: '1px solid #6c757d',
// // //     };
// // //   };

// // //   const computeSavedFilterCount = useCallback((saved) => {
// // //     let filtered = [...data];
// // //     const normalizedQuery = saved.searchQuery?.toLowerCase().trim() || '';
// // //     if (normalizedQuery === 'today') {
// // //       filtered = filtered.filter((item) => 
// // //         item.Move_Date && item.Move_Date.split('T')[0] === todayStr
// // //       );
// // //     } else if (saved.searchQuery?.trim()) {
// // //       filtered = filtered.filter((lead) =>
// // //         Object.entries(lead).some(([key, value]) => {
// // //           if (!value) return false;
// // //           const normalizedValue = value
// // //             .toString()
// // //             .replace(/[^a-zA-Z0-9]/g, "")
// // //             .toLowerCase();
// // //           return normalizedValue.includes(normalizedQuery.replace(/[^a-zA-Z0-9]/g, ""));
// // //         })
// // //       );
// // //     }
// // //     Object.keys(saved.columnFilters || {}).forEach((key) => {
// // //       const rawFilter = saved.columnFilters[key];
// // //       if (rawFilter) {
// // //         const trimmedRawFilter = rawFilter.trim();
// // //         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // //         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
// // //         if (isNAFilter) {
// // //           filtered = filtered.filter((lead) => {
// // //             const value = lead[key];
// // //             return value === null || value === undefined || value === "" || value === "N/A";
// // //           });
// // //         } else if (normalizedFilter) {
// // //           filtered = filtered.filter((lead) => {
// // //             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // //             return value?.includes(normalizedFilter);
// // //           });
// // //         }
// // //       }
// // //     });
// // //     return filtered.length;
// // //   }, [data, todayStr]);

// // //   const savedFilterCounts = useMemo(() => 
// // //     savedFilters.map(saved => computeSavedFilterCount(saved)), 
// // //     [savedFilters, computeSavedFilterCount]
// // //   );

// // //   return (
// // //     <div style={{ position: 'relative' }}>
// // //       <>
// // //         <TimelineComponent
// // //           userDetails={userDetails}
// // //           accessToken={accessToken}
// // //           onSearchChange={handleSearchChange}
// // //           onGlobalSearch={handleGlobalSearch}
// // //           connectionStatus={connectionStatus}
// // //           telnyxConnected={telnyxConnected}
// // //           onShowReports={() => setShowReports(true)}
// // //           onListView={() => setShowReports(false)}
// // //         />
// // //         {/* <div className="filter-bar" style={{
// // //           display: 'flex',
// // //           alignItems: 'center',
// // //           backgroundColor: '#f8f9fa',
// // //           borderBottom: '1px solid #dee2e6',
// // //           fontSize: '14px',
// // //           fontWeight: '500',
// // //           flexWrap: 'wrap',
// // //           gap: '8px'
// // //         }}>
// // //           {defaultFilters.map((filter) => {
// // //             const count = getFilterCount(filter.key);
// // //             return (
// // //               <button 
// // //                 key={filter.key}
// // //                 onClick={() => setCurrentFilter(filter.key)} 
// // //                 className={currentFilter === filter.key ? 'active' : ''} 
// // //                 style={{
// // //                   ...getFilterStyle(filter.key),
// // //                   padding: '4px 8px',
// // //                   borderRadius: '4px',
// // //                   cursor: 'pointer',
// // //                   marginRight: '4px'
// // //                 }}
// // //               >
// // //                 {filter.label} {count !== null && `(${count})`}
// // //               </button>
// // //             );
// // //           })}
// // //           {savedFilters.map((saved) => (
// // //             <div key={saved.name} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
// // //               <button 
// // //                 onClick={() => handleApplySavedFilter(saved)} 
// // //                 className={currentFilter === saved.name ? 'active' : ''} 
// // //                 style={{
// // //                   ...getFilterStyle(saved.name),
// // //                   padding: '4px 8px',
// // //                   borderRadius: '4px',
// // //                   cursor: 'pointer'
// // //                 }}
// // //               >
// // //                 {saved.name}
// // //               </button>
// // //               <button 
// // //                 onClick={() => handleDeleteFilter(saved.name)}
// // //                 style={{
// // //                   background: 'none',
// // //                   border: 'none',
// // //                   cursor: 'pointer',
// // //                   padding: '2px',
// // //                   color: '#dc3545',
// // //                   display: 'flex',
// // //                   alignItems: 'center',
// // //                   justifyContent: 'center'
// // //                 }}
// // //                 title="Delete filter"
// // //               >
// // //                 <Trash2 size={16} />
// // //               </button>
// // //             </div>
// // //           ))}
// // //           <button 
// // //             onClick={() => setShowAdvancedFilter(true)}
// // //             style={{
// // //               background: 'transparent',
// // //               color: '#6c757d',
// // //               border: '1px solid #6c757d',
// // //               padding: '4px 8px',
// // //               borderRadius: '4px',
// // //               cursor: 'pointer'
// // //             }}
// // //           >
// // //             + Add more filters
// // //           </button>
// // //         </div> */}
// // //         <div className="filter-bar" style={{
// // //           display: 'flex',
// // //           alignItems: 'center',
// // //           backgroundColor: '#f8f9fa',
// // //           borderBottom: '1px solid #dee2e6',
// // //           fontSize: '14px',
// // //           fontWeight: '500',
// // //           flexWrap: 'wrap',
// // //           gap: '8px'
// // //         }}>
// // //           {defaultFilters.map((filter) => {
// // //             const count = getFilterCount(filter.key);
// // //             return (
// // //               <button 
// // //                 key={filter.key}
// // //                 onClick={() => setCurrentFilter(filter.key)} 
// // //                 className={currentFilter === filter.key ? 'active' : ''} 
// // //                 style={{
// // //                   ...getFilterStyle(filter.key),
// // //                   display: 'flex',
// // //                   alignItems: 'center',
// // //                   width: '120px',
// // //                   padding: '4px 8px',
// // //                   borderRadius: '4px',
// // //                   cursor: 'pointer',
// // //                   marginRight: '4px',
// // //                   justifyContent: 'space-between'
// // //                 }}
// // //                 title={`${filter.label}${count !== null ? ` (${count})` : ''}`}
// // //               >
// // //                 <span 
// // //                   style={{
// // //                     overflow: 'hidden',
// // //                     textOverflow: 'ellipsis',
// // //                     whiteSpace: 'nowrap',
// // //                     flex: 1
// // //                   }}
// // //                 >
// // //                   {filter.label}
// // //                 </span>
// // //                 {count !== null && (
// // //                   <span 
// // //                     style={{
// // //                       marginLeft: '4px',
// // //                       whiteSpace: 'nowrap',
// // //                       fontWeight: 'bold'
// // //                     }}
// // //                   >
// // //                     ({count})
// // //                   </span>
// // //                 )}
// // //               </button>
// // //             );
// // //           })}
// // //           {savedFilters.map((saved, index) => {
// // //             const count = savedFilterCounts[index];
// // //             return (
// // //               <div key={saved.name} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
// // //                 <button 
// // //                   onClick={() => handleApplySavedFilter(saved)} 
// // //                   className={currentFilter === saved.name ? 'active' : ''} 
// // //                   style={{
// // //                     ...getFilterStyle(saved.name),
// // //                     display: 'flex',
// // //                     alignItems: 'center',
// // //                     width: '120px',
// // //                     padding: '4px 8px',
// // //                     borderRadius: '4px',
// // //                     cursor: 'pointer',
// // //                     justifyContent: 'space-between'
// // //                   }}
// // //                   title={`${saved.name}${count ? ` (${count})` : ''}`}
// // //                 >
// // //                   <span 
// // //                     style={{
// // //                       overflow: 'hidden',
// // //                       textOverflow: 'ellipsis',
// // //                       whiteSpace: 'nowrap',
// // //                       flex: 1
// // //                     }}
// // //                   >
// // //                     {saved.name}
// // //                   </span>
// // //                   {count !== null && count > 0 && (
// // //                     <span 
// // //                       style={{
// // //                         marginLeft: '4px',
// // //                         whiteSpace: 'nowrap',
// // //                         fontWeight: 'bold'
// // //                       }}
// // //                     >
// // //                       ({count})
// // //                     </span>
// // //                   )}
// // //                 </button>
// // //                 <button 
// // //                   onClick={() => handleDeleteFilter(saved.name)}
// // //                   style={{
// // //                     background: 'none',
// // //                     border: 'none',
// // //                     cursor: 'pointer',
// // //                     padding: '2px',
// // //                     color: '#dc3545',
// // //                     display: 'flex',
// // //                     alignItems: 'center',
// // //                     justifyContent: 'center'
// // //                   }}
// // //                   title="Delete filter"
// // //                 >
// // //                   <Trash2 size={16} />
// // //                 </button>
// // //               </div>
// // //             );
// // //           })}
// // //           <button 
// // //             onClick={() => setShowAdvancedFilter(true)}
// // //             style={{
// // //               background: 'transparent',
// // //               color: '#6c757d',
// // //               border: '1px solid #6c757d',
// // //               padding: '4px 8px',
// // //               borderRadius: '4px',
// // //               cursor: 'pointer'
// // //             }}
// // //           >
// // //             + Add more filters
// // //           </button>
// // //         </div>
// // //         {/* <div className="filter-bar" style={{
// // //           display: 'flex',
// // //           alignItems: 'center',
// // //           backgroundColor: '#f8f9fa',
// // //           borderBottom: '1px solid #dee2e6',
// // //           fontSize: '14px',
// // //           fontWeight: '500',
// // //           flexWrap: 'wrap',
// // //           gap: '8px'
// // //         }}>
// // //           {defaultFilters.map((filter, index) => {
// // //             const count = getFilterCount(filter.key);
// // //             const displayText = `${filter.label}${count !== null ? ` (${count})` : ''}`;
// // //             return (
// // //               <button 
// // //                 key={filter.key}
// // //                 onClick={() => setCurrentFilter(filter.key)} 
// // //                 className={currentFilter === filter.key ? 'active' : ''} 
// // //                 style={{
// // //                   ...getFilterStyle(filter.key),
// // //                   width: '140px',
// // //                   overflow: 'hidden',
// // //                   textOverflow: 'ellipsis',
// // //                   whiteSpace: 'nowrap',
// // //                   padding: '4px 8px',
// // //                   borderRadius: '4px',
// // //                   cursor: 'pointer',
// // //                   marginRight: '4px'
// // //                 }}
// // //                 title={displayText}
// // //               >
// // //                 {displayText}
// // //               </button>
// // //             );
// // //           })}
// // //           {savedFilters.map((saved, index) => {
// // //             const count = savedFilterCounts[index];
// // //             const displayText = `${saved.name}${count !== null ? ` (${count})` : ''}`;
// // //             return (
// // //               <div key={saved.name} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
// // //                 <button 
// // //                   onClick={() => handleApplySavedFilter(saved)} 
// // //                   className={currentFilter === saved.name ? 'active' : ''} 
// // //                   style={{
// // //                     ...getFilterStyle(saved.name),
// // //                     width: '140px',
// // //                     overflow: 'hidden',
// // //                     textOverflow: 'ellipsis',
// // //                     whiteSpace: 'nowrap',
// // //                     padding: '4px 8px',
// // //                     borderRadius: '4px',
// // //                     cursor: 'pointer'
// // //                   }}
// // //                   title={displayText}
// // //                 >
// // //                   {displayText}
// // //                 </button>
// // //                 <button 
// // //                   onClick={() => handleDeleteFilter(saved.name)}
// // //                   style={{
// // //                     background: 'none',
// // //                     border: 'none',
// // //                     cursor: 'pointer',
// // //                     padding: '2px',
// // //                     color: '#dc3545',
// // //                     display: 'flex',
// // //                     alignItems: 'center',
// // //                     justifyContent: 'center'
// // //                   }}
// // //                   title="Delete filter"
// // //                 >
// // //                   <Trash2 size={16} />
// // //                 </button>
// // //               </div>
// // //             );
// // //           })}
// // //           <button 
// // //             onClick={() => setShowAdvancedFilter(true)}
// // //             style={{
// // //               background: 'transparent',
// // //               color: '#6c757d',
// // //               border: '1px solid #6c757d',
// // //               padding: '4px 8px',
// // //               borderRadius: '4px',
// // //               cursor: 'pointer'
// // //             }}
// // //           >
// // //             + Add more filters
// // //           </button>
// // //         </div> */}
// // //       </>     
// // //       {showSaveModal && (
// // //         <div style={{
// // //           position: 'fixed',
// // //           top: 0,
// // //           left: 0,
// // //           width: '100%',
// // //           height: '100%',
// // //           backgroundColor: 'rgba(0,0,0,0.5)',
// // //           display: 'flex',
// // //           justifyContent: 'center',
// // //           alignItems: 'center',
// // //           zIndex: 1002
// // //         }}>
// // //           <div style={{
// // //             background: 'white',
// // //             padding: '20px',
// // //             borderRadius: '8px',
// // //             display: 'flex',
// // //             flexDirection: 'column',
// // //             gap: '10px'
// // //           }}>
// // //             <label>Filter Name:</label>
// // //             <input
// // //               type="text"
// // //               value={filterName}
// // //               onChange={(e) => setFilterName(e.target.value)}
// // //               style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
// // //             />
// // //             <div style={{ display: 'flex', gap: '10px' }}>
// // //               <button onClick={handleSaveNewFilter} style={{ padding: '8px 16px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}>Save</button>
// // //               <button onClick={() => { setShowSaveModal(false); setFilterName(''); }} style={{ padding: '8px 16px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px' }}>Cancel</button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}
// // //       {showReports && (
// // //         <>
// // //           {/* <button onClick={() => setShowReports(false)}>✖ Close Report</button> */}
// // //           <Reports />
// // //         </>
// // //       )}
// // //       {!showReports && (
// // //         <div className="table-container">
// // //           <div
// // //             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
// // //             style={{ flex: selectedBooking ? "1" : "2" }}
// // //           >
// // //             <div>
// // //               <div className="bookings-header-my">
// // //                 <span
// // //                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
// // //                   onClick={() => handleSort("LeadACVLRecordID")}
// // //                   style={{ cursor: "pointer" }}
// // //                 >
// // //                   ACVL LeadID
// // //                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
// // //                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // //                 </span>
// // //                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // //                   (colKey) => {
// // //                     const column = allColumns.find((c) => c.key === colKey);
// // //                     const isSorted = sortConfig.key === colKey;
// // //                     return column ? (
// // //                       <span
// // //                         key={colKey}
// // //                         className="sortable-header"
// // //                         onClick={() => handleSort(colKey)}
// // //                         style={{ cursor: "pointer" }}
// // //                       >
// // //                         {column.label}
// // //                         {!isDefaultSort && isSorted &&
// // //                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // //                       </span>
// // //                     ) : null;
// // //                   }
// // //                 )}
// // //                 <span2>
// // //                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
// // //                     <div>
// // //                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
// // //                     </div>
// // //                     <div>
// // //                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
// // //                     </div>
// // //                     <div>
// // //                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
// // //                     </div>
// // //                     <div>
// // //                       <Search
// // //                         className="filter-icon"
// // //                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
// // //                         title="Advanced column search"
// // //                       />
// // //                     </div>
// // //                   </div>
// // //                 </span2>
// // //                 {showFilter && (
// // //                   <div className="filter-dropdown" ref={filterRef}>
// // //                     {allColumns.map((col) => (
// // //                       <label key={col.key}>
// // //                         <input
// // //                           type="checkbox"
// // //                           value={col.key}
// // //                           checked={selectedColumns.includes(col.key)}
// // //                           onChange={handleColumnChange}
// // //                           disabled={
// // //                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
// // //                           }
// // //                         />
// // //                         {col.label}
// // //                       </label>
// // //                     ))}
// // //                   </div>
// // //                 )}
// // //               </div>
// // //               {showAdvancedFilter && (
// // //                 <div className="column-filter-row">
// // //                   <span className="filter-input">
// // //                     <input
// // //                       placeholder="Lead ID"
// // //                       value={columnFilters["LeadACVLRecordID"] || ""}
// // //                       onChange={(e) =>
// // //                         setColumnFilters({
// // //                           ...columnFilters,
// // //                           LeadACVLRecordID: e.target.value,
// // //                         })
// // //                       }
// // //                     />
// // //                   </span>
// // //                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // //                     (colKey) => (
// // //                       <span key={colKey} className="filter-input">
// // //                         <input
// // //                           placeholder={
// // //                             allColumns.find((col) => col.key === colKey)?.label || colKey
// // //                           }
// // //                           value={columnFilters[colKey] || ""}
// // //                           onChange={(e) =>
// // //                             setColumnFilters({
// // //                               ...columnFilters,
// // //                               [colKey]: e.target.value,
// // //                             })
// // //                           }
// // //                         />
// // //                       </span>
// // //                     )
// // //                   )}
// // //                   {/* <span className="filter-icons-space" /> */}
// // //                   <span className="filter-input">
// // //                   <button 
// // //                     onClick={handleSaveFilter}
// // //                     style={{
// // //                       background: '#17a2b8',
// // //                       color: 'white',
// // //                       border: '1px solid #17a2b8',
// // //                       padding: '8px 12px',
// // //                       borderRadius: '4px',
// // //                       cursor: 'pointer',
// // //                       marginLeft: 'auto',
// // //                       whiteSpace: 'nowrap',
// // //                       float: 'right',
// // //                       alignSelf: 'center'
// // //                     }}
// // //                   >
// // //                     Save Filter
// // //                   </button>
// // //                   </span>
// // //                 </div>
// // //               )}
// // //               {loading && <p>Loading...</p>}
// // //               {error && <p className="error">{error}</p>}
// // //               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
// // //               {!loading &&
// // //                 !error &&
// // //                 sortedData.map((item, index) => {
// // //                   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// // //                   const categories = leadNotesData.latestByCategory;
// // //                   let flags = [];
// // //                   const now = new Date();
// // //                   const todayStrLocal = now.toLocaleString('en-CA', { 
// // //                     timeZone: 'America/Toronto', 
// // //                     year: 'numeric', 
// // //                     month: '2-digit', 
// // //                     day: '2-digit' 
// // //                   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
// // //                   const isUnassignedToday =
// // //                     (item.Status === null || item.Status === undefined) &&
// // //                     item.Received_Date_EST &&
// // //                     item.Received_Date_EST.split(' ')[0] === todayStrLocal;
// // //                   const isUnassignedall =
// // //                     (item.Status === null || item.Status === undefined) &&
// // //                     item.Received_Date_EST &&
// // //                     item.Received_Date_EST.split(' ')[0] !== todayStrLocal;
// // //                   let isTodayFollowUp = false;

// // //                   // Collect and process follow-up dates
// // //                   const followUpDates = [];
                  
// // //                   // Add follow-up date from notes (next follow-up category)
// // //                   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
// // //                     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
// // //                     if (noteDate) {
// // //                       followUpDates.push(noteDate);
// // //                     }
// // //                   }

// // //                   // Add follow-up date from item.FollowUpDate
// // //                   if (item.FollowUpDate) {
// // //                     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
// // //                     if (itemDate && !followUpDates.includes(itemDate)) {
// // //                       followUpDates.push(itemDate);
// // //                     }
// // //                   }

// // //                   // Select the most relevant follow-up date
// // //                   let selectedFollowUpDate = null;
// // //                   if (followUpDates.length > 0) {
// // //                     // Prioritize: today's date, then past date, then future date
// // //                     const today = new Date(todayStrLocal);
// // //                     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
// // //                       const followUpDate = new Date(dateStr);
// // //                       if (!selected) return dateStr;
// // //                       const selectedDate = new Date(selected);
// // //                       if (dateStr === todayStrLocal) return dateStr; // Prioritize today's date
// // //                       if (selected === todayStrLocal) return selected;
// // //                       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
// // //                       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
// // //                       return selected; // Keep first date if no priority
// // //                     }, null);

// // //                     if (selectedFollowUpDate) {
// // //                       const followUpDate = new Date(selectedFollowUpDate);
// // //                       isTodayFollowUp = selectedFollowUpDate === todayStrLocal;
// // //                       let color;
// // //                       if (followUpDate < today && !isTodayFollowUp) {
// // //                         color = "red"; // Past date
// // //                       } else if (isTodayFollowUp) {
// // //                         color = "green"; // Today
// // //                       } else {
// // //                         color = "gray"; // Future date
// // //                       }
// // //                       flags.push({ 
// // //                         icon: Clock, 
// // //                         color, 
// // //                         title: `Follow-Up: ${selectedFollowUpDate}` 
// // //                       });
// // //                     }
// // //                   }

// // //                   // Process other categories
// // //                   Object.values(categories).forEach((note) => {
// // //                     if (note && note.Category?.toLowerCase() !== "next follow-up") {
// // //                       const category = note.Category?.toLowerCase() || "";
// // //                       const categoryDetails = note.Category_Details?.toLowerCase() || "";
// // //                       if (category === "connection status") {
// // //                         if (categoryDetails === "connected") {
// // //                           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
// // //                         } else if (categoryDetails === "not connected") {
// // //                           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
// // //                         }
// // //                       } else if (category === "prospective") {
// // //                         if (categoryDetails === "hot") {
// // //                           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
// // //                         } else if (categoryDetails === "warm") {
// // //                           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
// // //                         } else if (categoryDetails === "cold") {
// // //                           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
// // //                         }
// // //                       }
// // //                     }
// // //                   });

// // //                   // Process Lead_Priority for left side icon
// // //                   let priorityFlag = null;
// // //                   if (item.Lead_Priority) {
// // //                     const priority = item.Lead_Priority.toString().toLowerCase().trim();
// // //                     let color, title;
// // //                     if (priority === "high") {
// // //                       color = "red";
// // //                       title = "High";
// // //                     } else if (priority === "medium") {
// // //                       color = "purple";
// // //                       title = "Medium";
// // //                     } else if (priority === "low") {
// // //                       color = "green";
// // //                       title = "Low";
// // //                     }
// // //                     if (color && title) {
// // //                       priorityFlag = { icon: Circle, color, title };
// // //                     }
// // //                   }

// // //                   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
// // //                   const orderedFlags = new Array(5).fill(null);
// // //                   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
// // //                     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
// // //                   }
// // //                   if (item.Lead_Source_Status?.toLowerCase() === "return") {
// // //                     if (item.Return_Outcome?.toLowerCase() === "approved") {
// // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
// // //                     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
// // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
// // //                     } else {
// // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
// // //                     }
// // //                   }
// // //                   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
// // //                   if (prospectiveFlag) {
// // //                     orderedFlags[2] = prospectiveFlag;
// // //                   }
// // //                   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
// // //                   if (connectionFlag) {
// // //                     orderedFlags[3] = connectionFlag;
// // //                   }
// // //                   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
// // //                   if (followUpFlag) {
// // //                     orderedFlags[4] = followUpFlag;
// // //                   }

// // //                   return (
// // //                     <div
// // //                       key={index}
// // //                       className={`booking-item-my ${
// // //                         selectedBooking === item ? "active-booking" : ""
// // //                       } ${
// // //                         item.Duplicate_Lead_Details &&
// // //                         Object.keys(item.Duplicate_Lead_Details).length > 0
// // //                           ? "duplicate-item"
// // //                           : ""
// // //                       } ${
// // //                         item.Lead_Source_Status?.toLowerCase() === "return"
// // //                           ? "returned-item"
// // //                           : ""
// // //                       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
// // //                       onClick={() => {
// // //                         if (!selectedBooking) setWidth(700);
// // //                         setSelectedBooking(item);
// // //                       }}
// // //                       style={{
// // //                         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
// // //                         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
// // //                         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
// // //                         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
// // //                       }}
// // //                     >
// // //                       <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
// // //                         {priorityFlag && (
// // //                           <>
// // //                             <priorityFlag.icon
// // //                               className="icon"
// // //                               style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
// // //                               fill={priorityFlag.color}
// // //                               title={priorityFlag.title}
// // //                             />
// // //                             <div className="custom-tooltip1">
// // //                               {priorityFlag.title}
// // //                             </div>
// // //                           </>
// // //                         )}
// // //                       </div>
// // //                       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
// // //                       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // //                         (colKey) => (
// // //                           <span1 key={colKey}>
// // //                             {colKey === "AssignedUserID"
// // //                               ? userMap[item.AssignedUserID] || "N/A"
// // //                               : colKey === "FollowUpDate"
// // //                               ? formatFollowUpDate(item[colKey])
// // //                               : item[colKey] || "N/A"}
// // //                           </span1>
// // //                         )
// // //                       )}
// // //                       <span2 style={{
// // //                         display: "flex",
// // //                         gap: "8px",
// // //                         alignItems: "center",
// // //                         justifyContent: "flex-end",
// // //                         width: "120px",
// // //                       }}>
// // //                         {orderedFlags.map((flag, idx) => (
// // //                           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
// // //                             {flag && (
// // //                               <>
// // //                                 <flag.icon
// // //                                   className="icon"
// // //                                   style={{ color: flag.color, width: "16px", height: "16px" }}
// // //                                   title={flag.title}
// // //                                 />
// // //                                 <div className="custom-tooltip">
// // //                                   {flag.title}
// // //                                 </div>
// // //                               </>
// // //                             )}
// // //                           </div>
// // //                         ))}
// // //                       </span2>
// // //                     </div>
// // //                   );
// // //                 })}
// // //             </div>
// // //           </div>
// // //           {selectedBooking && (
// // //             <div className="lead-details-container" style={{ width: `${width}px` }}>
// // //               <div className="resize-handle" onMouseDown={startResizing}></div>
// // //               <LeadDetails
// // //                 key={selectedBooking.LeadACVLRecordID}
// // //                 booking={selectedBooking}
// // //                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
// // //                 onClose={() => setSelectedBooking(null)}
// // //                 userDetails={userDetails}
// // //                 accessToken={accessToken}
// // //                 userMap={userMap}
// // //                 updateLeadData={updateLeadData}
// // //                 refetchNotes={refetchNotes}
// // //                 onOpenDialpad={openDialpad}
// // //                 telnyxClient={telnyxClient}
// // //                 currentCall={currentCall}
// // //                 onMakeCall={makeTelnyxCall}
// // //                 onEndCall={endTelnyxCall}
// // //                 telnyxConnected={telnyxConnected}
// // //               />
// // //             </div>
// // //           )}
// // //         </div>
// // //       )}

// // //       <button 
// // //         onClick={() => openDialpad('')} 
// // //         style={{
// // //           position: 'fixed',
// // //           bottom: '20px',
// // //           right: '80px',
// // //           width: '56px',
// // //           height: '56px',
// // //           borderRadius: '50%',
// // //           backgroundColor: '#10b981', // Enhanced green
// // //           border: 'none',
// // //           display: 'flex',
// // //           alignItems: 'center',
// // //           justifyContent: 'center',
// // //           boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
// // //           cursor: 'pointer',
// // //           zIndex: 999,
// // //           transition: 'all 0.2s ease'
// // //         }}
// // //         title="Open Dialpad"
// // //       >
// // //         <Phone size={24} color="white" />
// // //       </button>
// // //       {showDialpad && (
// // //         <>
// // //           <div 
// // //             style={{ 
// // //               position: 'fixed', 
// // //               top: 0, 
// // //               left: 0, 
// // //               width: '100%', 
// // //               height: '100%', 
// // //               backgroundColor: 'rgba(0,0,0,0.5)', 
// // //               zIndex: 1000 
// // //             }} 
// // //             onClick={() => setShowDialpad(false)}
// // //           />
// // //           <div 
// // //             ref={dialpadRef}
// // //             style={{ 
// // //               position: 'fixed', 
// // //               left: `${dialpadPosition.x}px`, 
// // //               top: `${dialpadPosition.y}px`, 
// // //               background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', // Match dialpad gradient
// // //               padding: '2px',
// // //               borderRadius: '10px', 
// // //               zIndex: 1001,
// // //               boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
// // //             }} 
// // //             onClick={(e) => e.stopPropagation()}
// // //           >
// // //             <div 
// // //               style={{ 
// // //                 display: 'flex', 
// // //                 justifyContent: 'space-between', 
// // //                 alignItems: 'center', 
// // //                 marginBottom: '10px',
// // //                 cursor: 'move',
// // //                 padding: '5px 0'
// // //               }} 
// // //               onMouseDown={handleMouseDown}
// // //             >
// // //             </div>
// // //             <Dialpad
// // //               phoneNumber={currentPhoneNumber} 
// // //               onClose={() => setShowDialpad(false)}
// // //               telnyxClient={telnyxClient}
// // //               currentCall={currentCall}
// // //               onMakeCall={makeTelnyxCall}
// // //               onEndCall={endTelnyxCall}
// // //               telnyxConnected={telnyxConnected}
// // //             />
// // //           </div>
// // //         </>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default Homepage;

// import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
// import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle, Trash2 } from "lucide-react";
// import LeadDetails from "./Leaddetails";
// import TimelineComponent from "./Header";
// import Reports from "./Reports";
// import Dialpad from "./SmsEmail/Dialpad";

// const allColumns = [
//   { key: "Sales_Agent", label: "Sales Agent" },
//   { key: "Customer_Name", label: "Lead Name" },
//   { key: "Move_Date", label: "Move Date" },
//   { key: "Status", label: "Estimate Status" },
//   { key: "OriginCity", label: "From Province" },
//   { key: "DestinationCity", label: "To Province" },
//   { key: "FollowUpDate", label: "Follow Up Date" },
//   { key: "Move_Size", label: "Move Size" },
//   { key: "Lead_Status", label: "Lead Status" },
//   { key: "Move_Type", label: "Move Type" },
//   { key: "Estimate_Amount", label: "Estimate Amount" },
//   { key: "From_Postcode", label: "From Postcode" },
//   { key: "To_Postcode", label: "To Postcode" },
//   { key: "Received_Date_EST", label: "Received Date EST" },
//   { key: "Banner", label: "Banner" },
//   { key: "Lead_Priority", label: "Lead Priority" },
//   { key: "Received_Time_IST", label: "Received Time IST" },
// ];

// const defaultFilters = [
//   { key: 'all', label: 'All', color: '#007bff' },
//   { key: 'today', label: 'Today\'s Follow-up', color: '#28a745' },
//   { key: 'noFollowUp', label: 'No Follow-up Date', color: '#dc3545' }
// ];

// const businessNumber = '+16478463028'; // Define here for consistency

// const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
//   const [showReports, setShowReports] = useState(false);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [width, setWidth] = useState(350);
//   const [showFilter, setShowFilter] = useState(false);
//   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
//   const [columnFilters, setColumnFilters] = useState({});
//   const [selectedColumns, setSelectedColumns] = useState(
//     allColumns.slice(0, 7).map((col) => col.key)
//   );
//   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
//   const [isDefaultSort, setIsDefaultSort] = useState(false);
//   const [currentFilter, setCurrentFilter] = useState('all');
//   const [savedFilters, setSavedFilters] = useState([]);
//   const [showSaveModal, setShowSaveModal] = useState(false);
//   const [filterName, setFilterName] = useState('');
//   const filterRef = useRef(null);
//   const isResizing = useRef(false);
//   const [userMap, setUserMap] = useState({});
//   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
//   const prevSelectedLeadId = useRef(null);
//   const [allNotes, setAllNotes] = useState([]);

//   const [telnyxClient, setTelnyxClient] = useState(null);
//   const [telnyxConnected, setTelnyxConnected] = useState(false);
//   const [currentCall, setCurrentCall] = useState(null);
//   const telnyxLogRef = useRef(null);

//   const [showDialpad, setShowDialpad] = useState(false);
//   const [currentPhoneNumber, setCurrentPhoneNumber] = useState('');
//   const [dialpadPosition, setDialpadPosition] = useState({ x: window.innerWidth / 2 - 150, y: window.innerHeight / 2 - 200 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
//   const dialpadRef = useRef(null);

//   const todayStr = useMemo(() => {
//     const now = new Date();
//     return now.toLocaleString('en-CA', { 
//       timeZone: 'America/Toronto', 
//       year: 'numeric', 
//       month: '2-digit', 
//       day: '2-digit' 
//     }).split(',')[0].split('/').reverse().join('-');
//   }, []);

//   const notesByLead = React.useMemo(() => {
//     const map = {};
//     allNotes.forEach((note) => {
//       const id = note.LeadACVLRecordID;
//       if (id) {
//         if (!map[id]) {
//           map[id] = { notes: [], latestByCategory: {} };
//         }
//         map[id].notes.push(note);
//       }
//     });
//     Object.keys(map).forEach((leadId) => {
//       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
//       const categoryMap = {};
//       map[leadId].notes.forEach((note) => {
//         const category = note.Category?.toLowerCase() || "";
//         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
//           categoryMap[category] = note;
//         }
//       });
//       map[leadId].latestByCategory = categoryMap;
//     });
//     return map;
//   }, [allNotes]);

//   const getFollowUpDates = useCallback((item) => {
//     const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
//     const categories = leadNotesData.latestByCategory;
//     const followUpDates = [];
//     if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
//       const noteDate = categories["next follow-up"].Category_Details.split('T')[0];
//       if (noteDate) followUpDates.push(noteDate);
//     }
//     if (item.FollowUpDate) {
//       const itemDate = item.FollowUpDate.split('T')[0];
//       if (itemDate && !followUpDates.includes(itemDate)) {
//         followUpDates.push(itemDate);
//       }
//     }
//     return followUpDates;
//   }, [notesByLead]);

//   const counts = useMemo(() => {
//     const total = data.length;
//     let todayCount = 0;
//     let noFollowUpCount = 0;
//     data.forEach(item => {
//       const followUpDates = getFollowUpDates(item);
//       const hasToday = followUpDates.includes(todayStr);
//       const hasNo = followUpDates.length === 0;
//       if (hasToday) todayCount++;
//       if (hasNo) noFollowUpCount++;
//     });
//     return { total, today: todayCount, noFollowUp: noFollowUpCount };
//   }, [data, getFollowUpDates, todayStr]);

//   const updateLeadData = (updatedBooking) => {
//     setData((prevData) =>
//       prevData.map((lead) =>
//         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
//           ? { ...lead, ...updatedBooking }
//           : lead
//       )
//     );
//     setFilteredData((prevFilteredData) =>
//       prevFilteredData.map((lead) =>
//         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
//           ? { ...lead, ...updatedBooking }
//           : lead
//       )
//     );
//     if (
//       selectedBooking &&
//       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
//     ) {
//       setSelectedBooking(updatedBooking);
//     }
//   };

//   const refetchNotes = () => {
//     fetchAllNotes();
//   };

//   const formatFollowUpDate = (date) => {
//     if (!date) return "N/A";
//     return date.replace("T", " ");
//   };

//   const handleDefaultSort = () => {
//     setSearchQuery("");
//     setColumnFilters({});
//     setIsGlobalSearch(false);
//     setCurrentFilter('all');
//     setIsDefaultSort(true);
//     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
//     fetchLeads();
//   };
//   const updateUserpreference = async (headers, tabFilter, savedFilters) => {
//       try {
//         const payload = { 
//           Userpreference: { 
//             Headers: headers,
//             TabFilter: tabFilter,
//             SavedFilters: savedFilters
//           } 
//         };
//         await fetch("https://salesjet-10097049716.development.catalystappsail.com/userdata", {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         });
//       } catch (err) {
//         console.error("Error updating preferences:", err);
//       }
//   };

//   const savePreferences = useCallback((headers, tabFilter, savedFilters) => {
//     const prefs = { Headers: headers, TabFilter: tabFilter, SavedFilters: savedFilters };
//     localStorage.setItem("Userpreference", JSON.stringify(prefs));
//     updateUserpreference(headers, tabFilter, savedFilters);
//   }, [accessToken]);
  
//   const loadPreferences = () => {
//     try {
//       const stored = localStorage.getItem("Userpreference");
//       console.log("Loaded preferences from localStorage:", stored);
//       let headers, tabFilter, savedFilters;
//       if (stored) {
//         const parsed = JSON.parse(stored);
//         headers = parsed.Headers || null;
//         tabFilter = parsed.TabFilter || 'all';
//         savedFilters = parsed.SavedFilters ;
//       }
//       if (!headers || !Array.isArray(headers) || headers.length === 0) {
//         headers = allColumns.slice(0, 7).map((col) => col.label);
//       }
//       const keys = headers
//         .map((label) => {
//           const col = allColumns.find((c) => c.label === label);
//           return col ? col.key : null;
//         })
//         .filter(Boolean);
//       setSelectedColumns(keys);
//       setCurrentFilter(tabFilter);
//       setSavedFilters(savedFilters);
//       savePreferences(headers, tabFilter, savedFilters);
//     } catch (err) {
//       console.error(err);
//       const headers = allColumns.slice(0, 7).map((col) => col.label);
//       const tabFilter = 'all';
//       const savedFilters = [];
//       const prefs = { Headers: headers, TabFilter: tabFilter, SavedFilters: savedFilters };
//       localStorage.setItem("Userpreference", JSON.stringify(prefs));
//       savePreferences(headers, tabFilter, savedFilters);
//       setSelectedColumns(allColumns.slice(0, 7).map((col) => col.key));
//       setCurrentFilter(tabFilter);
//       setSavedFilters(savedFilters);
//     }
//   };

//   useEffect(() => {
//     if (accessToken) {
//       loadPreferences();
//     }
//   }, [accessToken, savePreferences]);

//   // Auto-save when currentFilter or selectedColumns change
//   useEffect(() => {
//     const headers = selectedColumns.map((key) => {
//       const col = allColumns.find((c) => c.key === key);
//       return col ? col.label : "";
//     });
//     savePreferences(headers, currentFilter, savedFilters);
//   }, [currentFilter, selectedColumns, savedFilters, savePreferences]);

//   const handleSaveNewFilter = () => {
//     if (!filterName.trim()) return;
//     const newFilter = {
//       name: filterName.trim(),
//       searchQuery,
//       columnFilters
//     };
//     const updatedSavedFilters = [...savedFilters, newFilter];
//     setSavedFilters(updatedSavedFilters);
//     setFilterName('');
//     setShowSaveModal(false);
//     // Save will be triggered by useEffect
//   };

//   const handleApplySavedFilter = (savedFilter) => {
//     setSearchQuery(savedFilter.searchQuery || '');
//     setColumnFilters(savedFilter.columnFilters || {});
//     setCurrentFilter(savedFilter.name);
//     setIsGlobalSearch(false);
//   };

//   const handleDeleteFilter = (name) => {
//     const updatedSavedFilters = savedFilters.filter(f => f.name !== name);
//     setSavedFilters(updatedSavedFilters);
//     if (currentFilter === name) {
//       setCurrentFilter('all');
//       setSearchQuery('');
//       setColumnFilters({});
//     }
//     // Save will be triggered by useEffect
//   };

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const response = await fetch(
//           "https://salesjet-10097049716.development.catalystappsail.com/userdata",
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         if (!response.ok) throw new Error(`Error: ${response.status}`);
//         const result = await response.json();
//         const userMapping = result.data.reduce((acc, user) => {
//           acc[user.userId] = user.pseudoname;
//           return acc;
//         }, {});
//         setUserMap(userMapping);
//       } catch (err) {
//         console.error("Error fetching user data:", err.message);
//       }
//     };
//     fetchUserData();
//   }, [accessToken]);

//   const loadTelnyxScripts = () => {
//     return new Promise((resolve, reject) => {
//       const scripts = [
//         { id: 'webrtc-adapter', src: 'https://webrtc.github.io/adapter/adapter-latest.js' },
//         { id: 'telnyx-webrtc', src: 'https://unpkg.com/@telnyx/webrtc@2.9.0/lib/bundle.js' }
//       ];

//       let loadedCount = 0;
//       const totalScripts = scripts.length;

//       const loadScript = (script) => {
//         return new Promise((scriptResolve, scriptReject) => {
//           if (document.getElementById(script.id)) {
//             scriptResolve(); // Already loaded
//             return;
//           }

//           const scriptElement = document.createElement('script');
//           scriptElement.id = script.id;
//           scriptElement.src = script.src;
//           scriptElement.async = true;
//           scriptElement.onload = () => {
//             scriptResolve();
//           };
//           scriptElement.onerror = () => {
//             scriptReject(new Error(`Failed to load ${script.src}`));
//           };
//           document.head.appendChild(scriptElement);
//         });
//       };

//       const loadAll = async () => {
//         for (const script of scripts) {
//           try {
//             await loadScript(script);
//             loadedCount++;
//           } catch (err) {
//             reject(err);
//             return;
//           }
//         }
//         if (loadedCount === totalScripts) {
//           resolve();
//         }
//       };

//       loadAll();
//     });
//   };

//   const logTelnyx = (msg) => {
//     console.log(msg);
//   };

//   const connectTelnyx = async () => {
//     const token = localStorage.getItem('telnyxToken');
//     const userStr = localStorage.getItem('user');
//     if (!token || !userStr) {
//       logTelnyx("Telnyx Token or User data missing in localStorage");
//       return;
//     }

//     const user = JSON.parse(userStr);
//     const name = user.firstName;
//     if (!name) {
//       logTelnyx("Agent firstName missing in user data");
//       return;
//     }

//     try {
//       // Load scripts if not already loaded
//       await loadTelnyxScripts();

//       // Check if library is available after loading
//       if (window.TelnyxWebRTC && window.TelnyxWebRTC.TelnyxRTC) {
//         const client = new window.TelnyxWebRTC.TelnyxRTC({ login_token: token });

//         client.on('telnyx.ready', () => {
//           setTelnyxConnected(true);
//           logTelnyx(`Connected as ${name}`);
//         });

//         client.on('telnyx.error', (e) => {
//           logTelnyx(`Error: ${e.message}`);
//           setTelnyxConnected(false);
//         });

//         client.on('telnyx.notification', (n) => {
//           if (n.call) {
//             setCurrentCall(n.call);

//             if (n.call.state === 'ringing') {
//               logTelnyx("📞 Incoming Call...");
//               const incomingNum = n.call.options?.remoteCallerNumber || '';
//               setCurrentPhoneNumber(incomingNum);
//               setShowDialpad(true);
//             }

//             if (n.call.state === 'active') {
//               logTelnyx("Call Active");
//             }

//             if (n.call.state === 'destroy') {
//               logTelnyx("📴 Call Ended");
//               setCurrentCall(null);
//               setShowDialpad(false);
//               setTelnyxConnected(true); // Re-enable connection
//             }
//           }
//         });

//         client.connect();
//         setTelnyxClient(client);
//       } else {
//         throw new Error("TelnyxWebRTC library still not loaded after script injection");
//       }
//     } catch (e) {
//       logTelnyx(`Connection Error: ${e.message}`);
//       setTelnyxConnected(false);
//     }
//   };

//   useEffect(() => {
//     connectTelnyx();
//   }, []);

//   const makeTelnyxCall = (destinationNumber, fromNumber) => {
//     if (telnyxClient && destinationNumber) {
//       const callOptions = {
//         destinationNumber: destinationNumber,
//         callerNumber: businessNumber, // Use business number
//       };
//       const call = telnyxClient.newCall(callOptions); // Use newCall as per docs
//       setCurrentCall(call);
//       logTelnyx(`Calling ${destinationNumber}`);
//       return call;
//     }
//     return null;
//   };

//   const endTelnyxCall = () => {
//     if (currentCall) {
//       currentCall.hangup();
//       setCurrentCall(null);
//     }
//   };

//   const fetchLeads = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(
//         "https://salesjet-10097049716.development.catalystappsail.com/leadsdata",
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (!response.ok) throw new Error(`Error: ${response.status}`);
//       const result = await response.json();
//       const leads = Array.isArray(result.data) ? result.data : [];
//       setData(leads);
//       setFilteredData(leads);
//     } catch (err) {
//       setError(err.message);
//       console.error("Error fetching leads:", err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAllNotes = async () => {
//     try {
//       const response = await fetch(
//         "https://salesjet-10097049716.development.catalystappsail.com/allleadnotes",
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (!response.ok) throw new Error(`Error: ${response.status}`);
//       const result = await response.json();
//       setAllNotes(Array.isArray(result.data) ? result.data : []);
//     } catch (err) {
//       console.error("Error fetching all lead notes:", err.message);
//     }
//   };

//   useEffect(() => {
//     if (!isGlobalSearch) {
//       fetchLeads();
//       fetchAllNotes();
//     }
//   }, [accessToken, isGlobalSearch]);

//   useEffect(() => {
//     handleDefaultSort();
//   }, []);

//   useEffect(() => {
//     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
//       prevSelectedLeadId.current = selectedLeadId;
//       setIsGlobalSearch(true);
//       setColumnFilters({});
//       handleGlobalSearch(selectedLeadId.toString());
//     }
//   }, [selectedLeadId]);

//   useEffect(() => {
//     if (selectedLeadId && filteredData.length > 0) {
//       const matchingLead = filteredData.find(
//         (lead) =>
//           lead.LeadACVLRecordID &&
//           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
//       );
//       if (matchingLead) {
//         setSelectedBooking(matchingLead);
//         setWidth(700);
//       } else {
//         setSelectedBooking(null);
//       }
//     } else if (selectedLeadId && filteredData.length === 0) {
//       setSelectedBooking(null);
//     }
//   }, [filteredData, selectedLeadId]);

//   useEffect(() => {
//     if (isGlobalSearch) {
//       return;
//     }
//     let filtered = [...data];
//     const normalizedQuery = searchQuery.toLowerCase().trim();
//     if (normalizedQuery === 'today') {
//       // Special filter for Move_Date today
//       filtered = filtered.filter((item) => 
//         item.Move_Date && item.Move_Date.split('T')[0] === todayStr
//       );
//     } else if (searchQuery.trim()) {
//       filtered = filtered.filter((lead) =>
//         Object.entries(lead).some(([key, value]) => {
//           if (!value) return false;
//           const normalizedValue = value
//             .toString()
//             .replace(/[^a-zA-Z0-9]/g, "")
//             .toLowerCase();
//           return normalizedValue.includes(normalizedQuery.replace(/[^a-zA-Z0-9]/g, ""));
//         })
//       );
//     }
//     Object.keys(columnFilters).forEach((key) => {
//       const rawFilter = columnFilters[key];
//       if (rawFilter) {
//         const trimmedRawFilter = rawFilter.trim();
//         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
//         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
//         if (isNAFilter) {
//           filtered = filtered.filter((lead) => {
//             const value = lead[key];
//             return value === null || value === undefined || value === "" || value === "N/A";
//           });
//         } else if (normalizedFilter) {
//           filtered = filtered.filter((lead) => {
//             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
//             return value?.includes(normalizedFilter);
//           });
//         }
//       }
//     });
//     // Apply current filter if it's a default one
//     if (defaultFilters.some(f => f.key === currentFilter)) {
//       if (currentFilter !== 'all') {
//         filtered = filtered.filter(item => {
//           const followUpDates = getFollowUpDates(item);
//           if (currentFilter === 'today') {
//             return followUpDates.includes(todayStr);
//           } else if (currentFilter === 'noFollowUp') {
//             return followUpDates.length === 0;
//           }
//           return true;
//         });
//       }
//     }
//     setFilteredData(filtered);
//   }, [data, searchQuery, columnFilters, isGlobalSearch, currentFilter, getFollowUpDates, todayStr]);

//   const handleSearchChange = (query) => {
//     setSearchQuery(query);
//     setIsGlobalSearch(false);
//     setCurrentFilter('all');
//   };

//   const handleGlobalSearch = async (query) => {
//     setLoading(true);
//     setIsDefaultSort(false);
//     setIsGlobalSearch(true);
//     setCurrentFilter('all');
//     try {
//       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
//       const response = await fetch(
//         "https://salesjet-10097049716.development.catalystappsail.com/globalsearch",
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ query: normalizedQuery }),
//         }
//       );
//       if (!response.ok) throw new Error(`Error: ${response.status}`);
//       const result = await response.json();
//       const leads = Array.isArray(result.data) ? result.data : [];
//       setFilteredData(leads);
//       setSearchQuery(query);
//       fetchAllNotes();
//     } catch (err) {
//       console.error("Global search error:", err.message);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSort = (key) => {
//     setIsDefaultSort(false);
//     setSortConfig((prev) =>
//       prev.key === key
//         ? {
//             key,
//             direction: prev.direction === "ascending" ? "descending" : "ascending",
//           }
//         : { key, direction: "ascending" }
//     );
//   };

//   const handleColumnChange = (event) => {
//     const value = event.target.value;
//     setSelectedColumns((prev) => {
//       let newSelected;
//       if (prev.includes(value)) {
//         newSelected = prev.filter((col) => col !== value);
//       } else {
//         newSelected = prev.length < 7 ? [...prev, value] : prev;
//       }
//       // The save will be handled by useEffect
//       return newSelected;
//     });
//   };

//   const handleSaveFilter = () => {
//     setShowSaveModal(true);
//   };

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (isDefaultSort) {
//       // Get current date in EST (America/Toronto)
//       const now = new Date();
//       const todayStrLocal = now.toLocaleString('en-CA', { 
//         timeZone: 'America/Toronto', 
//         year: 'numeric', 
//         month: '2-digit', 
//         day: '2-digit' 
//       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

//       // Custom sorting logic
//       sortableData.sort((a, b) => {
//         const isUnassignedA = a.Status === null || a.Status === undefined;
//         const isUnassignedB = b.Status === null || b.Status === undefined;
//         const timeA = a.Received_Date_EST;
//         const timeB = b.Received_Date_EST;
//         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
//         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

//         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
//         if (isUnassignedA && timeA === todayStrLocal && (!isUnassignedB || timeB !== todayStrLocal)) {
//           return -1;
//         }
//         if (isUnassignedB && timeB === todayStrLocal && (!isUnassignedA || timeA !== todayStrLocal)) {
//           return 1;
//         }

//         // Step 2: Leads with FollowUpDate date as today (EST)
//         if (followUpA === todayStrLocal && followUpB !== todayStrLocal) return -1;
//         if (followUpB === todayStrLocal && followUpA !== todayStrLocal) return 1;

//         // Step 3: Sort by LeadACVLRecordID descending as fallback
//         const idA = Number(a.LeadACVLRecordID || 0);
//         const idB = Number(b.LeadACVLRecordID || 0);
//         return idB - idA;
//       });
//     } else if (sortConfig.key) {
//       sortableData.sort((a, b) => {
//         let aVal = a[sortConfig.key];
//         let bVal = b[sortConfig.key];
//         // Handle null or undefined values
//         if (aVal === undefined || aVal === null) return 1;
//         if (bVal === undefined || bVal === null) return -1;
//         // Handle LeadACVLRecordID specifically as a number
//         if (sortConfig.key === "LeadACVLRecordID") {
//           aVal = Number(aVal);
//           bVal = Number(bVal);
//           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
//         }
//         // Handle date fields
//         const isDateField = [
//           "Move_Date",
//           "Received_Date_EST",
//           "Received_Time_IST",
//           "FollowUpDate",
//         ].includes(sortConfig.key);
//         if (isDateField) {
//           const dateA = new Date(aVal);
//           const dateB = new Date(bVal);
//           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
//         }
//         // Handle string fields
//         if (typeof aVal === "string" && typeof bVal === "string") {
//           return sortConfig.direction === "ascending"
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(bVal);
//         }
//         // Handle numeric fields
//         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, isDefaultSort]);

//   const startResizing = (e) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", resize);
//     document.addEventListener("mouseup", stopResizing);
//   };

//   const resize = (e) => {
//     if (!isResizing.current) return;
//     const minWidth = 500;
//     const maxWidth = window.innerWidth * 0.7;
//     let newWidth = window.innerWidth - e.clientX;
//     if (newWidth >= minWidth && newWidth <= maxWidth) {
//       setWidth(newWidth);
//     }
//   };

//   const stopResizing = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", resize);
//     document.removeEventListener("mouseup", stopResizing);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (filterRef.current && !filterRef.current.contains(event.target)) {
//         setShowFilter(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleMouseDown = (e) => {
//     setIsDragging(true);
//     const rect = dialpadRef.current.getBoundingClientRect();
//     setDragOffset({
//       x: e.clientX - rect.left,
//       y: e.clientY - rect.top
//     });
//   };

//   const handleMouseMove = (e) => {
//     if (!isDragging) return;
//     setDialpadPosition({
//       x: e.clientX - dragOffset.x,
//       y: e.clientY - dragOffset.y
//     });
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener('mousemove', handleMouseMove);
//       document.addEventListener('mouseup', handleMouseUp);
//     }
//     return () => {
//       document.removeEventListener('mousemove', handleMouseMove);
//       document.removeEventListener('mouseup', handleMouseUp);
//     };
//   }, [isDragging, dragOffset]);

//   const openDialpad = (phone = '') => {
//     setCurrentPhoneNumber(phone);
//     setShowDialpad(true);
//   };

//   const getFilterCount = (filterKey) => {
//     if (filterKey === 'all') return counts.total;
//     if (filterKey === 'today') return counts.today;
//     if (filterKey === 'noFollowUp') return counts.noFollowUp;
//     // For saved filters, compute on the fly if needed, but skip for now
//     return null;
//   };

//   const getFilterStyle = (filterKey) => {
//     const defFilter = defaultFilters.find(f => f.key === filterKey);
//     if (defFilter) {
//       return {
//         background: currentFilter === filterKey ? defFilter.color : 'transparent',
//         color: currentFilter === filterKey ? 'white' : defFilter.color,
//         border: `1px solid ${defFilter.color}`,
//       };
//     }
//     // For saved
//     return {
//       background: currentFilter === filterKey ? '#6c757d' : 'transparent',
//       color: currentFilter === filterKey ? 'white' : '#6c757d',
//       border: '1px solid #6c757d',
//     };
//   };

//   const computeSavedFilterCount = useCallback((saved) => {
//     let filtered = [...data];
//     const normalizedQuery = saved.searchQuery?.toLowerCase().trim() || '';
//     if (normalizedQuery === 'today') {
//       filtered = filtered.filter((item) => 
//         item.Move_Date && item.Move_Date.split('T')[0] === todayStr
//       );
//     } else if (saved.searchQuery?.trim()) {
//       filtered = filtered.filter((lead) =>
//         Object.entries(lead).some(([key, value]) => {
//           if (!value) return false;
//           const normalizedValue = value
//             .toString()
//             .replace(/[^a-zA-Z0-9]/g, "")
//             .toLowerCase();
//           return normalizedValue.includes(normalizedQuery.replace(/[^a-zA-Z0-9]/g, ""));
//         })
//       );
//     }
//     Object.keys(saved.columnFilters || {}).forEach((key) => {
//       const rawFilter = saved.columnFilters[key];
//       if (rawFilter) {
//         const trimmedRawFilter = rawFilter.trim();
//         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
//         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
//         if (isNAFilter) {
//           filtered = filtered.filter((lead) => {
//             const value = lead[key];
//             return value === null || value === undefined || value === "" || value === "N/A";
//           });
//         } else if (normalizedFilter) {
//           filtered = filtered.filter((lead) => {
//             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
//             return value?.includes(normalizedFilter);
//           });
//         }
//       }
//     });
//     return filtered.length;
//   }, [data, todayStr]);

//   const savedFilterCounts = useMemo(() => 
//     savedFilters.map(saved => computeSavedFilterCount(saved)), 
//     [savedFilters, computeSavedFilterCount]
//   );

//   return (
//     <div style={{ position: 'relative' }}>
//       <>
//         <TimelineComponent
//           userDetails={userDetails}
//           accessToken={accessToken}
//           onSearchChange={handleSearchChange}
//           onGlobalSearch={handleGlobalSearch}
//           connectionStatus={connectionStatus}
//           telnyxConnected={telnyxConnected}
//           onShowReports={() => setShowReports(true)}
//           onListView={() => setShowReports(false)}
//         />
//         <div className="filter-bar" style={{
//           display: 'flex',
//           alignItems: 'center',
//           backgroundColor: '#f8f9fa',
//           borderBottom: '1px solid #dee2e6',
//           fontSize: '14px',
//           fontWeight: '500',
//           flexWrap: 'wrap',
//           gap: '8px'
//         }}>
//           {defaultFilters.map((filter) => {
//             const count = getFilterCount(filter.key);
//             return (
//               <button 
//                 key={filter.key}
//                 onClick={() => setCurrentFilter(filter.key)} 
//                 className={currentFilter === filter.key ? 'active' : ''} 
//                 style={{
//                   ...getFilterStyle(filter.key),
//                   display: 'flex',
//                   alignItems: 'center',
//                   width: '120px',
//                   padding: '4px 8px',
//                   borderRadius: '4px',
//                   cursor: 'pointer',
//                   marginRight: '4px',
//                   justifyContent: 'space-between'
//                 }}
//                 title={`${filter.label}${count !== null ? ` (${count})` : ''}`}
//               >
//                 <span 
//                   style={{
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     whiteSpace: 'nowrap',
//                     flex: 1
//                   }}
//                 >
//                   {filter.label}
//                 </span>
//                 {count !== null && (
//                   <span 
//                     style={{
//                       marginLeft: '4px',
//                       whiteSpace: 'nowrap',
//                       fontWeight: 'bold'
//                     }}
//                   >
//                     ({count})
//                   </span>
//                 )}
//               </button>
//             );
//           })}
//           {savedFilters.map((saved, index) => {
//             const count = savedFilterCounts[index];
//             return (
//               <div key={saved.name} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//                 <button 
//                   onClick={() => handleApplySavedFilter(saved)} 
//                   className={currentFilter === saved.name ? 'active' : ''} 
//                   style={{
//                     ...getFilterStyle(saved.name),
//                     display: 'flex',
//                     alignItems: 'center',
//                     width: '120px',
//                     padding: '4px 8px',
//                     borderRadius: '4px',
//                     cursor: 'pointer',
//                     justifyContent: 'space-between'
//                   }}
//                   title={`${saved.name}${count ? ` (${count})` : ''}`}
//                 >
//                   <span 
//                     style={{
//                       overflow: 'hidden',
//                       textOverflow: 'ellipsis',
//                       whiteSpace: 'nowrap',
//                       flex: 1
//                     }}
//                   >
//                     {saved.name}
//                   </span>
//                   {count !== null && count > 0 && (
//                     <span 
//                       style={{
//                         marginLeft: '4px',
//                         whiteSpace: 'nowrap',
//                         fontWeight: 'bold'
//                       }}
//                     >
//                       ({count})
//                     </span>
//                   )}
//                 </button>
//                 <button 
//                   onClick={() => handleDeleteFilter(saved.name)}
//                   style={{
//                     background: 'none',
//                     border: 'none',
//                     cursor: 'pointer',
//                     padding: '2px',
//                     color: '#dc3545',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}
//                   title="Delete filter"
//                 >
//                   <Trash2 size={16} />
//                 </button>
//               </div>
//             );
//           })}
//           <button 
//             onClick={() => setShowAdvancedFilter(true)}
//             style={{
//               background: 'transparent',
//               color: '#6c757d',
//               border: '1px solid #6c757d',
//               padding: '4px 8px',
//               borderRadius: '4px',
//               cursor: 'pointer'
//             }}
//           >
//             + Add more filters
//           </button>
//         </div>
//       </>     
//       {showSaveModal && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backgroundColor: 'rgba(0,0,0,0.5)',
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           zIndex: 1002
//         }}>
//           <div style={{
//             background: 'white',
//             padding: '20px',
//             borderRadius: '8px',
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '10px'
//           }}>
//             <label>Filter Name:</label>
//             <input
//               type="text"
//               value={filterName}
//               onChange={(e) => setFilterName(e.target.value)}
//               style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
//             />
//             <div style={{ display: 'flex', gap: '10px' }}>
//               <button onClick={handleSaveNewFilter} style={{ padding: '8px 16px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}>Save</button>
//               <button onClick={() => { setShowSaveModal(false); setFilterName(''); }} style={{ padding: '8px 16px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px' }}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showReports && (
//         <>
//           <Reports />
//         </>
//       )}
//       {!showReports && (
//         <div className="table-container">
//           <div
//             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
//             style={{ flex: selectedBooking ? "1" : "2" }}
//           >
//             <div>
//               <div className="bookings-header-my">
//                 <span
//                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
//                   onClick={() => handleSort("LeadACVLRecordID")}
//                   style={{ cursor: "pointer" }}
//                 >
//                   ACVL LeadID
//                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
//                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
//                 </span>
//                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
//                   (colKey) => {
//                     const column = allColumns.find((c) => c.key === colKey);
//                     const isSorted = sortConfig.key === colKey;
//                     return column ? (
//                       <span
//                         key={colKey}
//                         className="sortable-header"
//                         onClick={() => handleSort(colKey)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         {column.label}
//                         {!isDefaultSort && isSorted &&
//                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
//                       </span>
//                     ) : null;
//                   }
//                 )}
//                 <span2>
//                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
//                     <div>
//                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
//                     </div>
//                     <div>
//                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
//                     </div>
//                     <div>
//                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
//                     </div>
//                     <div>
//                       <Search
//                         className="filter-icon"
//                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
//                         title="Advanced column search"
//                       />
//                     </div>
//                   </div>
//                 </span2>
//                 {showFilter && (
//                   <div className="filter-dropdown" ref={filterRef}>
//                     {allColumns.map((col) => (
//                       <label key={col.key}>
//                         <input
//                           type="checkbox"
//                           value={col.key}
//                           checked={selectedColumns.includes(col.key)}
//                           onChange={handleColumnChange}
//                           disabled={
//                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
//                           }
//                         />
//                         {col.label}
//                       </label>
//                     ))}
//                   </div>
//                 )}
//               </div>
//               {showAdvancedFilter && (
//                 <div className="column-filter-row">
//                   <span className="filter-input">
//                     <input
//                       placeholder="Lead ID"
//                       value={columnFilters["LeadACVLRecordID"] || ""}
//                       onChange={(e) =>
//                         setColumnFilters({
//                           ...columnFilters,
//                           LeadACVLRecordID: e.target.value,
//                         })
//                       }
//                     />
//                   </span>
//                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
//                     (colKey) => (
//                       <span key={colKey} className="filter-input">
//                         <input
//                           placeholder={
//                             allColumns.find((col) => col.key === colKey)?.label || colKey
//                           }
//                           value={columnFilters[colKey] || ""}
//                           onChange={(e) =>
//                             setColumnFilters({
//                               ...columnFilters,
//                               [colKey]: e.target.value,
//                             })
//                           }
//                         />
//                       </span>
//                     )
//                   )}
//                   <span className="filter-input">
//                   <button 
//                     onClick={handleSaveFilter}
//                     style={{
//                       background: '#17a2b8',
//                       color: 'white',
//                       border: '1px solid #17a2b8',
//                       padding: '8px 12px',
//                       borderRadius: '4px',
//                       cursor: 'pointer',
//                       marginLeft: 'auto',
//                       whiteSpace: 'nowrap',
//                       float: 'right',
//                       alignSelf: 'center'
//                     }}
//                   >
//                     Save Filter
//                   </button>
//                   </span>
//                 </div>
//               )}
//               {loading && <p>Loading...</p>}
//               {error && <p className="error">{error}</p>}
//               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
//               {!loading &&
//                 !error &&
//                 sortedData.map((item, index) => {
//                   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
//                   const categories = leadNotesData.latestByCategory;
//                   let flags = [];
//                   const now = new Date();
//                   const todayStrLocal = now.toLocaleString('en-CA', { 
//                     timeZone: 'America/Toronto', 
//                     year: 'numeric', 
//                     month: '2-digit', 
//                     day: '2-digit' 
//                   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
//                   const isUnassignedToday =
//                     (item.Status === null || item.Status === undefined) &&
//                     item.Received_Date_EST &&
//                     item.Received_Date_EST.split(' ')[0] === todayStrLocal;
//                   const isUnassignedall =
//                     (item.Status === null || item.Status === undefined) &&
//                     item.Received_Date_EST &&
//                     item.Received_Date_EST.split(' ')[0] !== todayStrLocal;
//                   let isTodayFollowUp = false;

//                   // Collect and process follow-up dates
//                   const followUpDates = [];
                  
//                   // Add follow-up date from notes (next follow-up category)
//                   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
//                     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
//                     if (noteDate) {
//                       followUpDates.push(noteDate);
//                     }
//                   }

//                   // Add follow-up date from item.FollowUpDate
//                   if (item.FollowUpDate) {
//                     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
//                     if (itemDate && !followUpDates.includes(itemDate)) {
//                       followUpDates.push(itemDate);
//                     }
//                   }

//                   // Select the most relevant follow-up date
//                   let selectedFollowUpDate = null;
//                   if (followUpDates.length > 0) {
//                     // Prioritize: today's date, then past date, then future date
//                     const today = new Date(todayStrLocal);
//                     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
//                       const followUpDate = new Date(dateStr);
//                       if (!selected) return dateStr;
//                       const selectedDate = new Date(selected);
//                       if (dateStr === todayStrLocal) return dateStr; // Prioritize today's date
//                       if (selected === todayStrLocal) return selected;
//                       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
//                       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
//                       return selected; // Keep first date if no priority
//                     }, null);

//                     if (selectedFollowUpDate) {
//                       const followUpDate = new Date(selectedFollowUpDate);
//                       isTodayFollowUp = selectedFollowUpDate === todayStrLocal;
//                       let color;
//                       if (followUpDate < today && !isTodayFollowUp) {
//                         color = "red"; // Past date
//                       } else if (isTodayFollowUp) {
//                         color = "green"; // Today
//                       } else {
//                         color = "gray"; // Future date
//                       }
//                       flags.push({ 
//                         icon: Clock, 
//                         color, 
//                         title: `Follow-Up: ${selectedFollowUpDate}` 
//                       });
//                     }
//                   }

//                   // Process other categories
//                   Object.values(categories).forEach((note) => {
//                     if (note && note.Category?.toLowerCase() !== "next follow-up") {
//                       const category = note.Category?.toLowerCase() || "";
//                       const categoryDetails = note.Category_Details?.toLowerCase() || "";
//                       if (category === "connection status") {
//                         if (categoryDetails === "connected") {
//                           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
//                         } else if (categoryDetails === "not connected") {
//                           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
//                         }
//                       } else if (category === "prospective") {
//                         if (categoryDetails === "hot") {
//                           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
//                         } else if (categoryDetails === "warm") {
//                           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
//                         } else if (categoryDetails === "cold") {
//                           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
//                         }
//                       }
//                     }
//                   });

//                   // Process Lead_Priority for left side icon
//                   let priorityFlag = null;
//                   if (item.Lead_Priority) {
//                     const priority = item.Lead_Priority.toString().toLowerCase().trim();
//                     let color, title;
//                     if (priority === "high") {
//                       color = "red";
//                       title = "High";
//                     } else if (priority === "medium") {
//                       color = "purple";
//                       title = "Medium";
//                     } else if (priority === "low") {
//                       color = "green";
//                       title = "Low";
//                     }
//                     if (color && title) {
//                       priorityFlag = { icon: Circle, color, title };
//                     }
//                   }

//                   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
//                   const orderedFlags = new Array(5).fill(null);
//                   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
//                     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
//                   }
//                   if (item.Lead_Source_Status?.toLowerCase() === "return") {
//                     if (item.Return_Outcome?.toLowerCase() === "approved") {
//                       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
//                     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
//                       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
//                     } else {
//                       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
//                     }
//                   }
//                   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
//                   if (prospectiveFlag) {
//                     orderedFlags[2] = prospectiveFlag;
//                   }
//                   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
//                   if (connectionFlag) {
//                     orderedFlags[3] = connectionFlag;
//                   }
//                   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
//                   if (followUpFlag) {
//                     orderedFlags[4] = followUpFlag;
//                   }

//                   return (
//                     <div
//                       key={index}
//                       className={`booking-item-my ${
//                         selectedBooking === item ? "active-booking" : ""
//                       } ${
//                         item.Duplicate_Lead_Details &&
//                         Object.keys(item.Duplicate_Lead_Details).length > 0
//                           ? "duplicate-item"
//                           : ""
//                       } ${
//                         item.Lead_Source_Status?.toLowerCase() === "return"
//                           ? "returned-item"
//                           : ""
//                       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
//                       onClick={() => {
//                         if (!selectedBooking) setWidth(700);
//                         setSelectedBooking(item);
//                       }}
//                       style={{
//                         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
//                         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
//                         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
//                         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
//                       }}
//                     >
//                       <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
//                         {priorityFlag && (
//                           <>
//                             <priorityFlag.icon
//                               className="icon"
//                               style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
//                               fill={priorityFlag.color}
//                               title={priorityFlag.title}
//                             />
//                             <div className="custom-tooltip1">
//                               {priorityFlag.title}
//                             </div>
//                           </>
//                         )}
//                       </div>
//                       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
//                       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
//                         (colKey) => (
//                           <span1 key={colKey}>
//                             {colKey === "AssignedUserID"
//                               ? userMap[item.AssignedUserID] || "N/A"
//                               : colKey === "FollowUpDate"
//                               ? formatFollowUpDate(item[colKey])
//                               : item[colKey] || "N/A"}
//                           </span1>
//                         )
//                       )}
//                       <span2 style={{
//                         display: "flex",
//                         gap: "8px",
//                         alignItems: "center",
//                         justifyContent: "flex-end",
//                         width: "120px",
//                       }}>
//                         {orderedFlags.map((flag, idx) => (
//                           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
//                             {flag && (
//                               <>
//                                 <flag.icon
//                                   className="icon"
//                                   style={{ color: flag.color, width: "16px", height: "16px" }}
//                                   title={flag.title}
//                                 />
//                                 <div className="custom-tooltip">
//                                   {flag.title}
//                                 </div>
//                               </>
//                             )}
//                           </div>
//                         ))}
//                       </span2>
//                     </div>
//                   );
//                 })}
//             </div>
//           </div>
//           {selectedBooking && (
//             <div className="lead-details-container" style={{ width: `${width}px` }}>
//               <div className="resize-handle" onMouseDown={startResizing}></div>
//               <LeadDetails
//                 key={selectedBooking.LeadACVLRecordID}
//                 booking={selectedBooking}
//                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
//                 onClose={() => setSelectedBooking(null)}
//                 userDetails={userDetails}
//                 accessToken={accessToken}
//                 userMap={userMap}
//                 updateLeadData={updateLeadData}
//                 refetchNotes={refetchNotes}
//                 onOpenDialpad={openDialpad}
//                 telnyxClient={telnyxClient}
//                 currentCall={currentCall}
//                 onMakeCall={makeTelnyxCall}
//                 onEndCall={endTelnyxCall}
//                 telnyxConnected={telnyxConnected}
//                 businessNumber={businessNumber}
//               />
//             </div>
//           )}
//         </div>
//       )}

//       <button 
//         onClick={() => openDialpad('')} 
//         style={{
//           position: 'fixed',
//           bottom: '20px',
//           right: '80px',
//           width: '56px',
//           height: '56px',
//           borderRadius: '50%',
//           backgroundColor: '#10b981', // Enhanced green
//           border: 'none',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//           cursor: 'pointer',
//           zIndex: 999,
//           transition: 'all 0.2s ease'
//         }}
//         title="Open Dialpad"
//       >
//         <Phone size={24} color="white" />
//       </button>

//       {showDialpad && !currentCall && (
//         <>
//           <div 
//             style={{ 
//               position: 'fixed', 
//               top: 0, 
//               left: 0, 
//               width: '100%', 
//               height: '100%', 
//               backgroundColor: 'rgba(0,0,0,0.5)', 
//               zIndex: 1000 
//             }} 
//             onClick={() => setShowDialpad(false)}
//           />
//           <div 
//             ref={dialpadRef}
//             style={{ 
//               position: 'fixed', 
//               left: `${dialpadPosition.x}px`, 
//               top: `${dialpadPosition.y}px`, 
//               background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', // Match dialpad gradient
//               padding: '2px',
//               borderRadius: '10px', 
//               zIndex: 1001,
//               boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
//             }} 
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div 
//               style={{ 
//                 display: 'flex', 
//                 justifyContent: 'space-between', 
//                 alignItems: 'center', 
//                 marginBottom: '10px',
//                 cursor: 'move',
//                 padding: '5px 0'
//               }} 
//               onMouseDown={handleMouseDown}
//             >
//             </div>
//             <Dialpad
//               phoneNumber={currentPhoneNumber} 
//               onClose={() => setShowDialpad(false)}
//               telnyxClient={telnyxClient}
//               currentCall={currentCall}
//               onEndCall={endTelnyxCall}
//               telnyxConnected={telnyxConnected}
//               businessNumber={businessNumber}
//             />
//           </div>
//         </>
//       )}

//       {currentCall && (
//         <Dialpad
//           phoneNumber={currentPhoneNumber} 
//           onClose={endTelnyxCall}
//           telnyxClient={telnyxClient}
//           currentCall={currentCall}
//           onEndCall={endTelnyxCall}
//           telnyxConnected={telnyxConnected}
//           businessNumber={businessNumber}
//         />
//       )}

//       {/* Hidden remote audio element for Telnyx - Single instance to avoid duplication/timing issues */}
//       <audio id="remoteAudio" autoPlay style={{ display: 'none' }} />
//     </div>
//   );
// };

// export default Homepage;

import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle, Trash2 } from "lucide-react";
import LeadDetails from "./Leaddetails";
import TimelineComponent from "./Header";
import Reports from "./Reports";
import Dialpad from "./SmsEmail/Dialpad";

const allColumns = [
  { key: "Sales_Agent", label: "Sales Agent" },
  { key: "Customer_Name", label: "Lead Name" },
  { key: "Move_Date", label: "Move Date" },
  { key: "Status", label: "Estimate Status" },
  { key: "OriginCity", label: "From Province" },
  { key: "DestinationCity", label: "To Province" },
  { key: "FollowUpDate", label: "Follow Up Date" },
  { key: "Move_Size", label: "Move Size" },
  { key: "Lead_Status", label: "Lead Status" },
  { key: "Move_Type", label: "Move Type" },
  { key: "Estimate_Amount", label: "Estimate Amount" },
  { key: "From_Postcode", label: "From Postcode" },
  { key: "To_Postcode", label: "To Postcode" },
  { key: "Received_Date_EST", label: "Received Date EST" },
  { key: "Banner", label: "Banner" },
  { key: "Lead_Priority", label: "Lead Priority" },
  { key: "Received_Time_IST", label: "Received Time IST" },
];

const defaultFilters = [
  { key: 'all', label: 'All', color: '#007bff' },
  { key: 'today', label: 'Today\'s Follow-up', color: '#28a745' },
  { key: 'noFollowUp', label: 'No Follow-up Date', color: '#dc3545' }
];

const businessNumber = '+16478463028'; // Define here for consistency

const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId, setUserStatus, userStatus }) => {
  const [showReports, setShowReports] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [width, setWidth] = useState(350);
  const [showFilter, setShowFilter] = useState(false);
  const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
  const [columnFilters, setColumnFilters] = useState({});
  const [selectedColumns, setSelectedColumns] = useState(
    allColumns.slice(0, 7).map((col) => col.key)
  );
  const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
  const [isDefaultSort, setIsDefaultSort] = useState(false);
  const [currentFilter, setCurrentFilter] = useState('all');
  const [savedFilters, setSavedFilters] = useState([]);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [filterName, setFilterName] = useState('');
  const filterRef = useRef(null);
  const isResizing = useRef(false);
  const [userMap, setUserMap] = useState({});
  const [isGlobalSearch, setIsGlobalSearch] = useState(false);
  const prevSelectedLeadId = useRef(null);
  const [allNotes, setAllNotes] = useState([]);

  const [telnyxClient, setTelnyxClient] = useState(null);
  const [telnyxConnected, setTelnyxConnected] = useState(false);
  const [currentCall, setCurrentCall] = useState(null);
  const telnyxLogRef = useRef(null);

  const [showDialpad, setShowDialpad] = useState(false);
  const [currentPhoneNumber, setCurrentPhoneNumber] = useState('');
  const [dialpadPosition, setDialpadPosition] = useState({ x: window.innerWidth / 2 - 150, y: window.innerHeight / 2 - 200 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const dialpadRef = useRef(null);

  const todayStr = useMemo(() => {
    const now = new Date();
    return now.toLocaleString('en-CA', { 
      timeZone: 'America/Toronto', 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit' 
    }).split(',')[0].split('/').reverse().join('-');
  }, []);

  const notesByLead = React.useMemo(() => {
    const map = {};
    allNotes.forEach((note) => {
      const id = note.LeadACVLRecordID;
      if (id) {
        if (!map[id]) {
          map[id] = { notes: [], latestByCategory: {} };
        }
        map[id].notes.push(note);
      }
    });
    Object.keys(map).forEach((leadId) => {
      map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
      const categoryMap = {};
      map[leadId].notes.forEach((note) => {
        const category = note.Category?.toLowerCase() || "";
        if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
          categoryMap[category] = note;
        }
      });
      map[leadId].latestByCategory = categoryMap;
    });
    return map;
  }, [allNotes]);

  const getFollowUpDates = useCallback((item) => {
    const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
    const categories = leadNotesData.latestByCategory;
    const followUpDates = [];
    if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
      const noteDate = categories["next follow-up"].Category_Details.split('T')[0];
      if (noteDate) followUpDates.push(noteDate);
    }
    if (item.FollowUpDate) {
      const itemDate = item.FollowUpDate.split('T')[0];
      if (itemDate && !followUpDates.includes(itemDate)) {
        followUpDates.push(itemDate);
      }
    }
    return followUpDates;
  }, [notesByLead]);

  const counts = useMemo(() => {
    const total = data.length;
    let todayCount = 0;
    let noFollowUpCount = 0;
    data.forEach(item => {
      const followUpDates = getFollowUpDates(item);
      const hasToday = followUpDates.includes(todayStr);
      const hasNo = followUpDates.length === 0;
      if (hasToday) todayCount++;
      if (hasNo) noFollowUpCount++;
    });
    return { total, today: todayCount, noFollowUp: noFollowUpCount };
  }, [data, getFollowUpDates, todayStr]);

  const updateLeadData = (updatedBooking) => {
    setData((prevData) =>
      prevData.map((lead) =>
        lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
          ? { ...lead, ...updatedBooking }
          : lead
      )
    );
    setFilteredData((prevFilteredData) =>
      prevFilteredData.map((lead) =>
        lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
          ? { ...lead, ...updatedBooking }
          : lead
      )
    );
    if (
      selectedBooking &&
      selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
    ) {
      setSelectedBooking(updatedBooking);
    }
  };

  const refetchNotes = () => {
    fetchAllNotes();
  };

  const formatFollowUpDate = (date) => {
    if (!date) return "N/A";
    return date.replace("T", " ");
  };

  const handleDefaultSort = () => {
    setSearchQuery("");
    setColumnFilters({});
    setIsGlobalSearch(false);
    setCurrentFilter('all');
    setIsDefaultSort(true);
    setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
    fetchLeads();
  };
  const updateUserpreference = async (headers, tabFilter, savedFilters) => {
      try {
        const payload = { 
          Userpreference: { 
            Headers: headers,
            TabFilter: tabFilter,
            SavedFilters: savedFilters
          } 
        };
        await fetch("https://salesjet-10097049716.development.catalystappsail.com/userdata", {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
      } catch (err) {
        console.error("Error updating preferences:", err);
      }
  };

  const savePreferences = useCallback((headers, tabFilter, savedFilters) => {
    const prefs = { Headers: headers, TabFilter: tabFilter, SavedFilters: savedFilters };
    localStorage.setItem("Userpreference", JSON.stringify(prefs));
    updateUserpreference(headers, tabFilter, savedFilters);
  }, [accessToken]);
  
  // const loadPreferences = () => {
  //   try {
  //     const stored = localStorage.getItem("Userpreference");
  //     console.log("Loaded preferences from localStorage:", stored);
  //     let headers = null, tabFilter = 'all', savedFilters = [];
  //     if (stored) {
  //       const parsed = JSON.parse(stored);
  //       headers = parsed.Headers || null;
  //       tabFilter = parsed.TabFilter || 'all';
  //       savedFilters = parsed.SavedFilters || [];
  //     }
  //     if (!headers || !Array.isArray(headers) || headers.length === 0) {
  //       headers = allColumns.slice(0, 7).map((col) => col.label);
  //     }
  //     const keys = headers
  //       .map((label) => {
  //         const col = allColumns.find((c) => c.label === label);
  //         return col ? col.key : null;
  //       })
  //       .filter(Boolean);
  //     setSelectedColumns(keys);
  //     setCurrentFilter(tabFilter);
  //     setSavedFilters(savedFilters);
  //     console.log('Loaded savedFilters:', savedFilters);
  //     savePreferences(headers, tabFilter, savedFilters);
  //   } catch (err) {
  //     console.error(err);
  //     const headers = allColumns.slice(0, 7).map((col) => col.label);
  //     const tabFilter = 'all';
  //     const savedFilters = [];
  //     const prefs = { Headers: headers, TabFilter: tabFilter, SavedFilters: savedFilters };
  //     localStorage.setItem("Userpreference", JSON.stringify(prefs));
  //     savePreferences(headers, tabFilter, savedFilters);
  //     setSelectedColumns(allColumns.slice(0, 7).map((col) => col.key));
  //     setCurrentFilter(tabFilter);
  //     setSavedFilters(savedFilters);
  //   }
  // };
  
  const loadPreferences = () => {
    try {
      const stored = localStorage.getItem("Userpreference");
      // console.log("Loaded preferences from localStorage:", stored);
      let headers = null, tabFilter = 'all', savedFilters = [];
      if (stored) {
        let parsedStr = stored.trim().replace(/\\"/g, '"');
        const parsed = JSON.parse(parsedStr);
        // console.log('parsed:', parsed);
        // console.log('keys:', Object.keys(parsed));
        // console.log('parsed["SavedFilters"]:', parsed['SavedFilters']);
        headers = parsed['Headers'] || null;
        tabFilter = parsed['TabFilter'] || 'all';
        savedFilters = parsed['SavedFilters'] || [];
      }
      if (!headers || !Array.isArray(headers) || headers.length === 0) {
        headers = allColumns.slice(0, 7).map((col) => col.label);
      }
      const keys = headers
        .map((label) => {
          const col = allColumns.find((c) => c.label === label);
          return col ? col.key : null;
        })
        .filter(Boolean);
      setSelectedColumns(keys);
      setCurrentFilter(tabFilter);
      setSavedFilters(savedFilters);
      console.log('Loaded savedFilters:', savedFilters);
      savePreferences(headers, tabFilter, savedFilters);
    } catch (err) {
      console.error(err);
      const headers = allColumns.slice(0, 7).map((col) => col.label);
      const tabFilter = 'all';
      const savedFilters = [];
      const prefs = { Headers: headers, TabFilter: tabFilter, SavedFilters: savedFilters };
      localStorage.setItem("Userpreference", JSON.stringify(prefs));
      savePreferences(headers, tabFilter, savedFilters);
      setSelectedColumns(allColumns.slice(0, 7).map((col) => col.key));
      setCurrentFilter(tabFilter);
      setSavedFilters(savedFilters);
    }
  };

  useEffect(() => {
    if (accessToken) {
      loadPreferences();
    }
  }, [accessToken, savePreferences]);

  useEffect(() => {
    const headers = selectedColumns.map((key) => {
      const col = allColumns.find((c) => c.key === key);
      return col ? col.label : "";
    });
    savePreferences(headers, currentFilter, savedFilters);
  }, [currentFilter, selectedColumns, savedFilters, savePreferences]);

  const handleSaveNewFilter = () => {
    if (!filterName.trim()) return;
    const newFilter = {
      name: filterName.trim(),
      searchQuery,
      columnFilters
    };
    const updatedSavedFilters = [...savedFilters, newFilter];
    setSavedFilters(updatedSavedFilters);
    setFilterName('');
    setShowSaveModal(false);
    // Save will be triggered by useEffect
  };

  const handleApplySavedFilter = (savedFilter) => {
    setSearchQuery(savedFilter.searchQuery || '');
    setColumnFilters(savedFilter.columnFilters || {});
    setCurrentFilter(savedFilter.name);
    setIsGlobalSearch(false);
  };

  const handleDeleteFilter = (name) => {
    const updatedSavedFilters = savedFilters.filter(f => f.name !== name);
    setSavedFilters(updatedSavedFilters);
    if (currentFilter === name) {
      setCurrentFilter('all');
      setSearchQuery('');
      setColumnFilters({});
    }
    // Save will be triggered by useEffect
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          "https://salesjet-10097049716.development.catalystappsail.com/userdata",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error(`Error: ${response.status}`);
        const result = await response.json();
        const userMapping = result.data.reduce((acc, user) => {
          acc[user.userId] = user.pseudoname;
          return acc;
        }, {});
        setUserMap(userMapping);
      } catch (err) {
        console.error("Error fetching user data:", err.message);
      }
    };
    fetchUserData();
  }, [accessToken]);

  const loadTelnyxScripts = () => {
    return new Promise((resolve, reject) => {
      const scripts = [
        { id: 'webrtc-adapter', src: 'https://webrtc.github.io/adapter/adapter-latest.js' },
        { id: 'telnyx-webrtc', src: 'https://unpkg.com/@telnyx/webrtc@2.9.0/lib/bundle.js' }
      ];

      let loadedCount = 0;
      const totalScripts = scripts.length;

      const loadScript = (script) => {
        return new Promise((scriptResolve, scriptReject) => {
          if (document.getElementById(script.id)) {
            scriptResolve(); // Already loaded
            return;
          }

          const scriptElement = document.createElement('script');
          scriptElement.id = script.id;
          scriptElement.src = script.src;
          scriptElement.async = true;
          scriptElement.onload = () => {
            scriptResolve();
          };
          scriptElement.onerror = () => {
            scriptReject(new Error(`Failed to load ${script.src}`));
          };
          document.head.appendChild(scriptElement);
        });
      };

      const loadAll = async () => {
        for (const script of scripts) {
          try {
            await loadScript(script);
            loadedCount++;
          } catch (err) {
            reject(err);
            return;
          }
        }
        if (loadedCount === totalScripts) {
          resolve();
        }
      };

      loadAll();
    });
  };

  const logTelnyx = (msg) => {
    console.log(msg);
  };

  const connectTelnyx = async () => {
    const token = localStorage.getItem('telnyxToken');
    const userStr = localStorage.getItem('user');
    if (!token || !userStr) {
      logTelnyx("Telnyx Token or User data missing in localStorage");
      return;
    }

    const user = JSON.parse(userStr);
    const name = user.firstName;
    if (!name) {
      logTelnyx("Agent firstName missing in user data");
      return;
    }

    try {
      // Load scripts if not already loaded
      await loadTelnyxScripts();

      // Check if library is available after loading
      if (window.TelnyxWebRTC && window.TelnyxWebRTC.TelnyxRTC) {
        const client = new window.TelnyxWebRTC.TelnyxRTC({ login_token: token });

        client.on('telnyx.ready', () => {
          setTelnyxConnected(true);
          logTelnyx(`Connected as ${name}`);
        });

        client.on('telnyx.error', (e) => {
          logTelnyx(`Error: ${e.message}`);
          setTelnyxConnected(false);
        });

        client.on('telnyx.notification', (n) => {
          if (n.call) {
            setCurrentCall(n.call);

            if (n.call.state === 'ringing') {
              logTelnyx("📞 Incoming Call...");
              const incomingNum = n.call.options?.remoteCallerNumber || '';
              setCurrentPhoneNumber(incomingNum);
              setShowDialpad(true);
            }

            if (n.call.state === 'active') {
              logTelnyx("Call Active");
            }

            if (n.call.state === 'destroy') {
              logTelnyx("📴 Call Ended");
              setCurrentCall(null);
              setShowDialpad(false);
              setTelnyxConnected(true); // Re-enable connection
            }
          }
        });

        client.connect();
        setTelnyxClient(client);
      } else {
        throw new Error("TelnyxWebRTC library still not loaded after script injection");
      }
    } catch (e) {
      logTelnyx(`Connection Error: ${e.message}`);
      setTelnyxConnected(false);
    }
  };

  useEffect(() => {
    connectTelnyx();
  }, []);

  const makeTelnyxCall = (destinationNumber, fromNumber) => {
    if (telnyxClient && destinationNumber) {
      const callOptions = {
        destinationNumber: destinationNumber,
        callerNumber: businessNumber, // Use business number
      };
      const call = telnyxClient.newCall(callOptions); // Use newCall as per docs
      setCurrentCall(call);
      logTelnyx(`Calling ${destinationNumber}`);
      return call;
    }
    return null;
  };

  const endTelnyxCall = () => {
    if (currentCall) {
      currentCall.hangup();
      setCurrentCall(null);
    }
  };

  const fetchLeads = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        "https://salesjet-10097049716.development.catalystappsail.com/leadsdata",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const result = await response.json();
      const leads = Array.isArray(result.data) ? result.data : [];
      setData(leads);
      setFilteredData(leads);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching leads:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllNotes = async () => {
    try {
      const response = await fetch(
        "https://salesjet-10097049716.development.catalystappsail.com/allleadnotes",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const result = await response.json();
      setAllNotes(Array.isArray(result.data) ? result.data : []);
    } catch (err) {
      console.error("Error fetching all lead notes:", err.message);
    }
  };

  useEffect(() => {
    if (!isGlobalSearch) {
      fetchLeads();
      fetchAllNotes();
    }
  }, [accessToken, isGlobalSearch]);

  useEffect(() => {
    handleDefaultSort();
  }, []);

  useEffect(() => {
    if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
      prevSelectedLeadId.current = selectedLeadId;
      setIsGlobalSearch(true);
      setColumnFilters({});
      handleGlobalSearch(selectedLeadId.toString());
    }
  }, [selectedLeadId]);

  useEffect(() => {
    if (selectedLeadId && filteredData.length > 0) {
      const matchingLead = filteredData.find(
        (lead) =>
          lead.LeadACVLRecordID &&
          lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
      );
      if (matchingLead) {
        setSelectedBooking(matchingLead);
        setWidth(700);
      } else {
        setSelectedBooking(null);
      }
    } else if (selectedLeadId && filteredData.length === 0) {
      setSelectedBooking(null);
    }
  }, [filteredData, selectedLeadId]);

  useEffect(() => {
    if (isGlobalSearch) {
      return;
    }
    let filtered = [...data];
    const normalizedQuery = searchQuery.toLowerCase().trim();
    if (normalizedQuery === 'today') {
      // Special filter for Move_Date today
      filtered = filtered.filter((item) => 
        item.Move_Date && item.Move_Date.split('T')[0] === todayStr
      );
    } else if (searchQuery.trim()) {
      filtered = filtered.filter((lead) =>
        Object.entries(lead).some(([key, value]) => {
          if (!value) return false;
          const normalizedValue = value
            .toString()
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase();
          return normalizedValue.includes(normalizedQuery.replace(/[^a-zA-Z0-9]/g, ""));
        })
      );
    }
    Object.keys(columnFilters).forEach((key) => {
      const rawFilter = columnFilters[key];
      if (rawFilter) {
        const trimmedRawFilter = rawFilter.trim();
        const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
        if (isNAFilter) {
          filtered = filtered.filter((lead) => {
            const value = lead[key];
            return value === null || value === undefined || value === "" || value === "N/A";
          });
        } else if (normalizedFilter) {
          filtered = filtered.filter((lead) => {
            const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            return value?.includes(normalizedFilter);
          });
        }
      }
    });
    // Apply current filter if it's a default one
    if (defaultFilters.some(f => f.key === currentFilter)) {
      if (currentFilter !== 'all') {
        filtered = filtered.filter(item => {
          const followUpDates = getFollowUpDates(item);
          if (currentFilter === 'today') {
            return followUpDates.includes(todayStr);
          } else if (currentFilter === 'noFollowUp') {
            return followUpDates.length === 0;
          }
          return true;
        });
      }
    }
    setFilteredData(filtered);
  }, [data, searchQuery, columnFilters, isGlobalSearch, currentFilter, getFollowUpDates, todayStr]);

  const handleSearchChange = (query) => {
    setSearchQuery(query);
    setIsGlobalSearch(false);
    setCurrentFilter('all');
  };

  const handleGlobalSearch = async (query) => {
    setLoading(true);
    setIsDefaultSort(false);
    setIsGlobalSearch(true);
    setCurrentFilter('all');
    try {
      const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
      const response = await fetch(
        "https://salesjet-10097049716.development.catalystappsail.com/globalsearch",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ query: normalizedQuery }),
        }
      );
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const result = await response.json();
      const leads = Array.isArray(result.data) ? result.data : [];
      setFilteredData(leads);
      setSearchQuery(query);
      fetchAllNotes();
    } catch (err) {
      console.error("Global search error:", err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (key) => {
    setIsDefaultSort(false);
    setSortConfig((prev) =>
      prev.key === key
        ? {
            key,
            direction: prev.direction === "ascending" ? "descending" : "ascending",
          }
        : { key, direction: "ascending" }
    );
  };

  const handleColumnChange = (event) => {
    const value = event.target.value;
    setSelectedColumns((prev) => {
      let newSelected;
      if (prev.includes(value)) {
        newSelected = prev.filter((col) => col !== value);
      } else {
        newSelected = prev.length < 7 ? [...prev, value] : prev;
      }
      // The save will be handled by useEffect
      return newSelected;
    });
  };

  const handleSaveFilter = () => {
    setShowSaveModal(true);
  };

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (isDefaultSort) {
      // Get current date in EST (America/Toronto)
      const now = new Date();
      const todayStrLocal = now.toLocaleString('en-CA', { 
        timeZone: 'America/Toronto', 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit' 
      }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

      // Custom sorting logic
      sortableData.sort((a, b) => {
        const isUnassignedA = a.Status === null || a.Status === undefined;
        const isUnassignedB = b.Status === null || b.Status === undefined;
        const timeA = a.Received_Date_EST;
        const timeB = b.Received_Date_EST;
        const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
        const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

        // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
        if (isUnassignedA && timeA === todayStrLocal && (!isUnassignedB || timeB !== todayStrLocal)) {
          return -1;
        }
        if (isUnassignedB && timeB === todayStrLocal && (!isUnassignedA || timeA !== todayStrLocal)) {
          return 1;
        }

        // Step 2: Leads with FollowUpDate date as today (EST)
        if (followUpA === todayStrLocal && followUpB !== todayStrLocal) return -1;
        if (followUpB === todayStrLocal && followUpA !== todayStrLocal) return 1;

        // Step 3: Sort by LeadACVLRecordID descending as fallback
        const idA = Number(a.LeadACVLRecordID || 0);
        const idB = Number(b.LeadACVLRecordID || 0);
        return idB - idA;
      });
    } else if (sortConfig.key) {
      sortableData.sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];
        // Handle null or undefined values
        if (aVal === undefined || aVal === null) return 1;
        if (bVal === undefined || bVal === null) return -1;
        // Handle LeadACVLRecordID specifically as a number
        if (sortConfig.key === "LeadACVLRecordID") {
          aVal = Number(aVal);
          bVal = Number(bVal);
          return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
        }
        // Handle date fields
        const isDateField = [
          "Move_Date",
          "Received_Date_EST",
          "Received_Time_IST",
          "FollowUpDate",
        ].includes(sortConfig.key);
        if (isDateField) {
          const dateA = new Date(aVal);
          const dateB = new Date(bVal);
          return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
        }
        // Handle string fields
        if (typeof aVal === "string" && typeof bVal === "string") {
          return sortConfig.direction === "ascending"
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(bVal);
        }
        // Handle numeric fields
        return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, isDefaultSort]);

  const startResizing = (e) => {
    isResizing.current = true;
    document.addEventListener("mousemove", resize);
    document.addEventListener("mouseup", stopResizing);
  };

  const resize = (e) => {
    if (!isResizing.current) return;
    const minWidth = 500;
    const maxWidth = window.innerWidth * 0.7;
    let newWidth = window.innerWidth - e.clientX;
    if (newWidth >= minWidth && newWidth <= maxWidth) {
      setWidth(newWidth);
    }
  };

  const stopResizing = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", resize);
    document.removeEventListener("mouseup", stopResizing);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowFilter(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    const rect = dialpadRef.current.getBoundingClientRect();
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setDialpadPosition({
      x: e.clientX - dragOffset.x,
      y: e.clientY - dragOffset.y
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, dragOffset]);

  const openDialpad = (phone = '') => {
    setCurrentPhoneNumber(phone);
    setShowDialpad(true);
  };

  const getFilterCount = (filterKey) => {
    if (filterKey === 'all') return counts.total;
    if (filterKey === 'today') return counts.today;
    if (filterKey === 'noFollowUp') return counts.noFollowUp;
    // For saved filters, compute on the fly if needed, but skip for now
    return null;
  };

  const getFilterStyle = (filterKey) => {
    const defFilter = defaultFilters.find(f => f.key === filterKey);
    if (defFilter) {
      return {
        background: currentFilter === filterKey ? defFilter.color : 'transparent',
        color: currentFilter === filterKey ? 'white' : defFilter.color,
        border: `1px solid ${defFilter.color}`,
      };
    }
    // For saved
    return {
      background: currentFilter === filterKey ? '#6c757d' : 'transparent',
      color: currentFilter === filterKey ? 'white' : '#6c757d',
      border: '1px solid #6c757d',
    };
  };

  const computeSavedFilterCount = useCallback((saved) => {
    let filtered = [...data];
    const normalizedQuery = saved.searchQuery?.toLowerCase().trim() || '';
    if (normalizedQuery === 'today') {
      filtered = filtered.filter((item) => 
        item.Move_Date && item.Move_Date.split('T')[0] === todayStr
      );
    } else if (saved.searchQuery?.trim()) {
      filtered = filtered.filter((lead) =>
        Object.entries(lead).some(([key, value]) => {
          if (!value) return false;
          const normalizedValue = value
            .toString()
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase();
          return normalizedValue.includes(normalizedQuery.replace(/[^a-zA-Z0-9]/g, ""));
        })
      );
    }
    Object.keys(saved.columnFilters || {}).forEach((key) => {
      const rawFilter = saved.columnFilters[key];
      if (rawFilter) {
        const trimmedRawFilter = rawFilter.trim();
        const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
        if (isNAFilter) {
          filtered = filtered.filter((lead) => {
            const value = lead[key];
            return value === null || value === undefined || value === "" || value === "N/A";
          });
        } else if (normalizedFilter) {
          filtered = filtered.filter((lead) => {
            const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            return value?.includes(normalizedFilter);
          });
        }
      }
    });
    return filtered.length;
  }, [data, todayStr]);

  const savedFilterCounts = useMemo(() => 
    (savedFilters || []).map(saved => computeSavedFilterCount(saved)), 
    [savedFilters, computeSavedFilterCount]
  );

  return (
    <div style={{ position: 'relative' }}>
      <>
        <TimelineComponent
          userDetails={userDetails}
          accessToken={accessToken}
          onSearchChange={handleSearchChange}
          onGlobalSearch={handleGlobalSearch}
          connectionStatus={connectionStatus}
          telnyxConnected={telnyxConnected}
          onShowReports={() => setShowReports(true)}
          onListView={() => setShowReports(false)}
          userStatus={userStatus}
          setUserStatus={setUserStatus}
        />
        <div className="filter-bar" style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#f8f9fa',
          borderBottom: '1px solid #dee2e6',
          fontSize: '14px',
          fontWeight: '500',
          flexWrap: 'wrap',
          gap: '8px'
        }}>
          {defaultFilters.map((filter) => {
            const count = getFilterCount(filter.key);
            return (
              <button 
                key={filter.key}
                onClick={() => setCurrentFilter(filter.key)} 
                className={currentFilter === filter.key ? 'active' : ''} 
                style={{
                  ...getFilterStyle(filter.key),
                  display: 'flex',
                  alignItems: 'center',
                  width: '120px',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  marginRight: '4px',
                  justifyContent: 'space-between'
                }}
                title={`${filter.label}${count !== null ? ` (${count})` : ''}`}
              >
                <span 
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: 1
                  }}
                >
                  {filter.label}
                </span>
                {count !== null && (
                  <span 
                    style={{
                      marginLeft: '4px',
                      whiteSpace: 'nowrap',
                      fontWeight: 'bold'
                    }}
                  >
                    ({count})
                  </span>
                )}
              </button>
            );
          })}
          {(savedFilters || []).map((saved, index) => {
            const count = savedFilterCounts[index];
            return (
              <div key={saved.name} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <button 
                  onClick={() => handleApplySavedFilter(saved)} 
                  className={currentFilter === saved.name ? 'active' : ''} 
                  style={{
                    ...getFilterStyle(saved.name),
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '120px',
                    width: 'auto',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    justifyContent: 'space-between'
                  }}
                  title={`${saved.name}${count !== null ? ` (${count})` : ''}`}
                >
                  <span 
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      flex: 1
                    }}
                  >
                    {saved.name}
                  </span>
                  {count !== null && (
                    <span 
                      style={{
                        marginLeft: '4px',
                        whiteSpace: 'nowrap',
                        fontWeight: 'bold'
                      }}
                    >
                      ({count})
                    </span>
                  )}
                </button>
                <button 
                  onClick={() => handleDeleteFilter(saved.name)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '2px',
                    color: '#dc3545',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  title="Delete filter"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            );
          })}
          {/* {(savedFilters || []).map((saved, index) => {
            const count = savedFilterCounts[index];
            return (
              <div key={saved.name} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <button 
                  onClick={() => handleApplySavedFilter(saved)} 
                  className={currentFilter === saved.name ? 'active' : ''} 
                  style={{
                    ...getFilterStyle(saved.name),
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '120px',
                    width: 'auto',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    justifyContent: 'space-between',
                    whiteSpace: 'nowrap'
                  }}
                  title={`${saved.name}${count !== null ? ` (${count})` : ''}`}
                >
                  <span 
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      flex: 1
                    }}
                  >
                    {saved.name}
                  </span>
                  {count !== null && (
                    <span 
                      style={{
                        marginLeft: '4px',
                        whiteSpace: 'nowrap',
                        fontWeight: 'bold'
                      }}
                    >
                      ({count})
                    </span>
                  )}
                </button>
                <button 
                  onClick={() => handleDeleteFilter(saved.name)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '2px',
                    color: '#dc3545',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  title="Delete filter"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            );
          })} */}
          <button 
            onClick={() => setShowAdvancedFilter(true)}
            style={{
              background: 'transparent',
              color: '#6c757d',
              border: '1px solid #6c757d',
              padding: '4px 8px',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            + Add more filters
          </button>
        </div>
      </>     
      {showSaveModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1002
        }}>
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
          }}>
            <label>Filter Name:</label>
            <input
              type="text"
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}
              style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            />
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={handleSaveNewFilter} style={{ padding: '8px 16px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}>Save</button>
              <button onClick={() => { setShowSaveModal(false); setFilterName(''); }} style={{ padding: '8px 16px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px' }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      {showReports && (
        <>
          <Reports />
        </>
      )}
      {!showReports && (
        <div className="table-container">
          <div
            className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
            style={{ flex: selectedBooking ? "1" : "2" }}
          >
            <div>
              <div className="bookings-header-my">
                <span
                  className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
                  onClick={() => handleSort("LeadACVLRecordID")}
                  style={{ cursor: "pointer" }}
                >
                  ACVL LeadID
                  {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
                    (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
                </span>
                {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
                  (colKey) => {
                    const column = allColumns.find((c) => c.key === colKey);
                    const isSorted = sortConfig.key === colKey;
                    return column ? (
                      <span
                        key={colKey}
                        className="sortable-header"
                        onClick={() => handleSort(colKey)}
                        style={{ cursor: "pointer" }}
                      >
                        {column.label}
                        {!isDefaultSort && isSorted &&
                          (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
                      </span>
                    ) : null;
                  }
                )}
                <span2>
                  <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                    <div>
                      <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
                    </div>
                    <div>
                      <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
                    </div>
                    <div>
                      <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
                    </div>
                    <div>
                      <Search
                        className="filter-icon"
                        onClick={() => setShowAdvancedFilter((prev) => !prev)}
                        title="Advanced column search"
                      />
                    </div>
                  </div>
                </span2>
                {showFilter && (
                  <div className="filter-dropdown" ref={filterRef}>
                    {allColumns.map((col) => (
                      <label key={col.key}>
                        <input
                          type="checkbox"
                          value={col.key}
                          checked={selectedColumns.includes(col.key)}
                          onChange={handleColumnChange}
                          disabled={
                            !selectedColumns.includes(col.key) && selectedColumns.length >= 7
                          }
                        />
                        {col.label}
                      </label>
                    ))}
                  </div>
                )}
              </div>
              {showAdvancedFilter && (
                <div className="column-filter-row">
                  <span className="filter-input">
                    <input
                      placeholder="Lead ID"
                      value={columnFilters["LeadACVLRecordID"] || ""}
                      onChange={(e) =>
                        setColumnFilters({
                          ...columnFilters,
                          LeadACVLRecordID: e.target.value,
                        })
                      }
                    />
                  </span>
                  {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
                    (colKey) => (
                      <span key={colKey} className="filter-input">
                        <input
                          placeholder={
                            allColumns.find((col) => col.key === colKey)?.label || colKey
                          }
                          value={columnFilters[colKey] || ""}
                          onChange={(e) =>
                            setColumnFilters({
                              ...columnFilters,
                              [colKey]: e.target.value,
                            })
                          }
                        />
                      </span>
                    )
                  )}
                  <span className="filter-input">
                  <button 
                    onClick={handleSaveFilter}
                    style={{
                      background: '#17a2b8',
                      color: 'white',
                      border: '1px solid #17a2b8',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      marginLeft: 'auto',
                      whiteSpace: 'nowrap',
                      float: 'right',
                      alignSelf: 'center'
                    }}
                  >
                    Save Filter
                  </button>
                  </span>
                </div>
              )}
              {loading && <p>Loading...</p>}
              {error && <p className="error">{error}</p>}
              {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
              {!loading &&
                !error &&
                sortedData.map((item, index) => {
                  const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
                  const categories = leadNotesData.latestByCategory;
                  let flags = [];
                  const now = new Date();
                  const todayStrLocal = now.toLocaleString('en-CA', { 
                    timeZone: 'America/Toronto', 
                    year: 'numeric', 
                    month: '2-digit', 
                    day: '2-digit' 
                  }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
                  const isUnassignedToday =
                    (item.Status === null || item.Status === undefined) &&
                    item.Received_Date_EST &&
                    item.Received_Date_EST.split(' ')[0] === todayStrLocal;
                  const isUnassignedall =
                    (item.Status === null || item.Status === undefined) &&
                    item.Received_Date_EST &&
                    item.Received_Date_EST.split(' ')[0] !== todayStrLocal;
                  let isTodayFollowUp = false;

                  // Collect and process follow-up dates
                  const followUpDates = [];
                  
                  // Add follow-up date from notes (next follow-up category)
                  if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
                    const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
                    if (noteDate) {
                      followUpDates.push(noteDate);
                    }
                  }

                  // Add follow-up date from item.FollowUpDate
                  if (item.FollowUpDate) {
                    const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
                    if (itemDate && !followUpDates.includes(itemDate)) {
                      followUpDates.push(itemDate);
                    }
                  }

                  // Select the most relevant follow-up date
                  let selectedFollowUpDate = null;
                  if (followUpDates.length > 0) {
                    // Prioritize: today's date, then past date, then future date
                    const today = new Date(todayStrLocal);
                    selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
                      const followUpDate = new Date(dateStr);
                      if (!selected) return dateStr;
                      const selectedDate = new Date(selected);
                      if (dateStr === todayStrLocal) return dateStr; // Prioritize today's date
                      if (selected === todayStrLocal) return selected;
                      if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
                      if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
                      return selected; // Keep first date if no priority
                    }, null);

                    if (selectedFollowUpDate) {
                      const followUpDate = new Date(selectedFollowUpDate);
                      isTodayFollowUp = selectedFollowUpDate === todayStrLocal;
                      let color;
                      if (followUpDate < today && !isTodayFollowUp) {
                        color = "red"; // Past date
                      } else if (isTodayFollowUp) {
                        color = "green"; // Today
                      } else {
                        color = "gray"; // Future date
                      }
                      flags.push({ 
                        icon: Clock, 
                        color, 
                        title: `Follow-Up: ${selectedFollowUpDate}` 
                      });
                    }
                  }

                  // Process other categories
                  Object.values(categories).forEach((note) => {
                    if (note && note.Category?.toLowerCase() !== "next follow-up") {
                      const category = note.Category?.toLowerCase() || "";
                      const categoryDetails = note.Category_Details?.toLowerCase() || "";
                      if (category === "connection status") {
                        if (categoryDetails === "connected") {
                          flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
                        } else if (categoryDetails === "not connected") {
                          flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
                        }
                      } else if (category === "prospective") {
                        if (categoryDetails === "hot") {
                          flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
                        } else if (categoryDetails === "warm") {
                          flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
                        } else if (categoryDetails === "cold") {
                          flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
                        }
                      }
                    }
                  });

                  // Process Lead_Priority for left side icon
                  let priorityFlag = null;
                  if (item.Lead_Priority) {
                    const priority = item.Lead_Priority.toString().toLowerCase().trim();
                    let color, title;
                    if (priority === "high") {
                      color = "red";
                      title = "High";
                    } else if (priority === "medium") {
                      color = "purple";
                      title = "Medium";
                    } else if (priority === "low") {
                      color = "green";
                      title = "Low";
                    }
                    if (color && title) {
                      priorityFlag = { icon: Circle, color, title };
                    }
                  }

                  // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
                  const orderedFlags = new Array(5).fill(null);
                  if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
                    orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
                  }
                  if (item.Lead_Source_Status?.toLowerCase() === "return") {
                    if (item.Return_Outcome?.toLowerCase() === "approved") {
                      orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
                    } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
                      orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
                    } else {
                      orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
                    }
                  }
                  const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
                  if (prospectiveFlag) {
                    orderedFlags[2] = prospectiveFlag;
                  }
                  const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
                  if (connectionFlag) {
                    orderedFlags[3] = connectionFlag;
                  }
                  const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
                  if (followUpFlag) {
                    orderedFlags[4] = followUpFlag;
                  }

                  return (
                    <div
                      key={index}
                      className={`booking-item-my ${
                        selectedBooking === item ? "active-booking" : ""
                      } ${
                        item.Duplicate_Lead_Details &&
                        Object.keys(item.Duplicate_Lead_Details).length > 0
                          ? "duplicate-item"
                          : ""
                      } ${
                        item.Lead_Source_Status?.toLowerCase() === "return"
                          ? "returned-item"
                          : ""
                      } ${isTodayFollowUp ? "follow-up-today" : ""}`}
                      onClick={() => {
                        if (!selectedBooking) setWidth(700);
                        setSelectedBooking(item);
                      }}
                      style={{
                        ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
                        ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
                        ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
                        ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
                      }}
                    >
                      <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
                        {priorityFlag && (
                          <>
                            <priorityFlag.icon
                              className="icon"
                              style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
                              fill={priorityFlag.color}
                              title={priorityFlag.title}
                            />
                            <div className="custom-tooltip1">
                              {priorityFlag.title}
                            </div>
                          </>
                        )}
                      </div>
                      <span1>{item.LeadACVLRecordID || "N/A"}</span1>
                      {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
                        (colKey) => (
                          <span1 key={colKey}>
                            {colKey === "AssignedUserID"
                              ? userMap[item.AssignedUserID] || "N/A"
                              : colKey === "FollowUpDate"
                              ? formatFollowUpDate(item[colKey])
                              : item[colKey] || "N/A"}
                          </span1>
                        )
                      )}
                      <span2 style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        width: "120px",
                      }}>
                        {orderedFlags.map((flag, idx) => (
                          <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
                            {flag && (
                              <>
                                <flag.icon
                                  className="icon"
                                  style={{ color: flag.color, width: "16px", height: "16px" }}
                                  title={flag.title}
                                />
                                <div className="custom-tooltip">
                                  {flag.title}
                                </div>
                              </>
                            )}
                          </div>
                        ))}
                      </span2>
                    </div>
                  );
                })}
            </div>
          </div>
          {selectedBooking && (
            <div className="lead-details-container" style={{ width: `${width}px` }}>
              <div className="resize-handle" onMouseDown={startResizing}></div>
              <LeadDetails
                key={selectedBooking.LeadACVLRecordID}
                booking={selectedBooking}
                notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
                onClose={() => setSelectedBooking(null)}
                userDetails={userDetails}
                accessToken={accessToken}
                userMap={userMap}
                updateLeadData={updateLeadData}
                refetchNotes={refetchNotes}
                onOpenDialpad={openDialpad}
                telnyxClient={telnyxClient}
                currentCall={currentCall}
                onMakeCall={makeTelnyxCall}
                onEndCall={endTelnyxCall}
                telnyxConnected={telnyxConnected}
                businessNumber={businessNumber}
              />
            </div>
          )}
        </div>
      )}

      <button 
        onClick={() => openDialpad('')} 
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '80px',
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          backgroundColor: '#10b981', // Enhanced green
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          cursor: 'pointer',
          zIndex: 999,
          transition: 'all 0.2s ease'
        }}
        title="Open Dialpad"
      >
        <Phone size={24} color="white" />
      </button>

      {showDialpad && !currentCall && (
        <>
          <div 
            style={{ 
              position: 'fixed', 
              top: 0, 
              left: 0, 
              width: '100%', 
              height: '100%', 
              backgroundColor: 'rgba(0,0,0,0.5)', 
              zIndex: 1000 
            }} 
            onClick={() => setShowDialpad(false)}
          />
          <div 
            ref={dialpadRef}
            style={{ 
              position: 'fixed', 
              left: `${dialpadPosition.x}px`, 
              top: `${dialpadPosition.y}px`, 
              background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', // Match dialpad gradient
              padding: '2px',
              borderRadius: '10px', 
              zIndex: 1001,
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
            }} 
            onClick={(e) => e.stopPropagation()}
          >
            <div 
              style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '10px',
                cursor: 'move',
                padding: '5px 0'
              }} 
              onMouseDown={handleMouseDown}
            >
            </div>
            <Dialpad
              phoneNumber={currentPhoneNumber} 
              onClose={() => setShowDialpad(false)}
              telnyxClient={telnyxClient}
              currentCall={currentCall}
              onEndCall={endTelnyxCall}
              telnyxConnected={telnyxConnected}
              businessNumber={businessNumber}
              setUserStatus={setUserStatus}
              userStatus={userStatus}
            />
          </div>
        </>
      )}

      {currentCall && (
        <Dialpad
          phoneNumber={currentPhoneNumber} 
          onClose={endTelnyxCall}
          telnyxClient={telnyxClient}
          currentCall={currentCall}
          onEndCall={endTelnyxCall}
          telnyxConnected={telnyxConnected}
          businessNumber={businessNumber}
          userStatus={userStatus}
          setUserStatus={setUserStatus}
        />
      )}

      {/* Hidden remote audio element for Telnyx - Single instance to avoid duplication/timing issues */}
      <audio id="remoteAudio" autoPlay style={{ display: 'none' }} />
    </div>
  );
};

export default Homepage;